import { jsx as u, jsxs as M, Fragment as Qe } from "react/jsx-runtime";
import * as T from "react";
import zn, { useState as V, useEffect as G, useCallback as Re, useRef as H, Children as vi, isValidElement as wt, useLayoutEffect as Vn, forwardRef as Zs } from "react";
import * as Bn from "react-dom";
import Hn from "video.js";
function Ks(e) {
  var t, i, s = "";
  if (typeof e == "string" || typeof e == "number") s += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var n = e.length;
    for (t = 0; t < n; t++) e[t] && (i = Ks(e[t])) && (s && (s += " "), s += i);
  } else for (i in e) e[i] && (s && (s += " "), s += i);
  return s;
}
function O() {
  for (var e, t, i = 0, s = "", n = arguments.length; i < n; i++) (e = arguments[i]) && (t = Ks(e)) && (s && (s += " "), s += t);
  return s;
}
const Qs = (e = !1) => {
  const [t, i] = V(() => typeof window > "u" || e ? "" : window.location.hash || ""), s = (n) => {
    if (typeof window > "u") {
      console.warn("setHashHandler called in a non-browser environment. Hash will not be set.");
      return;
    }
    if (n === "" || n === "#") {
      const o = window.location.pathname + window.location.search;
      history.replaceState(null, "", o), i("");
      return;
    }
    const a = n.startsWith("#") ? n : `#${n}`;
    history.replaceState(null, "", a), i(a);
  };
  return G(() => {
    e && i(window.location.hash);
  }, []), [t, s];
}, Js = (e) => ({ scrollToItem: Re(
  (i) => {
    var s;
    i !== null && ((s = e == null ? void 0 : e.current) != null && s[i]) && e.current[i].scrollIntoView({ behavior: "smooth", inline: "center", block: "start" });
  },
  [e]
) }), Fn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { fillRule: "evenodd", d: "M12 2.586 21.414 12 12 21.414 2.586 12 12 2.586ZM5.414 12 12 18.586 18.586 12 12 5.414 5.414 12Z", clipRule: "evenodd" })), Gn = (e) => /* @__PURE__ */ T.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ T.createElement("circle", { cx: 12, cy: 12, r: 12 }), /* @__PURE__ */ T.createElement("path", { d: "M16.8 9.21285L14.0129 12L16.8 14.787L14.787 16.8L12 14.0129L9.21285 16.8L7.19995 14.787L9.98705 12L7.19995 9.21285L9.21285 7.19995L12 9.98705L14.787 7.19995L16.8 9.21285Z", fill: "white" })), qn = (e) => /* @__PURE__ */ T.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ T.createElement("circle", { cx: 12, cy: 12, r: 12 }), /* @__PURE__ */ T.createElement("path", { d: "M10.6788 17.16L17.3577 6.83997H14.9857L10.221 14.1846L8.82701 11.6046H6.64233L10.1586 17.16H10.6788Z", fill: "white" })), jn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M10.8 2.8v14.6L5.5 12l-1.4 1.4 7.7 7.7 7.7-7.7-1.4-1.4-5.3 5.3V2.8h-2z" })), Un = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M21 11H6.4l5.3-5.3-1.4-1.4L2.6 12l7.7 7.7 1.4-1.4L6.4 13H21v-2z" })), Wn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M22 8L12 18 2 8" })), Yn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M16 22L6 12 16 2" })), Xn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M16.6 12L7.3 2.7l1.4-1.4 10 10 .7.7-.7.7-10 10-1.4-1.4 9.3-9.3z", clipRule: "evenodd" })), Zn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M2 16L12 6l10 10" })), Kn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M2.6 13h14.6l-5.3 5.3 1.4 1.4L21 12l-7.7-7.7-1.4 1.4 5.3 5.3H2.6v2z" })), Qn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M12.8 21.2V6.6L18 12l1.4-1.4-7.7-7.7L4 10.5l1.4 1.4 5.3-5.3v14.6h2z" })), Jn = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { fillRule: "evenodd", d: "M2 2a1 1 0 00-1 1v15c0 .6.4 1 1 1h7a2 2 0 012 2 1 1 0 102 0 2 2 0 012-2h7c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1h-6a5 5 0 00-4 2 5 5 0 00-4-2H2zm11 15.5a4 4 0 012-.5h6V4h-5a3 3 0 00-3 3v10.5zm-2 0V7a3 3 0 00-3-3H3v13h6a4 4 0 012 .5z", clipRule: "evenodd" })), er = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M20 3h-1V1h-2v2H7V1H5v2H4a2 2 0 00-2 2v16c0 1.1.9 2 2 2h16a2 2 0 002-2V5a2 2 0 00-2-2zm0 18H4V10h16v11zm0-13H4V5h16v3z" })), tr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M20.5 6.4l-11 11L8.1 16l-4.6-4.6L4.9 10l4.6 4.6L19.1 5l1.4 1.4z", clipRule: "evenodd" })), ir = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M12 15.7l6-6-1.4-1.4-4.6 4.6-4.6-4.6L6 9.7l6 6z" })), sr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M8.3 12l6 6 1.4-1.4-4.6-4.6 4.6-4.6L14.3 6l-6 6z" })), nr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M15.7 12l-6-6-1.4 1.4 4.6 4.6-4.6 4.6L9.7 18l6-6z" })), rr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M12 8.3l-6 6 1.4 1.4 4.6-4.6 4.6 4.6 1.4-1.4-6-6z" })), ar = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M12 2a10 10 0 100 20 10 10 0 000-20z" })), or = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M17.6 5L12 10.6 6.4 5 5 6.4l5.6 5.6L5 17.6 6.4 19l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6L19 6.4 17.6 5z" })), lr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M0 0h20v20H0z" })), cr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M4 4v10h10" })), dr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "m18.58 2.6 2.83 2.84a2 2 0 0 1 0 2.83l-7.44 7.44a2 2 0 0 1-2.83 0l-1.42-1.42 1.4-1.42 1.43 1.42 7.44-7.44-2.82-2.83-2.9 2.9-1.42-1.42 2.9-2.9a2 2 0 0 1 2.83 0ZM5.39 21.46l-2.83-2.82a2 2 0 0 1 0-2.83l7.48-7.48a2 2 0 0 1 2.83 0l1.42 1.42-1.41 1.41-1.42-1.42-7.48 7.48 2.82 2.83 2.9-2.9 1.42 1.41-2.9 2.9a2 2 0 0 1-2.83 0Z", clipRule: "evenodd" })), ur = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M20 5.4L18.6 4 12 10.6 5.4 4 4 5.4l6.6 6.6L4 18.6 5.4 20l6.6-6.6 6.6 6.6 1.4-1.4-6.6-6.6L20 5.4z", clipRule: "evenodd" })), fr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 80 80", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "m39.54 21.61.46-.01a9.1 9.1 0 0 1 9.12 8.57l.01.46v.34a9.09 9.09 0 0 1-8.67 9.02L40 40a9.1 9.1 0 0 1-9.14-9.03v-.34a9.09 9.09 0 0 1 8.68-9.02Zm.98-4.61H40a13.72 13.72 0 0 0-13.8 13.63v.34A13.7 13.7 0 0 0 39.48 44.6H40a13.72 13.72 0 0 0 13.8-13.13v-.85A13.7 13.7 0 0 0 40.52 17Zm17.33 45.5H63l-4.36-8.21a9.27 9.27 0 0 0-8.23-4.79H29.6a9.27 9.27 0 0 0-8.23 4.79L17 62.5h5.15l3.33-6.27a4.63 4.63 0 0 1 4.11-2.4h20.82a4.6 4.6 0 0 1 4.1 2.4l3.34 6.27Z", clipRule: "evenodd" })), pr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M19.4 7.5h3.1V6h-3.1A2.3 2.3 0 0015 6H9.8V3.7h-6V6H1.5v1.5h2.3v2.3h6V7.5H15a2.3 2.3 0 001.4 1.4v5.5a3 3 0 00-2.1 2.1H1.5V18h12.9a3 3 0 005.7 0h2.4v-1.5h-2.4a3 3 0 00-2.1-2.1V8.9a2.3 2.3 0 001.4-1.4zm-11.1.8h-3v-3h3v3zm10.4 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" })), hr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M19 9h-4V3H9v6H5l7 7 7-7zm-8 2V5h2v6h1.2L12 13.2 9.8 11H11zm-6 7h14v2H5v-2z" })), mr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M7.2 9.5h9.6L12 14.3 7.2 9.5zm-.4-.4s0 0 0 0h0z" })), gr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { fillRule: "evenodd", d: "M12 22a10 10 0 100-20 10 10 0 000 20zm0-2a8 8 0 100-16 8 8 0 000 16z", clipRule: "evenodd" })), _r = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M22 6a2 2 0 00-2-2H4a2 2 0 00-2 2v12c0 1.1.9 2 2 2h16a2 2 0 002-2V6zm-2 0l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z" })), vr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M10 6v2H5v11h11v-5h2v6a1 1 0 01-1 1H4a1 1 0 01-1-1V7a1 1 0 011-1h6zm11-3v8h-2V6.4l-7.8 7.8-1.4-1.4L17.6 5H13V3h8z" })), wr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M10.02 20L10 13H7v-3h3V8c0-2.7 1.67-4 4.08-4 1.15 0 2.14.09 2.43.12v2.83h-1.67c-1.3 0-1.56.62-1.56 1.53V10H17l-1 3h-2.72v7h-3.26z" })), br = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M22.6 11l-3-2.7V4.2L16.2.7H6.9v6H3.5A1.1 1.1 0 002.4 8V22a1.1 1.1 0 001.1 1.1H23V11.8a1.1 1.1 0 00-.4-.8zM7 21.8h-3V8.2h3v13.6zM15 2.1h.5L18 4.8v.5h-3v-3zm-6.7 0h5.2v4.5h4.5v3.4H8.4V2.3zm13.1 19.6H8.4V11.6h11.2v-1.3l2 1.7v9.8z" }), /* @__PURE__ */ T.createElement("path", { d: "M10.9 16.1h1.5v1.5h-1.5v-1.5zM13.9 16.1h1.5v1.5h-1.5v-1.5zM10.9 19.1h1.5v1.5h-1.5v-1.5zM13.9 19.1h1.5v1.5h-1.5v-1.5zM16.9 16.1h1.5v1.5h-1.5v-1.5zM16.9 19.1h1.5v1.5h-1.5v-1.5zM10.9 13.1h7.5v1.5h-7.5v-1.5z" })), yr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M4 1H3v22h18V6.6l-.3-.3-5-5-.3-.3H4zm1 20V3h9v5h5v13H5zM17.6 6L16 4.4V6h1.6zM11 8v6.7l-2.3-2.1L7.3 14l4 3.7.7.7.7-.7 4-3.7-1.4-1.4-2.3 2.1V8h-2z", clipRule: "evenodd" })), Er = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { fillRule: "evenodd", d: "M4 1H3v22h18V6.6l-.3-.3-5-5-.3-.3H4Zm1 20V3h9v5h5v13H5ZM17.6 6 16 4.4V6h1.6Z", clipRule: "evenodd" })), xr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { fillRule: "evenodd", d: "M14.126 9H3V7h11.126A4.002 4.002 0 0 1 22 8a4 4 0 0 1-7.874 1ZM16 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm-6.126 7H21v2H9.874A4.002 4.002 0 0 1 2 16a4 4 0 0 1 7.874-1ZM8 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z", clipRule: "evenodd" })), Sr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M12 2a10 10 0 100 20 10 10 0 000-20zm8 9h-2.8c-.2-2.2-.8-4.3-1.8-6.2a8 8 0 014.5 6.2zm-7.5-7a13 13 0 012.7 7H9c.2-2.6 1-5 2.5-7h1zm-3.8.7c-1 2-1.6 4-1.7 6.3H4a8 8 0 014.7-6.3zM4 13h3c0 2.4.6 4.5 1.5 6.2A8 8 0 014.1 13zm7.3 7A12 12 0 019 13h6.2c-.3 2.8-1.2 5.2-2.6 7h-1.2zm4-.8c1-1.8 1.6-3.9 1.8-6.2h2.7a8 8 0 01-4.4 6.2z" })), Tr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M12.22 3a9.23 9.23 0 0 0-8.23 4.97 8.71 8.71 0 0 0 0 8.05A9.23 9.23 0 0 0 12.22 21c2.53 0 4.6-.82 6.08-2.17a8.68 8.68 0 0 0 2.7-6.6c0-.3-.01-.6-.04-.9h-7.74v1.76h5.73l-.24 1.2a5.64 5.64 0 0 1-2.48 3.62 7.26 7.26 0 0 1-4.01 1.13A7.09 7.09 0 0 1 5.16 12a7.09 7.09 0 0 1 7.05-7.04c1.42 0 2.74.39 3.86 1.16l1.48-1.45A8.93 8.93 0 0 0 12.22 3ZM2.2 7.06A11.23 11.23 0 0 1 12.2 1a10.9 10.9 0 0 1 7.51 2.87l.78.71-.75.74-2.92 2.85-.68.67-.7-.65a4.61 4.61 0 0 0-3.23-1.23A5.09 5.09 0 0 0 7.16 12c0 .56.1 1.08.27 1.57v.02a5.09 5.09 0 0 0 4.79 3.45c1.2 0 2.17-.31 2.91-.8.48-.31.86-.7 1.14-1.15h-5.05V9.33h11.46l.14.84c.11.65.18 1.34.18 2.05 0 3.3-1.2 6.14-3.36 8.1A10.85 10.85 0 0 1 12.22 23c-4.38 0-8.17-2.47-10.01-6.06a10.71 10.71 0 0 1 0-9.88Z", clipRule: "evenodd" })), Nr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M11 7h2v2h-2V7zm0 4h2v6h-2v-6zm1-9a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16 8 8 0 010 16z" })), kr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M12 5.44c2.14 0 2.39.01 3.23.05.51 0 1.01.1 1.49.27.35.13.66.34.92.6.26.26.47.58.6.92.17.48.27.98.27 1.49.04.84.05 1.1.05 3.23s0 2.4-.05 3.23c0 .51-.1 1.01-.27 1.49a2.64 2.64 0 01-1.52 1.52c-.48.17-.98.27-1.48.27-.85.04-1.1.05-3.24.05-2.13 0-2.39 0-3.23-.05-.5 0-1.01-.1-1.49-.27a2.47 2.47 0 01-.92-.6 2.47 2.47 0 01-.6-.92 4.42 4.42 0 01-.27-1.49c-.04-.84-.05-1.1-.05-3.23s.01-2.39.05-3.23c0-.51.1-1.01.27-1.49.13-.35.34-.66.6-.92.26-.26.58-.47.92-.6.48-.17.98-.27 1.49-.27.84-.04 1.1-.05 3.23-.05zM12 4c-2.17 0-2.45 0-3.3.05-.66.01-1.32.14-1.94.37a3.9 3.9 0 00-1.42.92c-.4.4-.72.89-.92 1.42a5.87 5.87 0 00-.37 1.94C4 9.56 4 9.83 4 12s0 2.45.05 3.3c.01.66.14 1.32.37 1.94.2.53.52 1.02.92 1.42.4.4.89.72 1.42.92.62.23 1.28.36 1.94.37.86.04 1.13.05 3.3.05s2.45 0 3.3-.05a5.87 5.87 0 001.94-.37 4.1 4.1 0 002.34-2.34c.24-.62.36-1.28.37-1.94.04-.86.05-1.13.05-3.3 0-2.18 0-2.45-.05-3.3a5.87 5.87 0 00-.37-1.94 3.9 3.9 0 00-.92-1.42 3.9 3.9 0 00-1.42-.92 5.87 5.87 0 00-1.94-.37C14.44 4 14.17 4 12 4zm0 3.9a4.1 4.1 0 100 8.2 4.1 4.1 0 000-8.2zm0 6.77a2.67 2.67 0 110-5.34 2.67 2.67 0 010 5.34zm5.23-6.94a.96.96 0 11-1.92 0 .96.96 0 011.92 0z", clipRule: "evenodd" })), Ar = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M19.3 4H4.7c-.4 0-.7.3-.7.7v14.7c0 .3.3.6.7.6h14.7c.4 0 .7-.3.7-.7V4.7c-.1-.4-.4-.7-.8-.7zM8.7 17.6H6.4V10h2.4v7.6h-.1zM7.6 9c-.8 0-1.4-.7-1.4-1.4 0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4-.1.7-.7 1.4-1.4 1.4zm10 8.6h-2.4v-3.7c0-.9 0-2-1.2-2s-1.4 1-1.4 2v3.8h-2.4V10h2.3v1c.3-.6 1.1-1.2 2.2-1.2 2.4 0 2.8 1.6 2.8 3.6v4.2h.1z" })), Mr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7zm-4 6h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z" })), Cr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M5.298 16.359 7.657 14H2v5.657l1.86-1.86A9.99 9.99 0 0 0 12 22c4.83 0 8.87-3.44 9.8-8h-2.05c-.9 3.45-4.03 6-7.75 6a7.998 7.998 0 0 1-6.702-3.641ZM16.343 10H22V4.343l-1.86 1.86A9.99 9.99 0 0 0 12 2c-4.83 0-8.87 3.44-9.8 8h2.05c.9-3.45 4.03-6 7.75-6a8 8 0 0 1 6.703 3.641L16.343 10Z", clipRule: "evenodd" })), Ir = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M5 9a7 7 0 1114 0c0 5.3-7 13-7 13S5 14.2 5 9zm7-5a5 5 0 00-5 5c0 2.8 3 7.2 5 9.9 2.1-2.7 5-7 5-9.9a5 5 0 00-5-5zm2.5 5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" })), Rr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 72 40", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { fillRule: "evenodd", d: "M16.2 39h39.7L72 19.5 55.9 0H16.2L0 19.5 16.2 39zM55 37H17L2.6 19.4 17.1 2H55l14.5 17.6L55 36.9zM17 19.1v6.9h-2.2V10.8h4.3c1.2 0 2 .3 2.8 1 .6.8 1 1.7 1 3a4 4 0 01-.6 2.2c-.3.6-.8 1-1.4 1.3.3.1.6.4.9.7l.4 1.5.6 5.5h-2.2l-.5-5.3c-.1-.5-.2-.9-.5-1.1-.2-.2-.5-.4-1-.4H17zm0-6.4v4.4H19c.5 0 1-.1 1.2-.5.4-.4.5-1 .5-1.7 0-.8-.2-1.3-.5-1.7-.2-.3-.7-.5-1.2-.5H17zm13 13c-.5.3-1.2.5-2 .5s-1.4-.2-2-.6c-.6-.3-1.1-.9-1.4-1.6-.4-.6-.5-1.5-.5-2.4v-2c0-1 .1-1.8.5-2.5A3.7 3.7 0 0128 15c.8 0 1.4.2 2 .6.6.4 1.1.9 1.4 1.6.4.7.5 1.5.5 2.4v2.1c0 1-.1 1.8-.5 2.4-.3.7-.8 1.3-1.4 1.6zm-3.4-2.1c.4.4.8.6 1.4.6.6 0 1-.2 1.4-.6.3-.5.5-1.1.5-2v-2.2a3 3 0 00-.5-1.9c-.4-.4-.8-.6-1.4-.6-.6 0-1 .2-1.4.6a3 3 0 00-.5 1.9v2.3c0 .8.2 1.4.5 1.9zm13.5 1.7c-.6.6-1.5 1-2.5 1-1.2 0-2.2-.5-2.9-1.3a5 5 0 01-1-3.4v-2a5 5 0 011-3.4c.8-.9 1.7-1.3 3-1.3 1 0 1.9.3 2.5 1 .6.5 1 1.4 1.2 2.5l-2 .5c-.2-1.4-.8-2-1.8-2-.6 0-1 .2-1.4.6-.3.5-.5 1.1-.5 1.9v2.3c0 .8.2 1.4.5 1.9.4.4.8.6 1.4.6.5 0 .9-.1 1.2-.5.3-.3.5-.8.6-1.5l2 .5c-.2 1.1-.6 2-1.3 2.6zm4.9-6.5V26h-2V10.8h2V16c.2-.3.5-.5 1-.8a3 3 0 011.4-.3c1 0 1.7.3 2.2 1 .5.5.8 1.4.8 2.5V26h-2v-7.2c0-.6-.2-1.1-.5-1.5-.3-.3-.7-.5-1.2-.5s-1 .2-1.2.5A2 2 0 0045 19zm13.6-2.7c.6.8 1 2 1 3.3V21H54v.9c0 .8.2 1.4.5 1.9.4.4.8.6 1.3.6s.9-.1 1.2-.5c.3-.3.5-.7.6-1.3l1.8.4c-.1 1-.5 1.8-1.1 2.4-.7.6-1.5.9-2.5.9-1.2 0-2-.4-2.8-1.3-.7-.8-1-2-1-3.4v-2c0-1 .1-1.7.5-2.5.3-.6.8-1.2 1.3-1.6.6-.3 1.3-.5 2-.5 1.2 0 2 .4 2.8 1.2zm-1.4 1.3c-.4-.5-.8-.7-1.4-.7-.5 0-1 .2-1.2.7-.4.4-.5 1-.5 1.8v.3h3.5v-.4a3 3 0 00-.4-1.7z", clipRule: "evenodd" })), Or = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M9.1 22L2 19.8v-16l6.9 2.2 7-4L22 4.3v16.2L16 18l-6.9 4zM4 6.5v11.9l4 1.3V7.7L4 6.4zm10-1.1l-4 2.3v11.7l4-2.3V5.3zM16 4V16l4 1.6V5.7L16 4z" })), Lr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M19 2v2h-2v3a3 3 0 013 3v11a1 1 0 01-1 1H5a1 1 0 01-1-1V10a3 3 0 013-3V4H5V2h14zm-2 7H7a1 1 0 00-1 1v10h12V10a1 1 0 00-1-1zm-4 2v2h2v2h-2v2h-2v-2H9v-2h2v-2h2zm2-7H9v3h6V4z" })), Pr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M4 11h16v2H4v-2z" })), Dr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M15.132 16.192L6.47 24.854l1.06 1.061 8.662-8.662 8.663 8.662 1.06-1.06-8.662-8.663 8.662-8.662-1.06-1.06-8.663 8.662L7.53 6.47 6.47 7.53l8.662 8.662z" })), $r = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M29 8.75H3v-1.5h26v1.5zm0 7.5H3v-1.5h26v1.5zm0 7.5H3v-1.5h26v1.5z" })), zr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { fillRule: "evenodd", d: "M22.167 13.333a7.833 7.833 0 11-15.667 0 7.833 7.833 0 0115.667 0zm-2.568 7.708a9.333 9.333 0 111.168-.945l6.121 6.733-1.11 1.009L19.6 21.04z" })), Vr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M15.5 1h-8A2.5 2.5 0 005 3.5v17C5 21.9 6.1 23 7.5 23h8c1.4 0 2.5-1.1 2.5-2.5v-17C18 2.1 16.9 1 15.5 1zm-4 21a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm4.5-4H7V4h9v14z" })), Br = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M4 11a7 7 0 0 0 7-7h2a7 7 0 0 0 7 7v2a7 7 0 0 0-7 7h-2a7 7 0 0 0-7-7v-2Zm4.127 1A9.04 9.04 0 0 1 12 15.873 9.04 9.04 0 0 1 15.873 12 9.04 9.04 0 0 1 12 8.127 9.04 9.04 0 0 1 8.127 12Z", clipRule: "evenodd" })), Hr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { fillRule: "evenodd", d: "M4 17.8V6.2l8-1.7v15l-8-1.7ZM2 4.6l10-2.2 2-.4v4h8.5v12H14v4l-2-.4-10-2.2V4.6Zm12 5.8V16h6.5v-6l-3.4 2.3-.7.5-.6-.6-1.8-1.8ZM19.8 8h-5.4l2.2 2.2L19.8 8ZM7 12c0-.7.2-1.2.4-1.6L8 10c.1 0 .3 0 .6.4a3.4 3.4 0 0 1 0 3.2L8 14c-.1 0-.3 0-.6-.4-.2-.4-.4-1-.4-1.6Zm1-4c-1 0-1.8.6-2.2 1.3a5 5 0 0 0 0 5.4C6.2 15.4 7 16 8 16c1 0 1.8-.6 2.2-1.3a5 5 0 0 0 0-5.4A2.7 2.7 0 0 0 8 8Z", clipRule: "evenodd" })), Fr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M12.2 3a.7.7 0 00-.5.2h-.1a6.3 6.3 0 00-7.8 4.2c-.3 1-.4 2-.2 3l-1 1a2.1 2.1 0 00.9 3.4c.3.1.6.2 1 .1a2.1 2.1 0 001.8 1.6 2.1 2.1 0 002 2c0 .4.3 1 .6 1.3.8.8 2 .8 2.8.2l.4.4a2.2 2.2 0 003.7-1.3 2.1 2.1 0 001.9-2 2.1 2.1 0 001.9-1.6 2.1 2.1 0 002.4-2 2.1 2.1 0 00-.7-1.6l-.8-.8.2-.7a6 6 0 00-2.8-6.6 6 6 0 00-3-.8h-1.7-1zm3 5l3.4 3.4 1.7 1.6a.6.6 0 01-.5 1l-.4-.1-1.6-1.7a.8.8 0 00-1.1 0 .7.7 0 000 1.1l1.2 1.3a.6.6 0 01-.4 1h-.4a.8.8 0 00-1.2.5c0 .2 0 .3.2.5a.6.6 0 01-.5 1c-.1 0-.3 0-.4-.2a.8.8 0 00-1.2.6l.1.5a.6.6 0 01-.5 1c-.1 0-.3 0-.4-.2l-.4-.3.1-.2a2.1 2.1 0 00-1.4-3.6 2.1 2.1 0 00-2-2 2.1 2.1 0 00-1.4-1.8h-1a2.1 2.1 0 00-2-1.7 4.7 4.7 0 013-4.9c.6-.2 1.2-.3 1.9-.3L8.5 5.6a2.3 2.3 0 001 4.2c.7 0 1.3 0 1.8-.5L13.2 8h2zM9.4 6.7l3.1-2.3h2.3a4.5 4.5 0 014.5 5.3L16 6.6a.7.7 0 00-.6-.2H13c-.1 0-.3 0-.4.2L10.4 8a.8.8 0 01-1.3-.4.8.8 0 01.3-.9zm-3.4 8a.6.6 0 010-.9l1-1a.6.6 0 01.9 0 .6.6 0 010 1l-1 .9a.6.6 0 01-.9 0zm-.5-3.4a.6.6 0 010 .9l-1 1a.6.6 0 01-1-.3.6.6 0 01.2-.6l1-1a.6.6 0 01.8 0zm5.4 7.3a.6.6 0 01-1-.2.6.6 0 01.1-.6l1-1a.6.6 0 011 .2.6.6 0 01-.2.7l-1 1zm-2-2a.6.6 0 01-1.1-.4c0-.2 0-.3.2-.4l1-1a.6.6 0 011 .2.6.6 0 01-.2.7l-1 1z" })), Gr = (e) => /* @__PURE__ */ T.createElement("svg", { viewBox: "0 0 56 56", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M51 28C51 15.2975 40.7025 5 28 5C15.2975 5 5 15.2975 5 28C5 40.7025 15.2975 51 28 51V56C12.536 56 0 43.464 0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56V51C40.7025 51 51 40.7025 51 28Z" }), /* @__PURE__ */ T.createElement("path", { d: "M25.3333 19.75C25.3333 18.2312 24.1394 17 22.6667 17C21.1939 17 20 18.2312 20 19.75V36.25C20 37.7688 21.1939 39 22.6667 39C24.1394 39 25.3333 37.7688 25.3333 36.25V19.75Z" }), /* @__PURE__ */ T.createElement("path", { d: "M33.3333 17C34.8061 17 36 18.2312 36 19.75V36.25C36 37.7688 34.8061 39 33.3333 39C31.8606 39 30.6667 37.7688 30.6667 36.25V19.75C30.6667 18.2312 31.8606 17 33.3333 17Z" })), qr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M18.8 12h-6a1.5 1.5 0 00-1.6 1.5V18H3v-7.5H1.5v12H3v-3h18v3h1.5v-6.8a3.8 3.8 0 00-3.8-3.7zm2.2 6h-8.3v-4.5h6a2.3 2.3 0 012.3 2.3V18z" }), /* @__PURE__ */ T.createElement("path", { d: "M7.1 12.8a1.1 1.1 0 110 2.2 1.1 1.1 0 010-2.3zm0-1.6a2.6 2.6 0 100 5.3 2.6 2.6 0 000-5.3zM15.8 4.5h-3v-3h-1.6v3h-3V6h3v3h1.6V6h3V4.5z" })), jr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M6.5 5a1 1 0 112 0 1 1 0 01-2 0zm1-3a3 3 0 100 6 3 3 0 000-6zm8 3a1 1 0 112 0 1 1 0 01-2 0zm1-3a3 3 0 100 6 3 3 0 000-6zM4.3 9.3c.2-.2.4-.3.7-.3h5a1 1 0 011 1l-1 11c0 .6-.5 1-1 1H6a1 1 0 01-1-1L4 10c0-.2 0-.5.3-.7zM6 11l.8 9h1.2l.8-9H6.1zM14 9a1 1 0 00-1 1l1 11c0 .6.5 1 1 1h3c.5 0 1-.4 1-1l1-11a1 1 0 00-1-1h-5zm2 11l-.9-9h2.8l-.8 9h-1.2z", clipRule: "evenodd" })), Ur = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M6.5 5L7 7.6 5.8 8.8C5.4 7.6 5 6.3 5 5h1.5zm9.9 12c.9.3 1.7.4 2.6.5V19c-1.3-.1-2.6-.4-3.8-.8l1.2-1.2zM7.5 3H4a1 1 0 00-1 1 17 17 0 0017 17c.6 0 1-.4 1-1v-3.5c0-.5-.4-1-1-1a11.4 11.4 0 01-3.9-.6 1 1 0 00-.7.3l-2.2 2.2a15.1 15.1 0 01-6.6-6.6l2.2-2.2c.3-.3.4-.7.3-1-.4-1.1-.6-2.3-.6-3.6 0-.5-.4-1-1-1z" })), Wr = (e) => /* @__PURE__ */ T.createElement("svg", { viewBox: "0 0 56 56", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M51 28C51 15.2975 40.7025 5 28 5C15.2975 5 5 15.2975 5 28C5 40.7025 15.2975 51 28 51V56C12.536 56 0 43.464 0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56V51C40.7025 51 51 40.7025 51 28Z" }), /* @__PURE__ */ T.createElement("path", { d: "M37.8269 28.6792C37.7136 28.8855 37.5505 29.0569 37.3542 29.176L23.9374 37.3179C23.7411 37.4371 23.5183 37.4999 23.2915 37.5C23.0647 37.5 22.8419 37.4373 22.6456 37.3181C22.4491 37.1988 22.2861 37.0274 22.1727 36.8209C22.0595 36.6144 21.9998 36.3803 22 36.1419V19.8592C22 18.8146 23.0753 18.161 23.9374 18.6843L37.3542 26.8251C37.5505 26.9443 37.7136 27.1156 37.8269 27.3219C37.9402 27.5283 38 27.7623 38 28.0006C38 28.2388 37.9402 28.4729 37.8269 28.6792Z" })), Yr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M11.3 3.6h1.4l.2.1v16.6l-.2.1h-1.4l-.2-.1V3.6l.2-.1z" }), /* @__PURE__ */ T.createElement("path", { d: "M4.1 11.1H20c.1 0 .2 0 .2.2v1.4l-.2.2H4c-.1 0-.2 0-.2-.2v-1.4l.2-.2z" })), Xr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M14 12c0 .74-.4 1.38-1 1.72V22h-2v-8.28c-.6-.35-1-.98-1-1.72 0-1.1.9-2 2-2s2 .9 2 2Zm-2-6c-3.31 0-6 2.69-6 6 0 1.74.75 3.31 1.94 4.4l1.42-1.42A3.956 3.956 0 0 1 8 12c0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.19-.53 2.25-1.36 2.98l1.42 1.42A5.957 5.957 0 0 0 18 12c0-3.31-2.69-6-6-6Zm0-4C6.48 2 2 6.48 2 12c0 2.85 1.2 5.41 3.11 7.24l1.42-1.42A7.986 7.986 0 0 1 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 2.29-.98 4.36-2.53 5.82l1.42 1.42C20.8 17.41 22 14.85 22 12c0-5.52-4.48-10-10-10Z" })), Zr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M12 1.5a10.5 10.5 0 100 21 10.5 10.5 0 000-21zm4.4 13.7l-1.2 1.2L12 13l-3.2 3.3-1.2-1.2L11 12 7.6 8.8l1.2-1.2L12 11l3.2-3.3 1.2 1.2L13 12l3.3 3.2z" })), Kr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { fillRule: "evenodd", d: "M22.167 13.333a7.833 7.833 0 1 1-15.667 0 7.833 7.833 0 0 1 15.667 0Zm-2.568 7.708a9.333 9.333 0 1 1 1.168-.945l6.121 6.733-1.11 1.009L19.6 21.04Z", clipRule: "evenodd" })), Qr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M10 18a8 8 0 004.9-1.7l4.4 4.4 1.4-1.4-4.4-4.4A8 8 0 1010 18zm0-14a6 6 0 110 12 6 6 0 010-12z" })), Jr = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "m11.99 18.54-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74ZM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16Zm0-11.47L17.74 9 12 13.47 6.26 9 12 4.53Z" })), ea = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M26 21h-4.5v2h8v-8h-2v4.6l-10.3-9.3-.7-.7-.7.7-5.3 5.3-7.8-7.3-1.4 1.4 8.5 8 .7.7.7-.7 5.3-5.3L26 21Z", clipRule: "evenodd" })), ta = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "m25.6 16.9-3.3 3.3 1.4 1.4 5-5 .7-.7-.7-.7-5-5-1.4 1.5 3.2 3.2H3v2h22.6Z", clipRule: "evenodd" })), ia = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M26 10h-4.5V8h8v8h-2v-4.6l-10.3 9.3-.7.7-.7-.7-5.3-5.3-7.8 7.3-1.4-1.4 8.5-8 .7-.7.7.7 5.3 5.3L26 10Z", clipRule: "evenodd" })), sa = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M12 2a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16 8 8 0 010 16z" }), /* @__PURE__ */ T.createElement("path", { d: "M13 7h-2v6h6v-2h-4V7z" })), na = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M17.1761 4H19.9362L13.9061 10.7774L21 20H15.4456L11.0951 14.4066L6.11723 20H3.35544L9.80517 12.7508L3 4H8.69545L12.6279 9.11262L17.1761 4ZM16.2073 18.3754H17.7368L7.86441 5.53928H6.2232L16.2073 18.3754Z" })), ra = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M8 7l4-4 4 4h-3v8h-2V7H8zM3 19c0 1.1.9 2 2 2h14a2 2 0 002-2v-5h-2v5H5v-5H3v5z", clipRule: "evenodd" })), aa = (e) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...e }, /* @__PURE__ */ T.createElement("path", { d: "M20.85 8.7s-.15-1.27-.75-1.8c-.68-.75-1.43-.75-1.8-.75C15.75 6 12 6 12 6s-3.75 0-6.3.15c-.38.07-1.13.07-1.8.75-.52.52-.75 1.8-.75 1.8S3 10.13 3 11.63v1.34a34 34 0 00.15 2.93s.15 1.28.75 1.8c.68.75 1.57.68 1.95.75 1.43.15 6.15.15 6.15.15s3.75 0 6.3-.23c.38-.07 1.13-.07 1.8-.75.52-.52.75-1.8.75-1.8S21 14.4 21 12.9v-1.35c0-1.43-.15-2.85-.15-2.85zm-10.73 5.93V9.6L15 12.15l-4.88 2.47z" })), fs = {
  additional: Fn,
  "alert-error": Gn,
  "alert-success": qn,
  "arrow-down": jn,
  "arrow-left": Un,
  "arrow-light-down": Wn,
  "arrow-light-left": Yn,
  "arrow-light-right": Xn,
  "arrow-light-up": Zn,
  "arrow-right": Kn,
  "arrow-up": Qn,
  book: Jn,
  calendar: er,
  checkmark: tr,
  "chevron-down": ir,
  "chevron-left": sr,
  "chevron-right": nr,
  "chevron-up": rr,
  circle: ar,
  close: or,
  "color-indicator": lr,
  connected: cr,
  "copy-link": dr,
  cross: ur,
  "default-avatar": fr,
  diagnostics: pr,
  download: hr,
  dropdown: mr,
  dummy: gr,
  email: _r,
  "external-link": vr,
  facebook: wr,
  fax: br,
  "file-download": yr,
  file: Er,
  filter: xr,
  globe: Sr,
  "google-cal": Tr,
  info: Nr,
  instagram: kr,
  linkedin: Ar,
  list: Mr,
  loading: Cr,
  location: Ir,
  logo: Rr,
  map: Or,
  medicine: Lr,
  minus: Pr,
  "mobile-close": Dr,
  "mobile-menu": $r,
  "mobile-search": zr,
  mobile: Vr,
  "molecular-item": Br,
  outlook: Hr,
  partnership: Fr,
  pause: Gr,
  patient: qr,
  people: jr,
  phone: Ur,
  play: Wr,
  plus: Yr,
  podcasts: Xr,
  remove: Zr,
  "search-mobile": Kr,
  search: Qr,
  series: Jr,
  "stock-down": ea,
  "stock-equal": ta,
  "stock-up": ia,
  time: sa,
  twitter: na,
  upload: ra,
  youtube: aa
}, oa = [
  "arrow-left",
  "arrow-light-left",
  "arrow-light-right",
  "arrow-right",
  "chevron-left",
  "chevron-right",
  "diagnostics",
  "external-link",
  "file-download",
  "file",
  "list",
  "stock-down",
  "stock-equal",
  "stock-up",
  "loading"
], la = "icon", zt = {
  "icon-container": "icon-container",
  icon: la,
  "icon--rtl": "icon--rtl",
  "icon-container--inline": "icon-container--inline"
};
function ca() {
  const [e, t] = V(!1);
  return G(() => {
    if (typeof document > "u")
      return;
    const i = document.documentElement, s = () => {
      t(i.getAttribute("dir") === "rtl");
    };
    s();
    const n = new MutationObserver((r) => {
      for (const a of r)
        a.type === "attributes" && a.attributeName === "dir" && s();
    });
    return n.observe(i, { attributes: !0 }), () => {
      n.disconnect();
    };
  }, []), e;
}
const F = ({
  icon: e,
  height: t,
  width: i,
  color: s,
  decorative: n = !0,
  display: r,
  onClick: a
}) => {
  if (!Object.keys(fs).includes(e))
    return null;
  const l = ca() ? oa.includes(e) : !1, c = fs[e], d = {
    "--custom-icon-color": s
  };
  return /* @__PURE__ */ u("span", { className: O(zt["icon-container"], r === "inline" && zt["icon-container--inline"]), children: /* @__PURE__ */ u(
    c,
    {
      className: O(zt.icon, l && zt["icon--rtl"]),
      width: i,
      height: t,
      "aria-hidden": n,
      style: s ? d : void 0,
      onClick: a
    }
  ) });
}, da = "accordion", ua = "magnet", fa = "accordion__header", pa = "accordion__icon", ha = "accordion__panel", ma = "accordion__item", We = {
  accordion: da,
  magnet: ua,
  accordion__header: fa,
  "accordion__header-text": "accordion__header-text",
  accordion__icon: pa,
  accordion__panel: ha,
  accordion__item: ma,
  "accordion__item--active": "accordion__item--active",
  "accordion__item--closing": "accordion__item--closing"
}, wh = ({
  initiallyOpen: e,
  sections: t,
  headlineLevel: i = "h4",
  children: s,
  slot: n,
  onPanelToggle: r
}) => {
  const [a, o] = V(null), [l, c] = V(null), d = H([]), f = H([]), [h, g] = Qs(), { scrollToItem: m } = Js(f);
  G(() => {
    const w = h.substring(1), v = (t == null ? void 0 : t.findIndex((N) => N.id === w)) ?? null, y = e && e >= 0 && e < ((t == null ? void 0 : t.length) ?? 0) ? e : null, S = v !== null && v >= 0 ? v : y ?? null;
    o(S), v !== null && f.current[v] && m(v);
  }, []);
  const b = (w) => {
    var N, R;
    const v = a === w, y = v ? null : w;
    o(v ? null : w), c(v ? w : null), g(y !== null && ((N = t == null ? void 0 : t[y]) == null ? void 0 : N.id) || "");
    const S = (R = d.current) == null ? void 0 : R[w];
    S && (S.style.maxHeight = v ? "0px" : `${S.scrollHeight}px`, S.style.opacity = v ? "0" : "1");
  }, E = (w, v) => {
    var S;
    b(v);
    const y = ((S = t == null ? void 0 : t[v]) == null ? void 0 : S.headline) || "";
    r == null || r(w, y);
  }, x = (w, v) => {
    var S;
    if (w.propertyName !== "max-height")
      return;
    const y = (S = d.current) == null ? void 0 : S[v];
    l === v && y && y.style.maxHeight === "0px" && c(null);
  }, p = (w, v) => {
    var R;
    if (!t || t.length === 0)
      return;
    const { key: y } = w, S = t.length, N = {
      ArrowDown: (A, C) => (A + 1) % C,
      ArrowUp: (A, C) => (A - 1 + C) % C,
      Home: () => 0,
      End: (A, C) => C - 1
    };
    if (N[y]) {
      w.preventDefault();
      const A = N[y](v, S);
      (R = f.current[A]) == null || R.focus();
    } else (y === "Enter" || y === " ") && (w.preventDefault(), E(w, v));
  }, _ = `${i}`;
  return /* @__PURE__ */ u("div", { className: We.accordion, slot: n, children: t == null ? void 0 : t.map((w, v) => {
    var y;
    return /* @__PURE__ */ M(
      "div",
      {
        className: O(
          We.accordion__item,
          a === v && We["accordion__item--active"],
          l === v && We["accordion__item--closing"]
        ),
        onTransitionEnd: (S) => x(S, v),
        children: [
          /* @__PURE__ */ u(_, { children: /* @__PURE__ */ M(
            "button",
            {
              className: We.accordion__header,
              id: `accordion-header-${w.id}`,
              type: "button",
              "aria-expanded": a === v,
              "aria-controls": `accordion-panel-${w.id}`,
              tabIndex: 0,
              onClick: (S) => E(S, v),
              onKeyDown: (S) => p(S, v),
              ref: (S) => f.current[v] = S,
              children: [
                /* @__PURE__ */ u("span", { className: We["accordion__header-text"], children: w.headline }),
                /* @__PURE__ */ u("span", { className: We.accordion__icon, children: /* @__PURE__ */ u(F, { icon: a === v ? "minus" : "plus", height: "24px", decorative: !0 }) })
              ]
            }
          ) }),
          /* @__PURE__ */ u(
            "div",
            {
              className: We.accordion__panel,
              id: `accordion-panel-${w.id}`,
              role: "region",
              "aria-labelledby": `accordion-header-${w.id}`,
              "aria-hidden": a !== v,
              style: {
                maxHeight: a === v ? `${(y = d.current[v]) == null ? void 0 : y.scrollHeight}px` : "0px",
                opacity: a === v ? 1 : 0
              },
              ref: (S) => d.current[v] = S,
              children: s == null ? void 0 : s[v]
            }
          )
        ]
      },
      w.id
    );
  }) });
}, ps = {
  "roche-add-to-calendar": "roche-add-to-calendar",
  "roche-add-to-calendar__headline": "roche-add-to-calendar__headline"
};
var ci = /* @__PURE__ */ ((e) => (e.SELF = "_self", e.BLANK = "_blank", e))(ci || {}), di = /* @__PURE__ */ ((e) => (e.BUTTON = "button", e.SUBMIT = "submit", e.RESET = "reset", e))(di || {}), ti = /* @__PURE__ */ ((e) => (e.LEFT = "left", e.CENTER = "center", e))(ti || {}), Me = /* @__PURE__ */ ((e) => (e.PRIMARY = "primary", e.SECONDARY = "secondary", e.TERTIARY = "tertiary", e.SUCCESS = "success", e.ERROR = "error", e.BOTTOM_FIXED = "bottom-fixed", e))(Me || {});
const ga = "button", _a = "button__content", va = "button__text", ee = {
  button: ga,
  "button--loading": "button--loading",
  "button__icon-container": "button__icon-container",
  "button__icon-container--loading": "button__icon-container--loading",
  "loading-spinner": "loading-spinner",
  button__content: _a,
  "button__content--loading": "button__content--loading",
  "button__loading-spinner": "button__loading-spinner",
  button__text: va,
  "button--left-aligned": "button--left-aligned",
  "button--primary": "button--primary",
  "button--disabled": "button--disabled",
  "button--secondary": "button--secondary",
  "button--tertiary": "button--tertiary",
  "button--success": "button--success",
  "button--error": "button--error",
  "button--bottom-fixed": "button--bottom-fixed",
  "button-wrapper": "button-wrapper",
  "button-wrapper--no-margin": "button-wrapper--no-margin"
}, wa = 16, Pe = (e) => e / wa;
var ne = /* @__PURE__ */ ((e) => (e[e.SMALL = 320] = "SMALL", e[e.MEDIUM = 768] = "MEDIUM", e[e.LARGE = 1024] = "LARGE", e[e.X_LARGE = 1440] = "X_LARGE", e[e.XX_LARGE = 1672] = "XX_LARGE", e))(ne || {});
const ba = 24, ya = "loading", Lt = ({
  appearance: e = Me.PRIMARY,
  alignment: t = ti.CENTER,
  disabled: i,
  download: s,
  text: n,
  type: r = di.BUTTON,
  target: a = ci.SELF,
  leftIcon: o,
  rightIcon: l,
  href: c,
  hasMarginTop: d = !0,
  isModalTrigger: f,
  isLoading: h,
  slot: g,
  onModalTrigger: m,
  onClick: b
}) => {
  const E = c ? "a" : "button", x = (v, y) => {
    const S = O(ee["button__icon-container"], y && ee["button__icon-container--loading"]);
    return (
      // There's always text in the button, the icons are decorative: aria-hidden={true}
      /* @__PURE__ */ u("div", { className: S, "aria-hidden": !0, children: /* @__PURE__ */ u(F, { icon: v, height: `${Pe(ba)}rem` }) })
    );
  }, p = c ? {
    target: a,
    ...s && { download: s },
    ...!i && { href: c }
  } : {
    type: r,
    disabled: i,
    appearance: e
  }, _ = O(
    ee.button,
    i && ee["button--disabled"],
    h && ee["button--loading"],
    t === ti.LEFT && ee["button--left-aligned"],
    e === Me.PRIMARY && ee["button--primary"],
    e === Me.SECONDARY && ee["button--secondary"],
    e === Me.TERTIARY && ee["button--tertiary"],
    e === Me.SUCCESS && ee["button--success"],
    e === Me.ERROR && ee["button--error"],
    e === Me.BOTTOM_FIXED && ee["button--bottom-fixed"]
  ), w = (v) => {
    f && m && (v.preventDefault(), m()), b && b(v);
  };
  return /* @__PURE__ */ u("div", { className: O(ee["button-wrapper"], !d && ee["button-wrapper--no-margin"]), slot: g, children: /* @__PURE__ */ M(E, { className: _, onClick: w, ...p, children: [
    /* @__PURE__ */ M("span", { className: O(ee.button__content, h && ee["button__content--loading"]), children: [
      o && x(o),
      /* @__PURE__ */ u("div", { className: ee.button__text, "data-content": n, children: n }),
      l && x(l)
    ] }),
    h && /* @__PURE__ */ u("span", { className: ee["button__loading-spinner"], children: x(ya, h) })
  ] }) });
}, Vt = (e) => e ? new Date(e).toISOString() : "", hs = (e) => e.replace(/-|:|\.\d{3}/g, ""), bh = ({
  heading: e,
  eventTitle: t,
  description: i,
  startDate: s,
  endDate: n,
  icsLabel: r,
  googleCalendarLabel: a,
  outlookOnlineLabel: o,
  onCalendarLinkClick: l
}) => {
  const c = Vt(s), d = Vt(n), f = hs(Vt(s)), h = hs(Vt(n)), g = [
    {
      title: t,
      text: r,
      href: `data:text/calendar,${encodeURIComponent(
        `BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
SUMMARY:${t}
DESCRIPTION:${i}
DTSTART:${f}
DTEND:${h}
END:VEVENT
END:VCALENDAR`
      )}`,
      icon: "file"
    },
    {
      text: a,
      href: `https://calendar.google.com/calendar/event?action=TEMPLATE&dates=${f}%2F${h}&text=${encodeURIComponent(
        t
      )}&details=${encodeURIComponent(i)}`,
      icon: "google-cal"
    },
    {
      text: o,
      href: `https://outlook.live.com/calendar/0/deeplink/compose?rru=addevent&path=%2Fcalendar%2Faction%2Fcompose&startdt=${c}&enddt=${d}&subject=${t}&body=${i}`,
      icon: "outlook"
    }
  ];
  return /* @__PURE__ */ M("div", { className: ps["roche-add-to-calendar"], children: [
    /* @__PURE__ */ u("h3", { className: ps["roche-add-to-calendar__headline"], children: e }),
    g.map((m, b) => /* @__PURE__ */ u(
      Lt,
      {
        hasMarginTop: !1,
        appearance: Me.SECONDARY,
        alignment: ti.LEFT,
        download: m.title,
        text: m.text,
        href: m.href,
        leftIcon: m.icon,
        target: ci.BLANK,
        onClick: (E) => l(E, m.text, m.href)
      },
      b
    ))
  ] });
}, be = {
  "animated-words": "animated-words",
  "animated-words__headline": "animated-words__headline",
  "animated-words__text-container": "animated-words__text-container",
  "animated-words__words-container": "animated-words__words-container",
  "animated-words__word": "animated-words__word",
  "animated-words__word--active": "animated-words__word--active",
  "animated-words__word--previous": "animated-words__word--previous",
  "animated-words__word--next": "animated-words__word--next",
  "animated-words__word--red": "animated-words__word--red",
  "animated-words__word--orange": "animated-words__word--orange",
  "animated-words__word--purple": "animated-words__word--purple",
  "animated-words__word--brand": "animated-words__word--brand",
  "animated-words__word--effect": "animated-words__word--effect",
  "animated-words--animated": "animated-words--animated"
}, Ea = (e) => {
  const [t, i] = V(!1);
  return G(() => {
    const s = new IntersectionObserver(([n]) => i(n.isIntersecting));
    return e.current && s.observe(e.current), () => {
      s.disconnect();
    };
  }, [e]), t;
}, en = (e) => {
  const [, t] = V(!1), i = H(!1);
  return G(() => {
    const s = new IntersectionObserver(([n]) => {
      n.isIntersecting && !i.current && (i.current = !0, t(!0));
    });
    return e.current && s.observe(e.current), () => {
      s.disconnect();
    };
  }, [e]), i.current;
}, xa = 1400, Sa = ["red", "orange", "purple", "brand"], yh = ({ headline: e, words: t }) => {
  const i = H(null), [s, n] = V(0), r = Ea(i), a = t ? t.trim().split(`
`) : [], o = a.length <= 3 && a.length > 1 ? [...a, ...a] : a, l = a.length > 1, c = (d) => {
    const f = d % a.length === a.length - 1 ? "animated-words__word--effect" : `animated-words__word--${Sa[d % a.length % a.length]}`;
    if (!l)
      return O(be["animated-words__word"], be[f], {
        [be["animated-words__word--active"]]: !0
      });
    const h = o.length, g = d === s, m = d === (s - 1 + h) % h, b = d === (s + 1 + h) % h;
    return O(be["animated-words__word"], be[f], {
      [be["animated-words__word--active"]]: g,
      [be["animated-words__word--previous"]]: m,
      [be["animated-words__word--next"]]: b
    });
  };
  return G(() => {
    if (l && r) {
      const d = setInterval(() => {
        n((f) => (f + 1) % o.length);
      }, xa);
      return () => clearInterval(d);
    }
  }, [a, r]), /* @__PURE__ */ M(
    "h2",
    {
      ref: i,
      className: O(be["animated-words"], {
        [be["animated-words--animated"]]: l
      }),
      "aria-label": `${e} ${t.replaceAll(`
`, ", ")}`,
      children: [
        /* @__PURE__ */ u("span", { className: be["animated-words__headline"], children: e }),
        /* @__PURE__ */ u("div", { className: be["animated-words__text-container"], children: o.map((d, f) => /* @__PURE__ */ u("span", { className: c(f), children: d }, f)) })
      ]
    }
  );
}, Ta = "avatar", Na = "avatar__fallback", ka = "avatar__icon", Aa = "image", wi = {
  avatar: Ta,
  avatar__fallback: Na,
  avatar__icon: ka,
  image: Aa
}, Eh = ({ children: e }) => /* @__PURE__ */ u("div", { className: wi.avatar, children: e ?? /* @__PURE__ */ u("div", { className: wi.avatar__fallback, children: /* @__PURE__ */ u("div", { className: wi.avatar__icon, children: /* @__PURE__ */ u(F, { icon: "default-avatar", height: "100%", decorative: !0 }) }) }) });
var ui = /* @__PURE__ */ ((e) => (e.SELF = "_self", e.BLANK = "_blank", e))(ui || {});
const Ma = "overline", Ca = "overline__text", ms = {
  overline: Ma,
  overline__text: Ca
}, Ia = ({ overlineText: e, slot: t }) => /* @__PURE__ */ u("div", { className: ms.overline, slot: t, children: /* @__PURE__ */ u("p", { className: ms.overline__text, children: e }) }), lt = {
  "text-link": "text-link",
  "text-link__link": "text-link__link",
  "text-link__icon-container": "text-link__icon-container",
  "text-link__text": "text-link__text",
  "text-link--footnote": "text-link--footnote",
  "text-link--contact-person": "text-link--contact-person",
  "text-link--footer-social": "text-link--footer-social",
  "text-link--footer-column": "text-link--footer-column",
  "text-link--footer-quick": "text-link--footer-quick",
  "text-link--footer-service": "text-link--footer-service",
  "text-link--breadcrumbs": "text-link--breadcrumbs",
  "text-link--news-page": "text-link--news-page",
  "icon-container": "icon-container"
};
var ht = /* @__PURE__ */ ((e) => (e.CONTACT_PERSON = "contact-person", e.FOOTER = "footer", e.FOOTER_QUICK = "footer-quick", e.FOOTER_COLUMN = "footer-column", e.FOOTER_SOCIAL = "footer-social", e.FOOTER_SERVICE = "footer-service", e.BREADCRUMBS = "breadcrumbs", e.NEWS_PAGE = "news-page", e))(ht || {}), Ra = /* @__PURE__ */ ((e) => (e.FOOTNOTE = "footnote", e))(Ra || {});
const Mt = ({
  href: e,
  text: t,
  slot: i,
  target: s,
  leftIcon: n,
  rightIcon: r,
  label: a,
  type: o,
  size: l,
  onButtonClick: c,
  buttonType: d = di.BUTTON,
  onTextLinkClick: f
}) => {
  const h = e ? "a" : "button", g = e ? { href: e, target: s } : {}, m = (b) => {
    const E = o === ht.NEWS_PAGE;
    return /* @__PURE__ */ u("span", { className: lt["text-link__icon-container"], children: /* @__PURE__ */ u(F, { icon: b, height: E ? "14px" : "24px" }) });
  };
  return /* @__PURE__ */ u(
    "span",
    {
      className: O(lt["text-link"], o && lt[`text-link--${o}`], l && lt[` text-link--${l}`]),
      slot: i,
      children: /* @__PURE__ */ M(
        h,
        {
          className: lt["text-link__link"],
          ...g,
          "aria-label": a,
          onClick: h === "a" ? f : c,
          type: h === "button" ? d : void 0,
          children: [
            n && m(n),
            /* @__PURE__ */ u("span", { className: lt["text-link__text"], children: t }),
            r && m(r)
          ]
        }
      )
    }
  );
}, gs = {
  "roche-back-to-branch": "roche-back-to-branch",
  "roche-back-to-branch__content": "roche-back-to-branch__content"
}, Oa = "headline", La = "headline__overline", Bt = {
  headline: Oa,
  headline__overline: La,
  "headline--1": "headline--1",
  "headline--2": "headline--2",
  "headline--3": "headline--3",
  "headline--4": "headline--4",
  "headline--5": "headline--5",
  "headline--6": "headline--6",
  "headline--pipeline": "headline--pipeline"
};
var Li = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.PIPELINE = "pipeline", e))(Li || {});
const tn = ({
  overline: e,
  headline: t,
  level: i = "1",
  appearance: s = Li.DEFAULT,
  children: n,
  slot: r
}) => {
  const a = `h${i}`;
  return /* @__PURE__ */ M(
    a,
    {
      slot: r,
      className: O(
        Bt.headline,
        Bt[`headline--${i}`],
        s !== Li.DEFAULT && Bt[`headline--${s}`]
      ),
      children: [
        e && /* @__PURE__ */ u("span", { className: Bt.headline__overline, children: e }),
        t || n
      ]
    }
  );
}, xh = ({
  overlineText: e,
  headline: t,
  linkText: i,
  link: s,
  icon: n,
  slot: r
}) => /* @__PURE__ */ M("section", { className: gs["roche-back-to-branch"], slot: r, children: [
  /* @__PURE__ */ M("div", { className: gs["roche-back-to-branch__content"], children: [
    e && /* @__PURE__ */ u(Ia, { overlineText: e }),
    /* @__PURE__ */ u(tn, { headline: t, level: "5" })
  ] }),
  /* @__PURE__ */ u(Mt, { rightIcon: n, href: s, text: i, target: ui.SELF })
] }), Pa = "breadcrumbs", Da = "breadcrumbs__item", $a = "breadcrumbs__text", za = "breadcrumbs__icon", bt = {
  breadcrumbs: Pa,
  "breadcrumbs__item-list": "breadcrumbs__item-list",
  breadcrumbs__item: Da,
  breadcrumbs__text: $a,
  breadcrumbs__icon: za
}, Va = ({ items: e, ariaLabel: t, slot: i, onBreadcrumbClick: s }) => {
  const n = (r, a) => /* @__PURE__ */ M(zn.Fragment, { children: [
    a > 0 && /* @__PURE__ */ u("span", { className: bt.breadcrumbs__icon, children: /* @__PURE__ */ u(F, { icon: "chevron-right", height: "14px" }) }),
    /* @__PURE__ */ u("li", { className: bt.breadcrumbs__item, children: r.href ? /* @__PURE__ */ u(
      Mt,
      {
        href: r.href,
        text: r.text,
        target: ui.SELF,
        type: ht.BREADCRUMBS,
        onTextLinkClick: () => s(ht.BREADCRUMBS, r.text, r.href)
      }
    ) : /* @__PURE__ */ u("p", { className: bt.breadcrumbs__text, children: r.text }) })
  ] }, `breadcrumb-${a}`);
  return /* @__PURE__ */ u("nav", { className: bt.breadcrumbs, "aria-label": t, slot: i, children: /* @__PURE__ */ u("ol", { className: bt["breadcrumbs__item-list"], children: e == null ? void 0 : e.map((r, a) => n(r, a)) }) });
};
var Wt = /* @__PURE__ */ ((e) => (e.VARIANT_A = "contact-person--variant-a", e.VARIANT_A_WITHOUT_IMAGE = "contact-person--variant-a-without-image", e.VARIANT_B = "contact-person--variant-b", e))(Wt || {});
const ct = {
  "contact-person": "contact-person",
  "contact-person__avatar": "contact-person__avatar",
  "contact-person__name": "contact-person__name",
  "contact-person__job-title": "contact-person__job-title",
  "contact-person__phone-number": "contact-person__phone-number",
  "contact-person__email-address": "contact-person__email-address"
}, Sh = ({
  layout: e = Wt.VARIANT_A,
  name: t,
  jobTitle: i,
  phoneNumber: s,
  emailAddress: n,
  children: r,
  slot: a
}) => {
  const o = e !== Wt.VARIANT_B, l = e !== Wt.VARIANT_A_WITHOUT_IMAGE && r;
  return /* @__PURE__ */ M("div", { className: ct["contact-person"], slot: a, children: [
    l && /* @__PURE__ */ u("div", { className: ct["contact-person__avatar"], children: r }),
    /* @__PURE__ */ u("h3", { className: ct["contact-person__name"], children: t }),
    /* @__PURE__ */ u("p", { className: ct["contact-person__job-title"], children: i }),
    o && s && /* @__PURE__ */ u("div", { className: ct["contact-person__phone-number"], children: /* @__PURE__ */ u(
      Mt,
      {
        href: `tel:${s}`,
        text: s,
        leftIcon: "phone",
        type: ht.CONTACT_PERSON
      },
      "phone-number"
    ) }),
    o && n && /* @__PURE__ */ u("div", { className: ct["contact-person__email-address"], children: /* @__PURE__ */ u(
      Mt,
      {
        href: `mailto:${n}`,
        text: n,
        leftIcon: "email",
        type: ht.CONTACT_PERSON
      },
      "email-address"
    ) })
  ] });
}, Ba = "container", it = {
  container: Ba,
  "container--full-width": "container--full-width",
  "container--colored": "container--colored",
  "container--theme-aware": "container--theme-aware",
  "container--aware-gradient-top-left": "container--aware-gradient-top-left",
  "container--aware-gradient-bottom-right": "container--aware-gradient-bottom-right",
  "container--neutral-gradient-top-left": "container--neutral-gradient-top-left",
  "container--blue-gradient-top-left": "container--blue-gradient-top-left",
  "container--blue-gradient-bottom-right": "container--blue-gradient-bottom-right",
  "container--neutral-gradient-bottom-right": "container--neutral-gradient-bottom-right",
  "container--neutral-gradient-neutral-100-neutral-400": "container--neutral-gradient-neutral-100-neutral-400",
  "container--neutral-100": "container--neutral-100",
  "container--neutral-200": "container--neutral-200",
  "container--grey-50": "container--grey-50",
  "container--grey-100": "container--grey-100",
  "container--grey-300": "container--grey-300",
  "container--white": "container--white",
  "container--split-gradient-radial": "container--split-gradient-radial",
  "container__gradient-helper": "container__gradient-helper",
  "container--split-gradient-linear": "container--split-gradient-linear",
  "container--brand-gradient": "container--brand-gradient",
  "brand-gradient-animation": "brand-gradient-animation",
  "container--extended-background": "container--extended-background",
  "container--full-height": "container--full-height"
};
var Pi = /* @__PURE__ */ ((e) => (e.TRANSPARENT = "transparent", e.THEME_AWARE = "theme-aware", e.NEUTRAL_GRADIENT_TOP_LEFT = "neutral-gradient-top-left", e.NEUTRAL_GRADIENT_BOTTOM_RIGHT = "neutral-gradient-bottom-right", e.NEUTRAL_GRADIENT_NEUTRAL_100_NEUTRAL_400 = "neutral-gradient-neutral-100-neutral-400", e.NEUTRAL_100 = "neutral-100", e.NEUTRAL_200 = "neutral-200", e.GREY_50 = "grey-50", e.GREY_100 = "grey-100", e.GREY_300 = "grey-300", e.WHITE = "white", e.AWARE_SOFT_TOP_LEFT = "aware-gradient-top-left", e.AWARE_SOFT_BOTTOM_RIGHT = "aware-gradient-bottom-right", e.BLUE_GRADIENT_TOP_LEFT = "blue-gradient-top-left", e.BLUE_GRADIENT_BOTTOM_RIGHT = "blue-gradient-bottom-right", e.SPLIT_GRADIENT = "split-gradient-radial", e.GRADIENT_WHITE_TO_GRAY_4 = "split-gradient-linear", e.BRAND_GRADIENT = "brand-gradient", e))(Pi || {});
const Ha = ({
  color: e = Pi.TRANSPARENT,
  fullWidth: t,
  fullHeight: i,
  extendBackgroundToTop: s,
  children: n
}) => {
  const r = O(
    it.container,
    e !== Pi.TRANSPARENT && it["container--colored"],
    it["container--" + e],
    t && it["container--full-width"],
    i && it["container--full-height"],
    s && it["container--extended-background"]
  );
  return /* @__PURE__ */ M("div", { className: r, children: [
    /* @__PURE__ */ u("div", { className: it["container__gradient-helper"] }),
    n
  ] });
}, Ae = {
  "roche-dropdown": "roche-dropdown",
  "roche-dropdown__label-wrapper": "roche-dropdown__label-wrapper",
  "roche-dropdown__label": "roche-dropdown__label",
  "roche-dropdown__select": "roche-dropdown__select",
  "roche-dropdown__select--placeholder": "roche-dropdown__select--placeholder",
  "roche-dropdown__container": "roche-dropdown__container",
  "roche-dropdown__icon": "roche-dropdown__icon",
  "roche-dropdown--disabled": "roche-dropdown--disabled",
  "roche-dropdown__error": "roche-dropdown__error",
  "roche-dropdown--error": "roche-dropdown--error",
  "roche-dropdown__error-text": "roche-dropdown__error-text"
}, Fa = "tooltip", Ga = "tooltip__icon", qa = "tooltip__content", ja = "tooltip__arrow", Ua = "tooltip__text", st = {
  tooltip: Fa,
  tooltip__icon: Ga,
  "tooltip__icon--active": "tooltip__icon--active",
  tooltip__content: qa,
  tooltip__arrow: ja,
  "tooltip__content--open": "tooltip__content--open",
  tooltip__text: Ua
};
var _s = function(t) {
  return t.reduce(function(i, s) {
    var n = s[0], r = s[1];
    return i[n] = r, i;
  }, {});
}, vs = typeof window < "u" && window.document && window.document.createElement ? T.useLayoutEffect : T.useEffect, me = "top", Ne = "bottom", ke = "right", ge = "left", ji = "auto", Pt = [me, Ne, ke, ge], mt = "start", Ct = "end", Wa = "clippingParents", sn = "viewport", yt = "popper", Ya = "reference", ws = /* @__PURE__ */ Pt.reduce(function(e, t) {
  return e.concat([t + "-" + mt, t + "-" + Ct]);
}, []), nn = /* @__PURE__ */ [].concat(Pt, [ji]).reduce(function(e, t) {
  return e.concat([t, t + "-" + mt, t + "-" + Ct]);
}, []), Xa = "beforeRead", Za = "read", Ka = "afterRead", Qa = "beforeMain", Ja = "main", eo = "afterMain", to = "beforeWrite", io = "write", so = "afterWrite", no = [Xa, Za, Ka, Qa, Ja, eo, to, io, so];
function De(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function we(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function at(e) {
  var t = we(e).Element;
  return e instanceof t || e instanceof Element;
}
function Te(e) {
  var t = we(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Ui(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = we(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function ro(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(i) {
    var s = t.styles[i] || {}, n = t.attributes[i] || {}, r = t.elements[i];
    !Te(r) || !De(r) || (Object.assign(r.style, s), Object.keys(n).forEach(function(a) {
      var o = n[a];
      o === !1 ? r.removeAttribute(a) : r.setAttribute(a, o === !0 ? "" : o);
    }));
  });
}
function ao(e) {
  var t = e.state, i = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, i.popper), t.styles = i, t.elements.arrow && Object.assign(t.elements.arrow.style, i.arrow), function() {
    Object.keys(t.elements).forEach(function(s) {
      var n = t.elements[s], r = t.attributes[s] || {}, a = Object.keys(t.styles.hasOwnProperty(s) ? t.styles[s] : i[s]), o = a.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !Te(n) || !De(n) || (Object.assign(n.style, o), Object.keys(r).forEach(function(l) {
        n.removeAttribute(l);
      }));
    });
  };
}
const oo = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: ro,
  effect: ao,
  requires: ["computeStyles"]
};
function Le(e) {
  return e.split("-")[0];
}
var rt = Math.max, ii = Math.min, gt = Math.round;
function Di() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function rn() {
  return !/^((?!chrome|android).)*safari/i.test(Di());
}
function _t(e, t, i) {
  t === void 0 && (t = !1), i === void 0 && (i = !1);
  var s = e.getBoundingClientRect(), n = 1, r = 1;
  t && Te(e) && (n = e.offsetWidth > 0 && gt(s.width) / e.offsetWidth || 1, r = e.offsetHeight > 0 && gt(s.height) / e.offsetHeight || 1);
  var a = at(e) ? we(e) : window, o = a.visualViewport, l = !rn() && i, c = (s.left + (l && o ? o.offsetLeft : 0)) / n, d = (s.top + (l && o ? o.offsetTop : 0)) / r, f = s.width / n, h = s.height / r;
  return {
    width: f,
    height: h,
    top: d,
    right: c + f,
    bottom: d + h,
    left: c,
    x: c,
    y: d
  };
}
function Wi(e) {
  var t = _t(e), i = e.offsetWidth, s = e.offsetHeight;
  return Math.abs(t.width - i) <= 1 && (i = t.width), Math.abs(t.height - s) <= 1 && (s = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: i,
    height: s
  };
}
function an(e, t) {
  var i = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (i && Ui(i)) {
    var s = t;
    do {
      if (s && e.isSameNode(s))
        return !0;
      s = s.parentNode || s.host;
    } while (s);
  }
  return !1;
}
function je(e) {
  return we(e).getComputedStyle(e);
}
function lo(e) {
  return ["table", "td", "th"].indexOf(De(e)) >= 0;
}
function et(e) {
  return ((at(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function fi(e) {
  return De(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Ui(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    et(e)
  );
}
function bs(e) {
  return !Te(e) || // https://github.com/popperjs/popper-core/issues/837
  je(e).position === "fixed" ? null : e.offsetParent;
}
function co(e) {
  var t = /firefox/i.test(Di()), i = /Trident/i.test(Di());
  if (i && Te(e)) {
    var s = je(e);
    if (s.position === "fixed")
      return null;
  }
  var n = fi(e);
  for (Ui(n) && (n = n.host); Te(n) && ["html", "body"].indexOf(De(n)) < 0; ) {
    var r = je(n);
    if (r.transform !== "none" || r.perspective !== "none" || r.contain === "paint" || ["transform", "perspective"].indexOf(r.willChange) !== -1 || t && r.willChange === "filter" || t && r.filter && r.filter !== "none")
      return n;
    n = n.parentNode;
  }
  return null;
}
function Dt(e) {
  for (var t = we(e), i = bs(e); i && lo(i) && je(i).position === "static"; )
    i = bs(i);
  return i && (De(i) === "html" || De(i) === "body" && je(i).position === "static") ? t : i || co(e) || t;
}
function Yi(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function kt(e, t, i) {
  return rt(e, ii(t, i));
}
function uo(e, t, i) {
  var s = kt(e, t, i);
  return s > i ? i : s;
}
function on() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function ln(e) {
  return Object.assign({}, on(), e);
}
function cn(e, t) {
  return t.reduce(function(i, s) {
    return i[s] = e, i;
  }, {});
}
var fo = function(t, i) {
  return t = typeof t == "function" ? t(Object.assign({}, i.rects, {
    placement: i.placement
  })) : t, ln(typeof t != "number" ? t : cn(t, Pt));
};
function po(e) {
  var t, i = e.state, s = e.name, n = e.options, r = i.elements.arrow, a = i.modifiersData.popperOffsets, o = Le(i.placement), l = Yi(o), c = [ge, ke].indexOf(o) >= 0, d = c ? "height" : "width";
  if (!(!r || !a)) {
    var f = fo(n.padding, i), h = Wi(r), g = l === "y" ? me : ge, m = l === "y" ? Ne : ke, b = i.rects.reference[d] + i.rects.reference[l] - a[l] - i.rects.popper[d], E = a[l] - i.rects.reference[l], x = Dt(r), p = x ? l === "y" ? x.clientHeight || 0 : x.clientWidth || 0 : 0, _ = b / 2 - E / 2, w = f[g], v = p - h[d] - f[m], y = p / 2 - h[d] / 2 + _, S = kt(w, y, v), N = l;
    i.modifiersData[s] = (t = {}, t[N] = S, t.centerOffset = S - y, t);
  }
}
function ho(e) {
  var t = e.state, i = e.options, s = i.element, n = s === void 0 ? "[data-popper-arrow]" : s;
  n != null && (typeof n == "string" && (n = t.elements.popper.querySelector(n), !n) || an(t.elements.popper, n) && (t.elements.arrow = n));
}
const mo = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: po,
  effect: ho,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function vt(e) {
  return e.split("-")[1];
}
var go = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function _o(e, t) {
  var i = e.x, s = e.y, n = t.devicePixelRatio || 1;
  return {
    x: gt(i * n) / n || 0,
    y: gt(s * n) / n || 0
  };
}
function ys(e) {
  var t, i = e.popper, s = e.popperRect, n = e.placement, r = e.variation, a = e.offsets, o = e.position, l = e.gpuAcceleration, c = e.adaptive, d = e.roundOffsets, f = e.isFixed, h = a.x, g = h === void 0 ? 0 : h, m = a.y, b = m === void 0 ? 0 : m, E = typeof d == "function" ? d({
    x: g,
    y: b
  }) : {
    x: g,
    y: b
  };
  g = E.x, b = E.y;
  var x = a.hasOwnProperty("x"), p = a.hasOwnProperty("y"), _ = ge, w = me, v = window;
  if (c) {
    var y = Dt(i), S = "clientHeight", N = "clientWidth";
    if (y === we(i) && (y = et(i), je(y).position !== "static" && o === "absolute" && (S = "scrollHeight", N = "scrollWidth")), y = y, n === me || (n === ge || n === ke) && r === Ct) {
      w = Ne;
      var R = f && y === v && v.visualViewport ? v.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        y[S]
      );
      b -= R - s.height, b *= l ? 1 : -1;
    }
    if (n === ge || (n === me || n === Ne) && r === Ct) {
      _ = ke;
      var A = f && y === v && v.visualViewport ? v.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        y[N]
      );
      g -= A - s.width, g *= l ? 1 : -1;
    }
  }
  var C = Object.assign({
    position: o
  }, c && go), P = d === !0 ? _o({
    x: g,
    y: b
  }, we(i)) : {
    x: g,
    y: b
  };
  if (g = P.x, b = P.y, l) {
    var D;
    return Object.assign({}, C, (D = {}, D[w] = p ? "0" : "", D[_] = x ? "0" : "", D.transform = (v.devicePixelRatio || 1) <= 1 ? "translate(" + g + "px, " + b + "px)" : "translate3d(" + g + "px, " + b + "px, 0)", D));
  }
  return Object.assign({}, C, (t = {}, t[w] = p ? b + "px" : "", t[_] = x ? g + "px" : "", t.transform = "", t));
}
function vo(e) {
  var t = e.state, i = e.options, s = i.gpuAcceleration, n = s === void 0 ? !0 : s, r = i.adaptive, a = r === void 0 ? !0 : r, o = i.roundOffsets, l = o === void 0 ? !0 : o, c = {
    placement: Le(t.placement),
    variation: vt(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: n,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, ys(Object.assign({}, c, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: a,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, ys(Object.assign({}, c, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const wo = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: vo,
  data: {}
};
var Ht = {
  passive: !0
};
function bo(e) {
  var t = e.state, i = e.instance, s = e.options, n = s.scroll, r = n === void 0 ? !0 : n, a = s.resize, o = a === void 0 ? !0 : a, l = we(t.elements.popper), c = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return r && c.forEach(function(d) {
    d.addEventListener("scroll", i.update, Ht);
  }), o && l.addEventListener("resize", i.update, Ht), function() {
    r && c.forEach(function(d) {
      d.removeEventListener("scroll", i.update, Ht);
    }), o && l.removeEventListener("resize", i.update, Ht);
  };
}
const yo = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: bo,
  data: {}
};
var Eo = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Yt(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return Eo[t];
  });
}
var xo = {
  start: "end",
  end: "start"
};
function Es(e) {
  return e.replace(/start|end/g, function(t) {
    return xo[t];
  });
}
function Xi(e) {
  var t = we(e), i = t.pageXOffset, s = t.pageYOffset;
  return {
    scrollLeft: i,
    scrollTop: s
  };
}
function Zi(e) {
  return _t(et(e)).left + Xi(e).scrollLeft;
}
function So(e, t) {
  var i = we(e), s = et(e), n = i.visualViewport, r = s.clientWidth, a = s.clientHeight, o = 0, l = 0;
  if (n) {
    r = n.width, a = n.height;
    var c = rn();
    (c || !c && t === "fixed") && (o = n.offsetLeft, l = n.offsetTop);
  }
  return {
    width: r,
    height: a,
    x: o + Zi(e),
    y: l
  };
}
function To(e) {
  var t, i = et(e), s = Xi(e), n = (t = e.ownerDocument) == null ? void 0 : t.body, r = rt(i.scrollWidth, i.clientWidth, n ? n.scrollWidth : 0, n ? n.clientWidth : 0), a = rt(i.scrollHeight, i.clientHeight, n ? n.scrollHeight : 0, n ? n.clientHeight : 0), o = -s.scrollLeft + Zi(e), l = -s.scrollTop;
  return je(n || i).direction === "rtl" && (o += rt(i.clientWidth, n ? n.clientWidth : 0) - r), {
    width: r,
    height: a,
    x: o,
    y: l
  };
}
function Ki(e) {
  var t = je(e), i = t.overflow, s = t.overflowX, n = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(i + n + s);
}
function dn(e) {
  return ["html", "body", "#document"].indexOf(De(e)) >= 0 ? e.ownerDocument.body : Te(e) && Ki(e) ? e : dn(fi(e));
}
function At(e, t) {
  var i;
  t === void 0 && (t = []);
  var s = dn(e), n = s === ((i = e.ownerDocument) == null ? void 0 : i.body), r = we(s), a = n ? [r].concat(r.visualViewport || [], Ki(s) ? s : []) : s, o = t.concat(a);
  return n ? o : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    o.concat(At(fi(a)))
  );
}
function $i(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function No(e, t) {
  var i = _t(e, !1, t === "fixed");
  return i.top = i.top + e.clientTop, i.left = i.left + e.clientLeft, i.bottom = i.top + e.clientHeight, i.right = i.left + e.clientWidth, i.width = e.clientWidth, i.height = e.clientHeight, i.x = i.left, i.y = i.top, i;
}
function xs(e, t, i) {
  return t === sn ? $i(So(e, i)) : at(t) ? No(t, i) : $i(To(et(e)));
}
function ko(e) {
  var t = At(fi(e)), i = ["absolute", "fixed"].indexOf(je(e).position) >= 0, s = i && Te(e) ? Dt(e) : e;
  return at(s) ? t.filter(function(n) {
    return at(n) && an(n, s) && De(n) !== "body";
  }) : [];
}
function Ao(e, t, i, s) {
  var n = t === "clippingParents" ? ko(e) : [].concat(t), r = [].concat(n, [i]), a = r[0], o = r.reduce(function(l, c) {
    var d = xs(e, c, s);
    return l.top = rt(d.top, l.top), l.right = ii(d.right, l.right), l.bottom = ii(d.bottom, l.bottom), l.left = rt(d.left, l.left), l;
  }, xs(e, a, s));
  return o.width = o.right - o.left, o.height = o.bottom - o.top, o.x = o.left, o.y = o.top, o;
}
function un(e) {
  var t = e.reference, i = e.element, s = e.placement, n = s ? Le(s) : null, r = s ? vt(s) : null, a = t.x + t.width / 2 - i.width / 2, o = t.y + t.height / 2 - i.height / 2, l;
  switch (n) {
    case me:
      l = {
        x: a,
        y: t.y - i.height
      };
      break;
    case Ne:
      l = {
        x: a,
        y: t.y + t.height
      };
      break;
    case ke:
      l = {
        x: t.x + t.width,
        y: o
      };
      break;
    case ge:
      l = {
        x: t.x - i.width,
        y: o
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var c = n ? Yi(n) : null;
  if (c != null) {
    var d = c === "y" ? "height" : "width";
    switch (r) {
      case mt:
        l[c] = l[c] - (t[d] / 2 - i[d] / 2);
        break;
      case Ct:
        l[c] = l[c] + (t[d] / 2 - i[d] / 2);
        break;
    }
  }
  return l;
}
function It(e, t) {
  t === void 0 && (t = {});
  var i = t, s = i.placement, n = s === void 0 ? e.placement : s, r = i.strategy, a = r === void 0 ? e.strategy : r, o = i.boundary, l = o === void 0 ? Wa : o, c = i.rootBoundary, d = c === void 0 ? sn : c, f = i.elementContext, h = f === void 0 ? yt : f, g = i.altBoundary, m = g === void 0 ? !1 : g, b = i.padding, E = b === void 0 ? 0 : b, x = ln(typeof E != "number" ? E : cn(E, Pt)), p = h === yt ? Ya : yt, _ = e.rects.popper, w = e.elements[m ? p : h], v = Ao(at(w) ? w : w.contextElement || et(e.elements.popper), l, d, a), y = _t(e.elements.reference), S = un({
    reference: y,
    element: _,
    strategy: "absolute",
    placement: n
  }), N = $i(Object.assign({}, _, S)), R = h === yt ? N : y, A = {
    top: v.top - R.top + x.top,
    bottom: R.bottom - v.bottom + x.bottom,
    left: v.left - R.left + x.left,
    right: R.right - v.right + x.right
  }, C = e.modifiersData.offset;
  if (h === yt && C) {
    var P = C[n];
    Object.keys(A).forEach(function(D) {
      var B = [ke, Ne].indexOf(D) >= 0 ? 1 : -1, z = [me, Ne].indexOf(D) >= 0 ? "y" : "x";
      A[D] += P[z] * B;
    });
  }
  return A;
}
function Mo(e, t) {
  t === void 0 && (t = {});
  var i = t, s = i.placement, n = i.boundary, r = i.rootBoundary, a = i.padding, o = i.flipVariations, l = i.allowedAutoPlacements, c = l === void 0 ? nn : l, d = vt(s), f = d ? o ? ws : ws.filter(function(m) {
    return vt(m) === d;
  }) : Pt, h = f.filter(function(m) {
    return c.indexOf(m) >= 0;
  });
  h.length === 0 && (h = f);
  var g = h.reduce(function(m, b) {
    return m[b] = It(e, {
      placement: b,
      boundary: n,
      rootBoundary: r,
      padding: a
    })[Le(b)], m;
  }, {});
  return Object.keys(g).sort(function(m, b) {
    return g[m] - g[b];
  });
}
function Co(e) {
  if (Le(e) === ji)
    return [];
  var t = Yt(e);
  return [Es(e), t, Es(t)];
}
function Io(e) {
  var t = e.state, i = e.options, s = e.name;
  if (!t.modifiersData[s]._skip) {
    for (var n = i.mainAxis, r = n === void 0 ? !0 : n, a = i.altAxis, o = a === void 0 ? !0 : a, l = i.fallbackPlacements, c = i.padding, d = i.boundary, f = i.rootBoundary, h = i.altBoundary, g = i.flipVariations, m = g === void 0 ? !0 : g, b = i.allowedAutoPlacements, E = t.options.placement, x = Le(E), p = x === E, _ = l || (p || !m ? [Yt(E)] : Co(E)), w = [E].concat(_).reduce(function($e, le) {
      return $e.concat(Le(le) === ji ? Mo(t, {
        placement: le,
        boundary: d,
        rootBoundary: f,
        padding: c,
        flipVariations: m,
        allowedAutoPlacements: b
      }) : le);
    }, []), v = t.rects.reference, y = t.rects.popper, S = /* @__PURE__ */ new Map(), N = !0, R = w[0], A = 0; A < w.length; A++) {
      var C = w[A], P = Le(C), D = vt(C) === mt, B = [me, Ne].indexOf(P) >= 0, z = B ? "width" : "height", L = It(t, {
        placement: C,
        boundary: d,
        rootBoundary: f,
        altBoundary: h,
        padding: c
      }), k = B ? D ? ke : ge : D ? Ne : me;
      v[z] > y[z] && (k = Yt(k));
      var I = Yt(k), $ = [];
      if (r && $.push(L[P] <= 0), o && $.push(L[k] <= 0, L[I] <= 0), $.every(function($e) {
        return $e;
      })) {
        R = C, N = !1;
        break;
      }
      S.set(C, $);
    }
    if (N)
      for (var q = m ? 3 : 1, te = function(le) {
        var ze = w.find(function(ot) {
          var Ve = S.get(ot);
          if (Ve)
            return Ve.slice(0, le).every(function(mi) {
              return mi;
            });
        });
        if (ze)
          return R = ze, "break";
      }, K = q; K > 0; K--) {
        var ie = te(K);
        if (ie === "break") break;
      }
    t.placement !== R && (t.modifiersData[s]._skip = !0, t.placement = R, t.reset = !0);
  }
}
const Ro = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Io,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Ss(e, t, i) {
  return i === void 0 && (i = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - i.y,
    right: e.right - t.width + i.x,
    bottom: e.bottom - t.height + i.y,
    left: e.left - t.width - i.x
  };
}
function Ts(e) {
  return [me, ke, Ne, ge].some(function(t) {
    return e[t] >= 0;
  });
}
function Oo(e) {
  var t = e.state, i = e.name, s = t.rects.reference, n = t.rects.popper, r = t.modifiersData.preventOverflow, a = It(t, {
    elementContext: "reference"
  }), o = It(t, {
    altBoundary: !0
  }), l = Ss(a, s), c = Ss(o, n, r), d = Ts(l), f = Ts(c);
  t.modifiersData[i] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: c,
    isReferenceHidden: d,
    hasPopperEscaped: f
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": f
  });
}
const Lo = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Oo
};
function Po(e, t, i) {
  var s = Le(e), n = [ge, me].indexOf(s) >= 0 ? -1 : 1, r = typeof i == "function" ? i(Object.assign({}, t, {
    placement: e
  })) : i, a = r[0], o = r[1];
  return a = a || 0, o = (o || 0) * n, [ge, ke].indexOf(s) >= 0 ? {
    x: o,
    y: a
  } : {
    x: a,
    y: o
  };
}
function Do(e) {
  var t = e.state, i = e.options, s = e.name, n = i.offset, r = n === void 0 ? [0, 0] : n, a = nn.reduce(function(d, f) {
    return d[f] = Po(f, t.rects, r), d;
  }, {}), o = a[t.placement], l = o.x, c = o.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += c), t.modifiersData[s] = a;
}
const $o = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Do
};
function zo(e) {
  var t = e.state, i = e.name;
  t.modifiersData[i] = un({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const Vo = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: zo,
  data: {}
};
function Bo(e) {
  return e === "x" ? "y" : "x";
}
function Ho(e) {
  var t = e.state, i = e.options, s = e.name, n = i.mainAxis, r = n === void 0 ? !0 : n, a = i.altAxis, o = a === void 0 ? !1 : a, l = i.boundary, c = i.rootBoundary, d = i.altBoundary, f = i.padding, h = i.tether, g = h === void 0 ? !0 : h, m = i.tetherOffset, b = m === void 0 ? 0 : m, E = It(t, {
    boundary: l,
    rootBoundary: c,
    padding: f,
    altBoundary: d
  }), x = Le(t.placement), p = vt(t.placement), _ = !p, w = Yi(x), v = Bo(w), y = t.modifiersData.popperOffsets, S = t.rects.reference, N = t.rects.popper, R = typeof b == "function" ? b(Object.assign({}, t.rects, {
    placement: t.placement
  })) : b, A = typeof R == "number" ? {
    mainAxis: R,
    altAxis: R
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, R), C = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, P = {
    x: 0,
    y: 0
  };
  if (y) {
    if (r) {
      var D, B = w === "y" ? me : ge, z = w === "y" ? Ne : ke, L = w === "y" ? "height" : "width", k = y[w], I = k + E[B], $ = k - E[z], q = g ? -N[L] / 2 : 0, te = p === mt ? S[L] : N[L], K = p === mt ? -N[L] : -S[L], ie = t.elements.arrow, $e = g && ie ? Wi(ie) : {
        width: 0,
        height: 0
      }, le = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : on(), ze = le[B], ot = le[z], Ve = kt(0, S[L], $e[L]), mi = _ ? S[L] / 2 - q - Ve - ze - A.mainAxis : te - Ve - ze - A.mainAxis, Rn = _ ? -S[L] / 2 + q + Ve + ot + A.mainAxis : K + Ve + ot + A.mainAxis, gi = t.elements.arrow && Dt(t.elements.arrow), On = gi ? w === "y" ? gi.clientTop || 0 : gi.clientLeft || 0 : 0, ss = (D = C == null ? void 0 : C[w]) != null ? D : 0, Ln = k + mi - ss - On, Pn = k + Rn - ss, ns = kt(g ? ii(I, Ln) : I, k, g ? rt($, Pn) : $);
      y[w] = ns, P[w] = ns - k;
    }
    if (o) {
      var rs, Dn = w === "x" ? me : ge, $n = w === "x" ? Ne : ke, tt = y[v], $t = v === "y" ? "height" : "width", as = tt + E[Dn], os = tt - E[$n], _i = [me, ge].indexOf(x) !== -1, ls = (rs = C == null ? void 0 : C[v]) != null ? rs : 0, cs = _i ? as : tt - S[$t] - N[$t] - ls + A.altAxis, ds = _i ? tt + S[$t] + N[$t] - ls - A.altAxis : os, us = g && _i ? uo(cs, tt, ds) : kt(g ? cs : as, tt, g ? ds : os);
      y[v] = us, P[v] = us - tt;
    }
    t.modifiersData[s] = P;
  }
}
const Fo = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Ho,
  requiresIfExists: ["offset"]
};
function Go(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function qo(e) {
  return e === we(e) || !Te(e) ? Xi(e) : Go(e);
}
function jo(e) {
  var t = e.getBoundingClientRect(), i = gt(t.width) / e.offsetWidth || 1, s = gt(t.height) / e.offsetHeight || 1;
  return i !== 1 || s !== 1;
}
function Uo(e, t, i) {
  i === void 0 && (i = !1);
  var s = Te(t), n = Te(t) && jo(t), r = et(t), a = _t(e, n, i), o = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (s || !s && !i) && ((De(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Ki(r)) && (o = qo(t)), Te(t) ? (l = _t(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : r && (l.x = Zi(r))), {
    x: a.left + o.scrollLeft - l.x,
    y: a.top + o.scrollTop - l.y,
    width: a.width,
    height: a.height
  };
}
function Wo(e) {
  var t = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Set(), s = [];
  e.forEach(function(r) {
    t.set(r.name, r);
  });
  function n(r) {
    i.add(r.name);
    var a = [].concat(r.requires || [], r.requiresIfExists || []);
    a.forEach(function(o) {
      if (!i.has(o)) {
        var l = t.get(o);
        l && n(l);
      }
    }), s.push(r);
  }
  return e.forEach(function(r) {
    i.has(r.name) || n(r);
  }), s;
}
function Yo(e) {
  var t = Wo(e);
  return no.reduce(function(i, s) {
    return i.concat(t.filter(function(n) {
      return n.phase === s;
    }));
  }, []);
}
function Xo(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(i) {
      Promise.resolve().then(function() {
        t = void 0, i(e());
      });
    })), t;
  };
}
function Zo(e) {
  var t = e.reduce(function(i, s) {
    var n = i[s.name];
    return i[s.name] = n ? Object.assign({}, n, s, {
      options: Object.assign({}, n.options, s.options),
      data: Object.assign({}, n.data, s.data)
    }) : s, i;
  }, {});
  return Object.keys(t).map(function(i) {
    return t[i];
  });
}
var Ns = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function ks() {
  for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
    t[i] = arguments[i];
  return !t.some(function(s) {
    return !(s && typeof s.getBoundingClientRect == "function");
  });
}
function Ko(e) {
  e === void 0 && (e = {});
  var t = e, i = t.defaultModifiers, s = i === void 0 ? [] : i, n = t.defaultOptions, r = n === void 0 ? Ns : n;
  return function(o, l, c) {
    c === void 0 && (c = r);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Ns, r),
      modifiersData: {},
      elements: {
        reference: o,
        popper: l
      },
      attributes: {},
      styles: {}
    }, f = [], h = !1, g = {
      state: d,
      setOptions: function(x) {
        var p = typeof x == "function" ? x(d.options) : x;
        b(), d.options = Object.assign({}, r, d.options, p), d.scrollParents = {
          reference: at(o) ? At(o) : o.contextElement ? At(o.contextElement) : [],
          popper: At(l)
        };
        var _ = Yo(Zo([].concat(s, d.options.modifiers)));
        return d.orderedModifiers = _.filter(function(w) {
          return w.enabled;
        }), m(), g.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!h) {
          var x = d.elements, p = x.reference, _ = x.popper;
          if (ks(p, _)) {
            d.rects = {
              reference: Uo(p, Dt(_), d.options.strategy === "fixed"),
              popper: Wi(_)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(A) {
              return d.modifiersData[A.name] = Object.assign({}, A.data);
            });
            for (var w = 0; w < d.orderedModifiers.length; w++) {
              if (d.reset === !0) {
                d.reset = !1, w = -1;
                continue;
              }
              var v = d.orderedModifiers[w], y = v.fn, S = v.options, N = S === void 0 ? {} : S, R = v.name;
              typeof y == "function" && (d = y({
                state: d,
                options: N,
                name: R,
                instance: g
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Xo(function() {
        return new Promise(function(E) {
          g.forceUpdate(), E(d);
        });
      }),
      destroy: function() {
        b(), h = !0;
      }
    };
    if (!ks(o, l))
      return g;
    g.setOptions(c).then(function(E) {
      !h && c.onFirstUpdate && c.onFirstUpdate(E);
    });
    function m() {
      d.orderedModifiers.forEach(function(E) {
        var x = E.name, p = E.options, _ = p === void 0 ? {} : p, w = E.effect;
        if (typeof w == "function") {
          var v = w({
            state: d,
            name: x,
            instance: g,
            options: _
          }), y = function() {
          };
          f.push(v || y);
        }
      });
    }
    function b() {
      f.forEach(function(E) {
        return E();
      }), f = [];
    }
    return g;
  };
}
var Qo = [yo, Vo, wo, oo, $o, Ro, Fo, mo, Lo], Jo = /* @__PURE__ */ Ko({
  defaultModifiers: Qo
});
function el(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var bi, As;
function tl() {
  if (As) return bi;
  As = 1;
  var e = typeof Element < "u", t = typeof Map == "function", i = typeof Set == "function", s = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
  function n(r, a) {
    if (r === a) return !0;
    if (r && a && typeof r == "object" && typeof a == "object") {
      if (r.constructor !== a.constructor) return !1;
      var o, l, c;
      if (Array.isArray(r)) {
        if (o = r.length, o != a.length) return !1;
        for (l = o; l-- !== 0; )
          if (!n(r[l], a[l])) return !1;
        return !0;
      }
      var d;
      if (t && r instanceof Map && a instanceof Map) {
        if (r.size !== a.size) return !1;
        for (d = r.entries(); !(l = d.next()).done; )
          if (!a.has(l.value[0])) return !1;
        for (d = r.entries(); !(l = d.next()).done; )
          if (!n(l.value[1], a.get(l.value[0]))) return !1;
        return !0;
      }
      if (i && r instanceof Set && a instanceof Set) {
        if (r.size !== a.size) return !1;
        for (d = r.entries(); !(l = d.next()).done; )
          if (!a.has(l.value[0])) return !1;
        return !0;
      }
      if (s && ArrayBuffer.isView(r) && ArrayBuffer.isView(a)) {
        if (o = r.length, o != a.length) return !1;
        for (l = o; l-- !== 0; )
          if (r[l] !== a[l]) return !1;
        return !0;
      }
      if (r.constructor === RegExp) return r.source === a.source && r.flags === a.flags;
      if (r.valueOf !== Object.prototype.valueOf && typeof r.valueOf == "function" && typeof a.valueOf == "function") return r.valueOf() === a.valueOf();
      if (r.toString !== Object.prototype.toString && typeof r.toString == "function" && typeof a.toString == "function") return r.toString() === a.toString();
      if (c = Object.keys(r), o = c.length, o !== Object.keys(a).length) return !1;
      for (l = o; l-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(a, c[l])) return !1;
      if (e && r instanceof Element) return !1;
      for (l = o; l-- !== 0; )
        if (!((c[l] === "_owner" || c[l] === "__v" || c[l] === "__o") && r.$$typeof) && !n(r[c[l]], a[c[l]]))
          return !1;
      return !0;
    }
    return r !== r && a !== a;
  }
  return bi = function(a, o) {
    try {
      return n(a, o);
    } catch (l) {
      if ((l.message || "").match(/stack|recursion/i))
        return console.warn("react-fast-compare cannot handle circular refs"), !1;
      throw l;
    }
  }, bi;
}
var il = tl();
const sl = /* @__PURE__ */ el(il);
var nl = [], rl = function(t, i, s) {
  s === void 0 && (s = {});
  var n = T.useRef(null), r = {
    onFirstUpdate: s.onFirstUpdate,
    placement: s.placement || "bottom",
    strategy: s.strategy || "absolute",
    modifiers: s.modifiers || nl
  }, a = T.useState({
    styles: {
      popper: {
        position: r.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), o = a[0], l = a[1], c = T.useMemo(function() {
    return {
      name: "updateState",
      enabled: !0,
      phase: "write",
      fn: function(g) {
        var m = g.state, b = Object.keys(m.elements);
        Bn.flushSync(function() {
          l({
            styles: _s(b.map(function(E) {
              return [E, m.styles[E] || {}];
            })),
            attributes: _s(b.map(function(E) {
              return [E, m.attributes[E]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []), d = T.useMemo(function() {
    var h = {
      onFirstUpdate: r.onFirstUpdate,
      placement: r.placement,
      strategy: r.strategy,
      modifiers: [].concat(r.modifiers, [c, {
        name: "applyStyles",
        enabled: !1
      }])
    };
    return sl(n.current, h) ? n.current || h : (n.current = h, h);
  }, [r.onFirstUpdate, r.placement, r.strategy, r.modifiers, c]), f = T.useRef();
  return vs(function() {
    f.current && f.current.setOptions(d);
  }, [d]), vs(function() {
    if (!(t == null || i == null)) {
      var h = s.createPopper || Jo, g = h(t, i, d);
      return f.current = g, function() {
        g.destroy(), f.current = null;
      };
    }
  }, [t, i, s.createPopper]), {
    state: f.current ? f.current.state : null,
    styles: o.styles,
    attributes: o.attributes,
    update: f.current ? f.current.update : null,
    forceUpdate: f.current ? f.current.forceUpdate : null
  };
};
const Qi = (e) => {
  G(() => {
    const t = (i) => {
      i.key === "Escape" && e(null);
    };
    return window.addEventListener("keydown", t), () => {
      window.removeEventListener("keydown", t);
    };
  }, [e]);
}, al = 20, ol = 18, Ji = ({ children: e, height: t = ol, ariaLabel: i }) => {
  const [s, n] = V(!1), [r, a] = V(null), [o, l] = V(null), [c, d] = V(null);
  Qi(n);
  const {
    styles: f,
    attributes: h,
    update: g
  } = rl(r, o, {
    placement: "bottom",
    modifiers: [
      { name: "arrow", options: { element: c } },
      { name: "offset", options: { offset: [0, al] } }
    ]
  }), m = () => {
    n(!s), setTimeout(() => {
      g == null || g();
    }, 0);
  }, b = () => {
    n(!0), setTimeout(() => {
      g == null || g();
    }, 0);
  }, E = () => {
    n(!1);
  };
  return /* @__PURE__ */ M("div", { className: st.tooltip, children: [
    /* @__PURE__ */ u(
      "button",
      {
        ref: a,
        type: "button",
        className: O(st.tooltip__icon, s && st["tooltip__icon--active"]),
        "aria-label": i,
        onClick: m,
        onMouseEnter: b,
        onMouseLeave: E,
        onBlur: () => n(!1),
        children: /* @__PURE__ */ u(F, { icon: "info", height: `${Pe(t)}rem` })
      }
    ),
    /* @__PURE__ */ M(
      "div",
      {
        role: "status",
        ref: l,
        style: f.popper,
        ...h.popper,
        className: O(st.tooltip__content, s && st["tooltip__content--open"]),
        children: [
          /* @__PURE__ */ u("div", { className: st.tooltip__text, children: e }),
          /* @__PURE__ */ u("div", { ref: d, style: f.arrow, className: st.tooltip__arrow })
        ]
      }
    )
  ] });
}, Th = ({
  id: e,
  name: t,
  label: i,
  tooltip: s,
  tooltipAriaLabel: n,
  options: r,
  value: a,
  placeholder: o,
  error: l,
  hasError: c = !1,
  required: d = !1,
  disabled: f = !1,
  slot: h,
  onChange: g,
  onBlur: m
}) => {
  const b = `${e}-error`, E = (v) => {
    g && g(v.target.value);
  }, x = (v) => {
    v.key === "Enter" && v.currentTarget.click();
  }, p = O(
    Ae["roche-dropdown"],
    f && [Ae["roche-dropdown--disabled"]],
    (l || c) && [Ae["roche-dropdown--error"]]
  ), _ = O(
    Ae["roche-dropdown__select"],
    !a && o && [Ae["roche-dropdown__select--placeholder"]]
  ), w = !!(l || c);
  return /* @__PURE__ */ M("div", { className: p, slot: h, children: [
    i && /* @__PURE__ */ M("div", { className: Ae["roche-dropdown__label-wrapper"], children: [
      /* @__PURE__ */ u("label", { htmlFor: e, className: Ae["roche-dropdown__label"], children: i }),
      s && /* @__PURE__ */ u(Ji, { ariaLabel: n, children: s })
    ] }),
    /* @__PURE__ */ M("div", { className: Ae["roche-dropdown__container"], children: [
      /* @__PURE__ */ M(
        "select",
        {
          id: e,
          name: t,
          value: a || "",
          required: d,
          disabled: f,
          onChange: E,
          onBlur: m,
          onKeyDown: x,
          className: _,
          "aria-invalid": w,
          "aria-describedby": w ? b : void 0,
          children: [
            /* @__PURE__ */ u("option", { value: "", disabled: !0, children: o }),
            r.map((v) => /* @__PURE__ */ u("option", { value: v.value, children: v.label }, v.value))
          ]
        }
      ),
      /* @__PURE__ */ u("div", { className: Ae["roche-dropdown__icon"], children: /* @__PURE__ */ u(F, { icon: "chevron-down", width: "16px", decorative: !0 }) })
    ] }),
    /* @__PURE__ */ u("div", { className: Ae["roche-dropdown__error"], children: l && /* @__PURE__ */ M(Qe, { children: [
      /* @__PURE__ */ u(F, { icon: "info", width: "16px", decorative: !0 }),
      /* @__PURE__ */ u("p", { id: b, role: "alert", className: Ae["roche-dropdown__error-text"], children: l })
    ] }) })
  ] });
}, Ms = (e) => {
  let t = e.toLowerCase();
  return t = t.normalize("NFD").replace(/[\u0300-\u036f]/g, ""), t = t.replace(/[^a-z0-9\s-]/g, ""), t = t.replace(/\s+/g, "-"), t = t.replace(/^-+|-+$/g, ""), t.match(/^\d/) && (t = "_" + t), t;
}, ll = "column", cl = "columns", dl = "grid", ul = "grid__column", fl = "teaser", pl = "grid__columns", hl = "image", ml = "headline", ye = {
  column: ll,
  columns: cl,
  "is-mobile": "is-mobile",
  "is-narrow": "is-narrow",
  "is-full": "is-full",
  "is-three-quarters": "is-three-quarters",
  "is-two-thirds": "is-two-thirds",
  "is-half": "is-half",
  "is-one-third": "is-one-third",
  "is-one-quarter": "is-one-quarter",
  "is-one-fifth": "is-one-fifth",
  "is-two-fifths": "is-two-fifths",
  "is-three-fifths": "is-three-fifths",
  "is-four-fifths": "is-four-fifths",
  "is-offset-three-quarters": "is-offset-three-quarters",
  "is-offset-two-thirds": "is-offset-two-thirds",
  "is-offset-half": "is-offset-half",
  "is-offset-one-third": "is-offset-one-third",
  "is-offset-one-quarter": "is-offset-one-quarter",
  "is-offset-one-fifth": "is-offset-one-fifth",
  "is-offset-two-fifths": "is-offset-two-fifths",
  "is-offset-three-fifths": "is-offset-three-fifths",
  "is-offset-four-fifths": "is-offset-four-fifths",
  "is-0": "is-0",
  "is-offset-0": "is-offset-0",
  "is-1": "is-1",
  "is-offset-1": "is-offset-1",
  "is-2": "is-2",
  "is-offset-2": "is-offset-2",
  "is-3": "is-3",
  "is-offset-3": "is-offset-3",
  "is-4": "is-4",
  "is-offset-4": "is-offset-4",
  "is-5": "is-5",
  "is-offset-5": "is-offset-5",
  "is-6": "is-6",
  "is-offset-6": "is-offset-6",
  "is-7": "is-7",
  "is-offset-7": "is-offset-7",
  "is-8": "is-8",
  "is-offset-8": "is-offset-8",
  "is-9": "is-9",
  "is-offset-9": "is-offset-9",
  "is-10": "is-10",
  "is-offset-10": "is-offset-10",
  "is-11": "is-11",
  "is-offset-11": "is-offset-11",
  "is-12": "is-12",
  "is-offset-12": "is-offset-12",
  "is-narrow-mobile": "is-narrow-mobile",
  "is-full-mobile": "is-full-mobile",
  "is-three-quarters-mobile": "is-three-quarters-mobile",
  "is-two-thirds-mobile": "is-two-thirds-mobile",
  "is-half-mobile": "is-half-mobile",
  "is-one-third-mobile": "is-one-third-mobile",
  "is-one-quarter-mobile": "is-one-quarter-mobile",
  "is-one-fifth-mobile": "is-one-fifth-mobile",
  "is-two-fifths-mobile": "is-two-fifths-mobile",
  "is-three-fifths-mobile": "is-three-fifths-mobile",
  "is-four-fifths-mobile": "is-four-fifths-mobile",
  "is-offset-three-quarters-mobile": "is-offset-three-quarters-mobile",
  "is-offset-two-thirds-mobile": "is-offset-two-thirds-mobile",
  "is-offset-half-mobile": "is-offset-half-mobile",
  "is-offset-one-third-mobile": "is-offset-one-third-mobile",
  "is-offset-one-quarter-mobile": "is-offset-one-quarter-mobile",
  "is-offset-one-fifth-mobile": "is-offset-one-fifth-mobile",
  "is-offset-two-fifths-mobile": "is-offset-two-fifths-mobile",
  "is-offset-three-fifths-mobile": "is-offset-three-fifths-mobile",
  "is-offset-four-fifths-mobile": "is-offset-four-fifths-mobile",
  "is-0-mobile": "is-0-mobile",
  "is-offset-0-mobile": "is-offset-0-mobile",
  "is-1-mobile": "is-1-mobile",
  "is-offset-1-mobile": "is-offset-1-mobile",
  "is-2-mobile": "is-2-mobile",
  "is-offset-2-mobile": "is-offset-2-mobile",
  "is-3-mobile": "is-3-mobile",
  "is-offset-3-mobile": "is-offset-3-mobile",
  "is-4-mobile": "is-4-mobile",
  "is-offset-4-mobile": "is-offset-4-mobile",
  "is-5-mobile": "is-5-mobile",
  "is-offset-5-mobile": "is-offset-5-mobile",
  "is-6-mobile": "is-6-mobile",
  "is-offset-6-mobile": "is-offset-6-mobile",
  "is-7-mobile": "is-7-mobile",
  "is-offset-7-mobile": "is-offset-7-mobile",
  "is-8-mobile": "is-8-mobile",
  "is-offset-8-mobile": "is-offset-8-mobile",
  "is-9-mobile": "is-9-mobile",
  "is-offset-9-mobile": "is-offset-9-mobile",
  "is-10-mobile": "is-10-mobile",
  "is-offset-10-mobile": "is-offset-10-mobile",
  "is-11-mobile": "is-11-mobile",
  "is-offset-11-mobile": "is-offset-11-mobile",
  "is-12-mobile": "is-12-mobile",
  "is-offset-12-mobile": "is-offset-12-mobile",
  "is-narrow-tablet": "is-narrow-tablet",
  "is-full-tablet": "is-full-tablet",
  "is-three-quarters-tablet": "is-three-quarters-tablet",
  "is-two-thirds-tablet": "is-two-thirds-tablet",
  "is-half-tablet": "is-half-tablet",
  "is-one-third-tablet": "is-one-third-tablet",
  "is-one-quarter-tablet": "is-one-quarter-tablet",
  "is-one-fifth-tablet": "is-one-fifth-tablet",
  "is-two-fifths-tablet": "is-two-fifths-tablet",
  "is-three-fifths-tablet": "is-three-fifths-tablet",
  "is-four-fifths-tablet": "is-four-fifths-tablet",
  "is-offset-three-quarters-tablet": "is-offset-three-quarters-tablet",
  "is-offset-two-thirds-tablet": "is-offset-two-thirds-tablet",
  "is-offset-half-tablet": "is-offset-half-tablet",
  "is-offset-one-third-tablet": "is-offset-one-third-tablet",
  "is-offset-one-quarter-tablet": "is-offset-one-quarter-tablet",
  "is-offset-one-fifth-tablet": "is-offset-one-fifth-tablet",
  "is-offset-two-fifths-tablet": "is-offset-two-fifths-tablet",
  "is-offset-three-fifths-tablet": "is-offset-three-fifths-tablet",
  "is-offset-four-fifths-tablet": "is-offset-four-fifths-tablet",
  "is-0-tablet": "is-0-tablet",
  "is-offset-0-tablet": "is-offset-0-tablet",
  "is-1-tablet": "is-1-tablet",
  "is-offset-1-tablet": "is-offset-1-tablet",
  "is-2-tablet": "is-2-tablet",
  "is-offset-2-tablet": "is-offset-2-tablet",
  "is-3-tablet": "is-3-tablet",
  "is-offset-3-tablet": "is-offset-3-tablet",
  "is-4-tablet": "is-4-tablet",
  "is-offset-4-tablet": "is-offset-4-tablet",
  "is-5-tablet": "is-5-tablet",
  "is-offset-5-tablet": "is-offset-5-tablet",
  "is-6-tablet": "is-6-tablet",
  "is-offset-6-tablet": "is-offset-6-tablet",
  "is-7-tablet": "is-7-tablet",
  "is-offset-7-tablet": "is-offset-7-tablet",
  "is-8-tablet": "is-8-tablet",
  "is-offset-8-tablet": "is-offset-8-tablet",
  "is-9-tablet": "is-9-tablet",
  "is-offset-9-tablet": "is-offset-9-tablet",
  "is-10-tablet": "is-10-tablet",
  "is-offset-10-tablet": "is-offset-10-tablet",
  "is-11-tablet": "is-11-tablet",
  "is-offset-11-tablet": "is-offset-11-tablet",
  "is-12-tablet": "is-12-tablet",
  "is-offset-12-tablet": "is-offset-12-tablet",
  "is-narrow-touch": "is-narrow-touch",
  "is-full-touch": "is-full-touch",
  "is-three-quarters-touch": "is-three-quarters-touch",
  "is-two-thirds-touch": "is-two-thirds-touch",
  "is-half-touch": "is-half-touch",
  "is-one-third-touch": "is-one-third-touch",
  "is-one-quarter-touch": "is-one-quarter-touch",
  "is-one-fifth-touch": "is-one-fifth-touch",
  "is-two-fifths-touch": "is-two-fifths-touch",
  "is-three-fifths-touch": "is-three-fifths-touch",
  "is-four-fifths-touch": "is-four-fifths-touch",
  "is-offset-three-quarters-touch": "is-offset-three-quarters-touch",
  "is-offset-two-thirds-touch": "is-offset-two-thirds-touch",
  "is-offset-half-touch": "is-offset-half-touch",
  "is-offset-one-third-touch": "is-offset-one-third-touch",
  "is-offset-one-quarter-touch": "is-offset-one-quarter-touch",
  "is-offset-one-fifth-touch": "is-offset-one-fifth-touch",
  "is-offset-two-fifths-touch": "is-offset-two-fifths-touch",
  "is-offset-three-fifths-touch": "is-offset-three-fifths-touch",
  "is-offset-four-fifths-touch": "is-offset-four-fifths-touch",
  "is-0-touch": "is-0-touch",
  "is-offset-0-touch": "is-offset-0-touch",
  "is-1-touch": "is-1-touch",
  "is-offset-1-touch": "is-offset-1-touch",
  "is-2-touch": "is-2-touch",
  "is-offset-2-touch": "is-offset-2-touch",
  "is-3-touch": "is-3-touch",
  "is-offset-3-touch": "is-offset-3-touch",
  "is-4-touch": "is-4-touch",
  "is-offset-4-touch": "is-offset-4-touch",
  "is-5-touch": "is-5-touch",
  "is-offset-5-touch": "is-offset-5-touch",
  "is-6-touch": "is-6-touch",
  "is-offset-6-touch": "is-offset-6-touch",
  "is-7-touch": "is-7-touch",
  "is-offset-7-touch": "is-offset-7-touch",
  "is-8-touch": "is-8-touch",
  "is-offset-8-touch": "is-offset-8-touch",
  "is-9-touch": "is-9-touch",
  "is-offset-9-touch": "is-offset-9-touch",
  "is-10-touch": "is-10-touch",
  "is-offset-10-touch": "is-offset-10-touch",
  "is-11-touch": "is-11-touch",
  "is-offset-11-touch": "is-offset-11-touch",
  "is-12-touch": "is-12-touch",
  "is-offset-12-touch": "is-offset-12-touch",
  "is-narrow-desktop": "is-narrow-desktop",
  "is-full-desktop": "is-full-desktop",
  "is-three-quarters-desktop": "is-three-quarters-desktop",
  "is-two-thirds-desktop": "is-two-thirds-desktop",
  "is-half-desktop": "is-half-desktop",
  "is-one-third-desktop": "is-one-third-desktop",
  "is-one-quarter-desktop": "is-one-quarter-desktop",
  "is-one-fifth-desktop": "is-one-fifth-desktop",
  "is-two-fifths-desktop": "is-two-fifths-desktop",
  "is-three-fifths-desktop": "is-three-fifths-desktop",
  "is-four-fifths-desktop": "is-four-fifths-desktop",
  "is-offset-three-quarters-desktop": "is-offset-three-quarters-desktop",
  "is-offset-two-thirds-desktop": "is-offset-two-thirds-desktop",
  "is-offset-half-desktop": "is-offset-half-desktop",
  "is-offset-one-third-desktop": "is-offset-one-third-desktop",
  "is-offset-one-quarter-desktop": "is-offset-one-quarter-desktop",
  "is-offset-one-fifth-desktop": "is-offset-one-fifth-desktop",
  "is-offset-two-fifths-desktop": "is-offset-two-fifths-desktop",
  "is-offset-three-fifths-desktop": "is-offset-three-fifths-desktop",
  "is-offset-four-fifths-desktop": "is-offset-four-fifths-desktop",
  "is-0-desktop": "is-0-desktop",
  "is-offset-0-desktop": "is-offset-0-desktop",
  "is-1-desktop": "is-1-desktop",
  "is-offset-1-desktop": "is-offset-1-desktop",
  "is-2-desktop": "is-2-desktop",
  "is-offset-2-desktop": "is-offset-2-desktop",
  "is-3-desktop": "is-3-desktop",
  "is-offset-3-desktop": "is-offset-3-desktop",
  "is-4-desktop": "is-4-desktop",
  "is-offset-4-desktop": "is-offset-4-desktop",
  "is-5-desktop": "is-5-desktop",
  "is-offset-5-desktop": "is-offset-5-desktop",
  "is-6-desktop": "is-6-desktop",
  "is-offset-6-desktop": "is-offset-6-desktop",
  "is-7-desktop": "is-7-desktop",
  "is-offset-7-desktop": "is-offset-7-desktop",
  "is-8-desktop": "is-8-desktop",
  "is-offset-8-desktop": "is-offset-8-desktop",
  "is-9-desktop": "is-9-desktop",
  "is-offset-9-desktop": "is-offset-9-desktop",
  "is-10-desktop": "is-10-desktop",
  "is-offset-10-desktop": "is-offset-10-desktop",
  "is-11-desktop": "is-11-desktop",
  "is-offset-11-desktop": "is-offset-11-desktop",
  "is-12-desktop": "is-12-desktop",
  "is-offset-12-desktop": "is-offset-12-desktop",
  "is-narrow-widescreen": "is-narrow-widescreen",
  "is-full-widescreen": "is-full-widescreen",
  "is-three-quarters-widescreen": "is-three-quarters-widescreen",
  "is-two-thirds-widescreen": "is-two-thirds-widescreen",
  "is-half-widescreen": "is-half-widescreen",
  "is-one-third-widescreen": "is-one-third-widescreen",
  "is-one-quarter-widescreen": "is-one-quarter-widescreen",
  "is-one-fifth-widescreen": "is-one-fifth-widescreen",
  "is-two-fifths-widescreen": "is-two-fifths-widescreen",
  "is-three-fifths-widescreen": "is-three-fifths-widescreen",
  "is-four-fifths-widescreen": "is-four-fifths-widescreen",
  "is-offset-three-quarters-widescreen": "is-offset-three-quarters-widescreen",
  "is-offset-two-thirds-widescreen": "is-offset-two-thirds-widescreen",
  "is-offset-half-widescreen": "is-offset-half-widescreen",
  "is-offset-one-third-widescreen": "is-offset-one-third-widescreen",
  "is-offset-one-quarter-widescreen": "is-offset-one-quarter-widescreen",
  "is-offset-one-fifth-widescreen": "is-offset-one-fifth-widescreen",
  "is-offset-two-fifths-widescreen": "is-offset-two-fifths-widescreen",
  "is-offset-three-fifths-widescreen": "is-offset-three-fifths-widescreen",
  "is-offset-four-fifths-widescreen": "is-offset-four-fifths-widescreen",
  "is-0-widescreen": "is-0-widescreen",
  "is-offset-0-widescreen": "is-offset-0-widescreen",
  "is-1-widescreen": "is-1-widescreen",
  "is-offset-1-widescreen": "is-offset-1-widescreen",
  "is-2-widescreen": "is-2-widescreen",
  "is-offset-2-widescreen": "is-offset-2-widescreen",
  "is-3-widescreen": "is-3-widescreen",
  "is-offset-3-widescreen": "is-offset-3-widescreen",
  "is-4-widescreen": "is-4-widescreen",
  "is-offset-4-widescreen": "is-offset-4-widescreen",
  "is-5-widescreen": "is-5-widescreen",
  "is-offset-5-widescreen": "is-offset-5-widescreen",
  "is-6-widescreen": "is-6-widescreen",
  "is-offset-6-widescreen": "is-offset-6-widescreen",
  "is-7-widescreen": "is-7-widescreen",
  "is-offset-7-widescreen": "is-offset-7-widescreen",
  "is-8-widescreen": "is-8-widescreen",
  "is-offset-8-widescreen": "is-offset-8-widescreen",
  "is-9-widescreen": "is-9-widescreen",
  "is-offset-9-widescreen": "is-offset-9-widescreen",
  "is-10-widescreen": "is-10-widescreen",
  "is-offset-10-widescreen": "is-offset-10-widescreen",
  "is-11-widescreen": "is-11-widescreen",
  "is-offset-11-widescreen": "is-offset-11-widescreen",
  "is-12-widescreen": "is-12-widescreen",
  "is-offset-12-widescreen": "is-offset-12-widescreen",
  "is-narrow-fullhd": "is-narrow-fullhd",
  "is-full-fullhd": "is-full-fullhd",
  "is-three-quarters-fullhd": "is-three-quarters-fullhd",
  "is-two-thirds-fullhd": "is-two-thirds-fullhd",
  "is-half-fullhd": "is-half-fullhd",
  "is-one-third-fullhd": "is-one-third-fullhd",
  "is-one-quarter-fullhd": "is-one-quarter-fullhd",
  "is-one-fifth-fullhd": "is-one-fifth-fullhd",
  "is-two-fifths-fullhd": "is-two-fifths-fullhd",
  "is-three-fifths-fullhd": "is-three-fifths-fullhd",
  "is-four-fifths-fullhd": "is-four-fifths-fullhd",
  "is-offset-three-quarters-fullhd": "is-offset-three-quarters-fullhd",
  "is-offset-two-thirds-fullhd": "is-offset-two-thirds-fullhd",
  "is-offset-half-fullhd": "is-offset-half-fullhd",
  "is-offset-one-third-fullhd": "is-offset-one-third-fullhd",
  "is-offset-one-quarter-fullhd": "is-offset-one-quarter-fullhd",
  "is-offset-one-fifth-fullhd": "is-offset-one-fifth-fullhd",
  "is-offset-two-fifths-fullhd": "is-offset-two-fifths-fullhd",
  "is-offset-three-fifths-fullhd": "is-offset-three-fifths-fullhd",
  "is-offset-four-fifths-fullhd": "is-offset-four-fifths-fullhd",
  "is-0-fullhd": "is-0-fullhd",
  "is-offset-0-fullhd": "is-offset-0-fullhd",
  "is-1-fullhd": "is-1-fullhd",
  "is-offset-1-fullhd": "is-offset-1-fullhd",
  "is-2-fullhd": "is-2-fullhd",
  "is-offset-2-fullhd": "is-offset-2-fullhd",
  "is-3-fullhd": "is-3-fullhd",
  "is-offset-3-fullhd": "is-offset-3-fullhd",
  "is-4-fullhd": "is-4-fullhd",
  "is-offset-4-fullhd": "is-offset-4-fullhd",
  "is-5-fullhd": "is-5-fullhd",
  "is-offset-5-fullhd": "is-offset-5-fullhd",
  "is-6-fullhd": "is-6-fullhd",
  "is-offset-6-fullhd": "is-offset-6-fullhd",
  "is-7-fullhd": "is-7-fullhd",
  "is-offset-7-fullhd": "is-offset-7-fullhd",
  "is-8-fullhd": "is-8-fullhd",
  "is-offset-8-fullhd": "is-offset-8-fullhd",
  "is-9-fullhd": "is-9-fullhd",
  "is-offset-9-fullhd": "is-offset-9-fullhd",
  "is-10-fullhd": "is-10-fullhd",
  "is-offset-10-fullhd": "is-offset-10-fullhd",
  "is-11-fullhd": "is-11-fullhd",
  "is-offset-11-fullhd": "is-offset-11-fullhd",
  "is-12-fullhd": "is-12-fullhd",
  "is-offset-12-fullhd": "is-offset-12-fullhd",
  "is-centered": "is-centered",
  "is-gapless": "is-gapless",
  "is-multiline": "is-multiline",
  "is-vcentered": "is-vcentered",
  "is-desktop": "is-desktop",
  "is-0-tablet-only": "is-0-tablet-only",
  "is-0-desktop-only": "is-0-desktop-only",
  "is-0-widescreen-only": "is-0-widescreen-only",
  "is-1-tablet-only": "is-1-tablet-only",
  "is-1-desktop-only": "is-1-desktop-only",
  "is-1-widescreen-only": "is-1-widescreen-only",
  "is-2-tablet-only": "is-2-tablet-only",
  "is-2-desktop-only": "is-2-desktop-only",
  "is-2-widescreen-only": "is-2-widescreen-only",
  "is-3-tablet-only": "is-3-tablet-only",
  "is-3-desktop-only": "is-3-desktop-only",
  "is-3-widescreen-only": "is-3-widescreen-only",
  "is-4-tablet-only": "is-4-tablet-only",
  "is-4-desktop-only": "is-4-desktop-only",
  "is-4-widescreen-only": "is-4-widescreen-only",
  "is-5-tablet-only": "is-5-tablet-only",
  "is-5-desktop-only": "is-5-desktop-only",
  "is-5-widescreen-only": "is-5-widescreen-only",
  "is-6-tablet-only": "is-6-tablet-only",
  "is-6-desktop-only": "is-6-desktop-only",
  "is-6-widescreen-only": "is-6-widescreen-only",
  "is-7-tablet-only": "is-7-tablet-only",
  "is-7-desktop-only": "is-7-desktop-only",
  "is-7-widescreen-only": "is-7-widescreen-only",
  "is-8-tablet-only": "is-8-tablet-only",
  "is-8-desktop-only": "is-8-desktop-only",
  "is-8-widescreen-only": "is-8-widescreen-only",
  grid: dl,
  "grid--hide-in-print-view": "grid--hide-in-print-view",
  "grid--no-padding": "grid--no-padding",
  "grid--extend-background-to-top": "grid--extend-background-to-top",
  "grid--has-breadcrumbs": "grid--has-breadcrumbs",
  "grid--has-staging-hero": "grid--has-staging-hero",
  "grid--move-to-back": "grid--move-to-back",
  "grid--overflow-visible": "grid--overflow-visible",
  "grid--equal-columns": "grid--equal-columns",
  grid__column: ul,
  teaser: fl,
  grid__columns: pl,
  "is-variable": "is-variable",
  "grid__columns--multiple-rows": "grid__columns--multiple-rows",
  "contact-person": "contact-person",
  image: hl,
  headline: ml,
  "headline--1": "headline--1",
  "headline--2": "headline--2",
  "headline--3": "headline--3",
  "headline--4": "headline--4",
  "headline--5": "headline--5",
  "headline--6": "headline--6",
  "disable-rtl": "disable-rtl"
}, gl = {
  "roche-grid-1-4-1-6": "1-4-1-6",
  "roche-grid-12": "12",
  "roche-grid-3-1-5-3": "3-1-5-3",
  "roche-grid-3-1-8": "3-1-8",
  "roche-grid-3-3-3-3": "3-3-3-3",
  "roche-grid-4-4-4": "4-4-4",
  "roche-grid-4-8": "4-8",
  "roche-grid-5-1-6": "5-1-6",
  "roche-grid-5-7": "5-7",
  "roche-grid-6-1-4-1": "6-1-4-1",
  "roche-grid-6-6": "6-6",
  "roche-grid-7-5": "7-5",
  "roche-grid-8-4": "8-4",
  "roche-grid-8": "8",
  "roche-grid-6": "6",
  "roche-grid-6-1-5": "6-1-5",
  "roche-grid-8-1-3": "8-1-3",
  "roche-grid-7-1-4": "7-1-4"
}, _l = {
  1: ["full"],
  2: ["left", "right"],
  3: ["left", "center", "right"],
  4: ["left", "center-left", "center-right", "right"]
}, fn = (e, t, i) => ({
  span: parseInt(e, 10),
  slotName: _l[i.length][t]
}), vl = (e) => e.split("-").map(fn), wl = (e) => e.split("-").reverse().map(fn), Cs = (e) => e === "roche-staging-hero", Is = (e) => e === "roche-story-staging-hero", bl = (e) => e === "roche-stage-home", yl = (e) => e.type === Va || e.type === "roche-breadcrumbs", El = (e) => e === "hero--variant-b", Et = ({
  layout: e,
  fullWidth: t,
  backgroundColor: i,
  hideInPrintView: s,
  isRightToLeft: n,
  noPadding: r,
  fullHeight: a,
  stagingHero: o,
  multipleRows: l,
  overflowVisible: c,
  children: d
}) => {
  const f = gl[e] || e, h = "columns is-centered is-variable is-0-mobile is-3-tablet is-4-desktop", g = vi.toArray(d), m = g.some((v) => wt(v) && yl(v)), b = g.some(
    (v) => {
      var y;
      return wt(v) && bl((y = v.props.blok) == null ? void 0 : y.component);
    }
  ), E = g.some(
    (v) => {
      var y, S;
      return wt(v) && (Cs((y = v.props.blok) == null ? void 0 : y.component) || Is((S = v.props.blok) == null ? void 0 : S.component));
    }
  ), x = g.some(
    (v) => {
      var y, S, N;
      return wt(v) && (Cs((y = v.props.blok) == null ? void 0 : y.component) || Is((S = v.props.blok) == null ? void 0 : S.component)) && El((N = v.props.blok) == null ? void 0 : N.variant) || o;
    }
  ), p = (v) => {
    const y = v.split("-");
    return y.every((S) => S === y[0]);
  }, _ = O(
    ye.grid,
    b && ye["grid--extend-background-to-top"],
    s && ye["grid--hide-in-print-view"],
    (r || E || b) && ye["grid--no-padding"],
    c && ye["grid--overflow-visible"],
    m && ye["grid--has-breadcrumbs"],
    (E || o) && ye["grid--has-staging-hero"],
    x && ye["grid--move-to-back"],
    p(f) && ye["grid--equal-columns"]
  );
  if (!vi)
    return null;
  const w = n ? wl(f).reverse() : vl(f);
  return /* @__PURE__ */ u("div", { className: _, children: /* @__PURE__ */ u(
    Ha,
    {
      fullWidth: t,
      color: i,
      fullHeight: a,
      extendBackgroundToTop: b,
      children: /* @__PURE__ */ u(
        "div",
        {
          className: `${O(
            ye.grid__columns,
            h,
            l && ye["grid__columns--multiple-rows"]
          )}`,
          children: w.map(({ span: v, slotName: y }, S) => /* @__PURE__ */ u("div", { className: `${ye.grid__column} column is-${v} is-offset-0`, children: vi.map(d, (N) => {
            if (wt(N) && N.props.slot === y)
              return N;
          }) }, S))
        }
      )
    }
  ) });
}, xl = "footer", Sl = "grid", Tl = "footer__copyright", Nl = "grid__column", ae = {
  footer: xl,
  "footer__first-row": "footer__first-row",
  grid: Sl,
  "footer__columns-container": "footer__columns-container",
  "footer__second-row": "footer__second-row",
  "footer__third-row": "footer__third-row",
  "footer__quick-links": "footer__quick-links",
  "footer__column-title": "footer__column-title",
  "footer__stock-price": "footer__stock-price",
  "footer__quick-links-nav": "footer__quick-links-nav",
  "footer__social-links-nav": "footer__social-links-nav",
  footer__copyright: Tl,
  "footer__social-links": "footer__social-links",
  "footer__service-links": "footer__service-links",
  "footer__legal-text": "footer__legal-text",
  "footer--with-extra-columns": "footer--with-extra-columns",
  "is-3": "is-3",
  "is-8": "is-8",
  grid__column: Nl,
  "is-1": "is-1",
  "is-3-tablet": "is-3-tablet",
  "is-4-desktop": "is-4-desktop",
  "is-4": "is-4"
}, kl = 3, Al = (e, t, i) => i && t ? e === 0 ? "right" : e === 1 ? "center" : "left" : t && !i ? e === 0 ? "left" : e === 1 ? "center" : "right" : i ? e === 0 ? "right" : "left" : e === 0 ? "left" : "right", Nh = ({
  quickLinksTitle: e,
  quickLinks: t,
  footerColumns: i,
  stockPrice: s,
  socialLinksTitle: n,
  socialLinks: r,
  serviceLinksTitle: a,
  serviceLinks: o,
  year: l,
  date: c,
  copyright: d,
  text: f,
  isRightToLeft: h
}) => {
  const m = !!((i == null ? void 0 : i.length) === kl && s) ? i == null ? void 0 : i.slice(0, 2) : i == null ? void 0 : i.slice(0, 3), b = (m == null ? void 0 : m.length) === 1, E = !!(((m == null ? void 0 : m.length) || 0) > 1 && s || ((m == null ? void 0 : m.length) || 0) > 2), x = b ? "8-4" : E ? "4-4-4" : "6-6";
  return /* @__PURE__ */ u("footer", { className: O(ae.footer, E && ae["footer--with-extra-columns"]), children: /* @__PURE__ */ M(Et, { layout: "12", noPadding: !0, children: [
    /* @__PURE__ */ u("div", { className: ae["footer__first-row"], slot: "full", children: /* @__PURE__ */ M(Et, { layout: "3-1-8", fullWidth: !0, isRightToLeft: h, children: [
      /* @__PURE__ */ u(
        "nav",
        {
          className: ae["footer__quick-links-nav"],
          "aria-label": e,
          slot: h ? "right" : "left",
          children: /* @__PURE__ */ u("ul", { className: ae["footer__quick-links"], children: t })
        }
      ),
      /* @__PURE__ */ u("div", { slot: "center" }),
      /* @__PURE__ */ u("div", { className: ae["footer__columns-container"], slot: h ? "left" : "right", children: /* @__PURE__ */ M(Et, { layout: x, fullWidth: !0, isRightToLeft: h, children: [
        m == null ? void 0 : m.map((p, _) => /* @__PURE__ */ M(
          "nav",
          {
            "aria-labelledby": Ms(p.columnTitle),
            slot: Al(_, E, h),
            children: [
              /* @__PURE__ */ u("h3", { className: ae["footer__column-title"], id: Ms(p.columnTitle), children: p.columnTitle }),
              /* @__PURE__ */ u("ul", { className: ae["footer__column-links"], children: p.links })
            ]
          },
          _
        )),
        s && /* @__PURE__ */ u("div", { className: ae["footer__stock-price"], slot: "right", children: s })
      ] }) })
    ] }) }),
    /* @__PURE__ */ u("div", { className: ae["footer__second-row"], slot: "full", children: /* @__PURE__ */ M(Et, { layout: "4-8", fullWidth: !0, isRightToLeft: h, children: [
      /* @__PURE__ */ u(
        "nav",
        {
          className: ae["footer__social-links-nav"],
          "aria-label": n,
          slot: h ? "right" : "left",
          children: /* @__PURE__ */ u("ul", { className: ae["footer__social-links"], children: r })
        }
      ),
      /* @__PURE__ */ u("nav", { "aria-label": a, slot: h ? "left" : "right", children: /* @__PURE__ */ u("ul", { className: ae["footer__service-links"], children: o }) })
    ] }) }),
    /* @__PURE__ */ u("div", { className: ae["footer__third-row"], slot: "full", children: /* @__PURE__ */ M(Et, { layout: "4-8", fullWidth: !0, isRightToLeft: h, children: [
      /* @__PURE__ */ M("div", { className: ae.footer__copyright, slot: h ? "right" : "left", children: [
        "© ",
        /* @__PURE__ */ u("time", { children: l }),
        "  ",
        d,
        "  ",
        /* @__PURE__ */ u("time", { children: c })
      ] }),
      /* @__PURE__ */ u("div", { className: ae["footer__legal-text"], slot: h ? "left" : "right", children: f })
    ] }) })
  ] }) });
}, dt = {
  "form-wrapper": "form-wrapper",
  "form-wrapper--one-trust-container": "form-wrapper--one-trust-container",
  "form-wrapper--title": "form-wrapper--title",
  "form-wrapper--link": "form-wrapper--link",
  "form-wrapper--submit-button": "form-wrapper--submit-button",
  "button-wrapper": "button-wrapper",
  "form-wrapper--message": "form-wrapper--message",
  "form-wrapper--recaptcha-container": "form-wrapper--recaptcha-container",
  "form-wrapper--actions": "form-wrapper--actions"
}, Ml = "message", Cl = "message__content", Il = "message__type", xt = {
  message: Ml,
  message__content: Cl,
  message__type: Il,
  "message__close-button": "message__close-button",
  "message--closed": "message--closed",
  "message--success": "message--success",
  "message--error": "message--error",
  "message--info": "message--info"
}, Ft = "24px", Rl = ({ type: e, message: t, showCloseButton: i, labels: s }) => {
  const [n, r] = V(!1), a = e === "error" ? "alert" : "status", o = {
    info: "info",
    error: "alert-error",
    success: "alert-success"
  }, l = () => {
    r(!0);
  };
  return /* @__PURE__ */ M(
    "div",
    {
      className: O(xt.message, xt[`message--${e}`], n && xt["message--closed"]),
      role: a,
      children: [
        /* @__PURE__ */ M("div", { className: xt.message__content, children: [
          /* @__PURE__ */ u(F, { icon: o[e], width: Ft, height: Ft, decorative: !0 }),
          /* @__PURE__ */ u("span", { className: "message__type", children: (s == null ? void 0 : s[`${e}Title`]) || e }),
          /* @__PURE__ */ u("p", { children: t })
        ] }),
        i && /* @__PURE__ */ u("button", { className: xt["message__close-button"], "aria-label": s == null ? void 0 : s.closeButton, onClick: l, children: /* @__PURE__ */ u(F, { icon: "close", width: Ft, height: Ft, decorative: !0 }) })
      ]
    }
  );
}, kh = ({
  action: e,
  needsConsentText: t,
  needsConsent: i,
  onConsentRequest: s,
  consentRequestButtonText: n,
  submitButton: r,
  message: a,
  messageType: o,
  children: l,
  successComponent: c
}) => {
  const { onSubmit: d, text: f, disabled: h, loading: g, icon: m, appearance: b } = r;
  return /* @__PURE__ */ M("form", { className: dt["form-wrapper"], onSubmit: d, action: e, children: [
    l,
    i && /* @__PURE__ */ M("div", { className: dt["form-wrapper--one-trust-container"], children: [
      /* @__PURE__ */ M("div", { className: dt["form-wrapper--title"], children: [
        t,
        " *"
      ] }),
      /* @__PURE__ */ u(Mt, { onButtonClick: s, text: n, leftIcon: "chevron-right" })
    ] }),
    /* @__PURE__ */ M("div", { className: dt["form-wrapper--submit-button"], children: [
      /* @__PURE__ */ u(
        Lt,
        {
          text: f,
          type: di.SUBMIT,
          appearance: b,
          rightIcon: m,
          disabled: h,
          isLoading: g
        }
      ),
      /* @__PURE__ */ u("div", { className: dt["form-wrapper--message"], children: a && /* @__PURE__ */ u(Rl, { type: o, message: a }) }),
      c && /* @__PURE__ */ u("div", { className: dt["form-wrapper--message"], children: c })
    ] })
  ] });
}, pn = () => {
  const [e, t] = V(typeof window < "u" ? window.scrollY : 0);
  return Vn(() => {
    if (typeof window > "u") return;
    const i = () => {
      t(window.scrollY);
    };
    return window.addEventListener("scroll", i), () => {
      window.removeEventListener("scroll", i);
    };
  }, []), e;
}, Ol = () => {
  const e = pn(), [t, i] = V(null), [s, n] = V(e);
  return G(() => {
    e > s ? i("down") : e < s && i("up"), n(e);
  }, [e, s]), t;
}, Ll = (e) => {
  G(() => {
    const { body: t } = document;
    return e ? (t.style.overflow = "hidden", t.style.position = "relative") : (t.style.overflow = "", t.style.position = ""), () => {
      t.style.overflow = "", t.style.position = "";
    };
  }, [e]);
}, hn = (e, t, i) => {
  const s = Re(
    (n) => {
      t && e.current && !e.current.contains(n.target) && i();
    },
    [e, t, i]
  );
  G(() => (t ? (document.addEventListener("mousedown", s), document.addEventListener("focusin", s)) : (document.removeEventListener("mousedown", s), document.removeEventListener("focusin", s)), () => {
    document.removeEventListener("mousedown", s), document.removeEventListener("focusin", s);
  }), [t, s]);
}, X = {
  "mobile-navigation": "mobile-navigation",
  "mobile-navigation__overlay": "mobile-navigation__overlay",
  "mobile-navigation__overlay--open": "mobile-navigation__overlay--open",
  "mobile-navigation__overlay--closing": "mobile-navigation__overlay--closing",
  "mobile-navigation__header": "mobile-navigation__header",
  "mobile-navigation__worldwide-link": "mobile-navigation__worldwide-link",
  "mobile-navigation__header-link": "mobile-navigation__header-link",
  "mobile-navigation__close-button": "mobile-navigation__close-button",
  "mobile-navigation__list": "mobile-navigation__list",
  "mobile-navigation__list--primary": "mobile-navigation__list--primary",
  "mobile-navigation__chevron": "mobile-navigation__chevron",
  "mobile-navigation__list-item": "mobile-navigation__list-item",
  "mobile-navigation__list-item--open": "mobile-navigation__list-item--open",
  "mobile-navigation__list-item--active": "mobile-navigation__list-item--active",
  "mobile-navigation__list-item-button": "mobile-navigation__list-item-button",
  "mobile-navigation__list-item-link": "mobile-navigation__list-item-link",
  "mobile-navigation__submenu-list": "mobile-navigation__submenu-list",
  "mobile-navigation__submenu-item": "mobile-navigation__submenu-item",
  "mobile-navigation__submenu-item--active": "mobile-navigation__submenu-item--active",
  "mobile-navigation__submenu-item-title": "mobile-navigation__submenu-item-title",
  "mobile-navigation__submenu-item-title--active": "mobile-navigation__submenu-item-title--active",
  "mobile-navigation__submenu-item-arrow": "mobile-navigation__submenu-item-arrow",
  "mobile-navigation__submenu-item-link": "mobile-navigation__submenu-item-link",
  "mobile-navigation__meta-nav": "mobile-navigation__meta-nav"
}, Ze = (e) => e == null ? void 0 : e.replace(/^\/+|\/+$/g, ""), ve = (e, t) => Ze(e) === Ze(t), yi = (e, t, i) => {
  const s = Ze(i) === Ze(t);
  return O(X[`${e}`], s && X[`${e}--active`]);
}, Pl = (e, t) => e == null ? void 0 : e.findIndex(
  ({ url: i, nestedLinks: s }) => Ze(t) === Ze(i) || (s == null ? void 0 : s.some(
    (n) => Ze(n.url) === Ze(t)
  ))
), oe = {
  "main-navigation": "main-navigation",
  "main-navigation__submenu": "main-navigation__submenu",
  "main-navigation__submenu-item--active": "main-navigation__submenu-item--active",
  "main-navigation__item": "main-navigation__item",
  "main-navigation__item--active": "main-navigation__item--active",
  "main-navigation__item--open": "main-navigation__item--open",
  "main-navigation__item--separator": "main-navigation__item--separator",
  "main-navigation__item-button": "main-navigation__item-button",
  "navigation-item__link": "navigation-item__link",
  "main-navigation__submenu-link": "main-navigation__submenu-link",
  "main-navigation__submenu-link--title": "main-navigation__submenu-link--title"
}, Dl = ({ nav: e, primaryNavLabel: t, currentPage: i }) => {
  const [s, n] = V(null), r = H(null);
  Qi(n), hn(r, s !== null, () => n(null));
  const a = (d, f) => {
    n(d === s ? null : d), d === s ? r.current = null : r.current = f.current;
  }, o = (d, f) => {
    n(d), r.current = f.current;
  }, l = () => {
    n(null), r.current = null;
  }, c = (d, f) => {
    const { nestedLinks: h, text: g, url: m } = d, b = H(null);
    if (!d.url)
      return /* @__PURE__ */ u(
        "li",
        {
          className: O(oe["main-navigation__item"], oe["main-navigation__item--separator"]),
          "aria-hidden": "true"
        },
        "separator" + f
      );
    const E = s === f, x = O(
      oe["main-navigation__item"],
      ve(m, i) && oe["main-navigation__item--active"],
      E && oe["main-navigation__item--open"]
    );
    return h != null && h.length ? /* @__PURE__ */ M("li", { className: x, ref: b, children: [
      /* @__PURE__ */ u(
        "button",
        {
          className: oe["main-navigation__item-button"],
          "aria-controls": m,
          "aria-expanded": s === f,
          onMouseEnter: () => o(f, b),
          onMouseLeave: l,
          onClick: () => a(f, b),
          children: g
        }
      ),
      /* @__PURE__ */ M(
        "ul",
        {
          className: oe["main-navigation__submenu"],
          id: m,
          onMouseEnter: () => o(f, b),
          onMouseLeave: l,
          children: [
            /* @__PURE__ */ u("li", { className: oe["main-navigation__submenu-item"], children: /* @__PURE__ */ M(
              "a",
              {
                className: O(oe["main-navigation__submenu-link"], oe["main-navigation__submenu-link--title"]),
                href: m,
                onClick: d.onClick,
                "aria-current": ve(m, i) ? "page" : !1,
                children: [
                  /* @__PURE__ */ u("span", { className: oe["main-navigation__submenu-label"], children: g }),
                  /* @__PURE__ */ u(F, { icon: "arrow-right", height: "24px", decorative: !0 })
                ]
              }
            ) }),
            h == null ? void 0 : h.map((p, _) => /* @__PURE__ */ u(
              "li",
              {
                className: O(
                  oe["main-navigation__submenu-item"],
                  ve(p == null ? void 0 : p.url, i) && oe["main-navigation__submenu-item--active"]
                ),
                children: /* @__PURE__ */ u(
                  "a",
                  {
                    className: oe["main-navigation__submenu-link"],
                    href: p == null ? void 0 : p.url,
                    onClick: p == null ? void 0 : p.onClick,
                    "aria-current": ve(p == null ? void 0 : p.url, i) ? "page" : !1,
                    children: p.text
                  }
                )
              },
              "sub" + _
            ))
          ]
        }
      )
    ] }, f) : /* @__PURE__ */ u("li", { className: x, ref: b, children: /* @__PURE__ */ u(
      "a",
      {
        className: oe["navigation-item__link"],
        href: m,
        "aria-current": ve(m, i) ? "page" : !1,
        onClick: d.onClick,
        children: g
      }
    ) }, f);
  };
  return /* @__PURE__ */ u("nav", { "aria-label": t, children: /* @__PURE__ */ u("ul", { className: oe["main-navigation"], children: e == null ? void 0 : e.map((d, f) => c(d, f)) }) });
}, fe = {
  "meta-navigation": "meta-navigation",
  "meta-navigation__items": "meta-navigation__items",
  "meta-navigation__item-icon": "meta-navigation__item-icon",
  "meta-navigation__item": "meta-navigation__item",
  "meta-navigation__item--icon": "meta-navigation__item--icon",
  "meta-navigation__item--active": "meta-navigation__item--active",
  "meta-navigation__item-link": "meta-navigation__item-link",
  "meta-navigation__separator": "meta-navigation__separator"
};
var pi = /* @__PURE__ */ ((e) => (e.DROPDOWN = "dropdown", e.INLINE_LIST = "inline-list", e))(pi || {});
const Be = {
  "language-switch-dropdown": "language-switch-dropdown",
  "language-switch-dropdown__chevron-icon": "language-switch-dropdown__chevron-icon",
  "language-switch-dropdown__open": "language-switch-dropdown__open",
  "language-switch-dropdown__list": "language-switch-dropdown__list",
  "language-switch-dropdown__button": "language-switch-dropdown__button",
  "language-switch-dropdown__list-item": "language-switch-dropdown__list-item",
  "language-switch-dropdown__link": "language-switch-dropdown__link",
  "language-switch-dropdown__link--selected": "language-switch-dropdown__link--selected"
}, ut = {
  "language-switch-inline": "language-switch-inline",
  "language-switch-inline__list": "language-switch-inline__list",
  "language-switch-inline__list-item": "language-switch-inline__list-item",
  "language-switch-inline__link": "language-switch-inline__link",
  "language-switch-inline__link--selected": "language-switch-inline__link--selected"
}, mn = ({
  alternates: e,
  currentLocale: t,
  currentPage: i,
  translatedLocale: s,
  translatedAriaLabel: n,
  layout: r,
  onClick: a
}) => {
  const [o, l] = V(!1), c = H(null), d = H(null);
  Qi(l), hn(c, o, () => l(!1));
  const f = (E) => {
    l((x) => {
      const p = !x;
      return c.current = p ? E.current : null, p;
    });
  }, h = (E) => {
    l(!0), c.current = E.current;
  }, g = () => {
    l(!1), c.current = null;
  }, m = (E) => /* @__PURE__ */ u("div", { className: ut["language-switch-inline"], children: /* @__PURE__ */ u("ul", { className: ut["language-switch-inline__list"], children: E.map((x, p) => {
    const _ = x.url === i;
    return s[x.locale] && /* @__PURE__ */ u("li", { className: ut["language-switch-inline__list-item"], children: _ ? /* @__PURE__ */ u(
      "span",
      {
        className: O(
          ut["language-switch-inline__link"],
          _ && ut["language-switch-inline__link--selected"]
        ),
        "aria-current": "page",
        "aria-disabled": !0,
        children: s[x.locale]
      }
    ) : /* @__PURE__ */ u(
      "a",
      {
        className: ut["language-switch-inline__link"],
        href: x.url,
        "aria-disabled": !1,
        onClick: () => a(x.locale, x.url),
        children: s[x.locale]
      }
    ) }, p);
  }) }) }), b = (E, x) => /* @__PURE__ */ M(
    "div",
    {
      className: O(
        Be["language-switch-dropdown"],
        o && Be["language-switch-dropdown__open"]
      ),
      children: [
        /* @__PURE__ */ M(
          "button",
          {
            className: Be["language-switch-dropdown__button"],
            id: "language-switch-button",
            "aria-expanded": o,
            "aria-controls": "language-switch-list",
            "aria-label": n,
            onClick: () => f(d),
            onMouseEnter: () => h(d),
            onMouseLeave: g,
            children: [
              x.toUpperCase(),
              /* @__PURE__ */ u("span", { className: Be["language-switch-dropdown__chevron-icon"], children: /* @__PURE__ */ u(F, { icon: "chevron-down", width: "18px" }) })
            ]
          }
        ),
        /* @__PURE__ */ u(
          "ul",
          {
            ref: d,
            className: Be["language-switch-dropdown__list"],
            id: "language-switch-list",
            "aria-hidden": !o,
            onMouseEnter: () => h(d),
            onMouseLeave: g,
            inert: o ? null : "",
            children: E.map((p, _) => {
              const w = p.url === i;
              return s[p.locale] && /* @__PURE__ */ u("li", { className: Be["language-switch-dropdown__list-item"], children: w ? /* @__PURE__ */ u(
                "span",
                {
                  className: O(
                    Be["language-switch-dropdown__link"],
                    w && Be["language-switch-dropdown__link--selected"]
                  ),
                  "aria-current": "page",
                  "aria-disabled": !0,
                  children: s[p.locale]
                }
              ) : /* @__PURE__ */ u(
                "a",
                {
                  href: p.url,
                  onClick: () => a(p.locale, p.url),
                  className: Be["language-switch-dropdown__link"],
                  "aria-disabled": !1,
                  children: s[p.locale]
                }
              ) }, _);
            })
          }
        )
      ]
    }
  );
  return r === pi.DROPDOWN ? b(e, t) : m(e);
}, $l = ({
  nav: e,
  secondaryNavLabel: t,
  searchLink: i,
  worldWideLink: s,
  currentPage: n,
  languageSwitchConfig: r
}) => {
  const a = ((r == null ? void 0 : r.alternates) ?? []).length > 0, o = !!(a || s || i);
  return /* @__PURE__ */ M("nav", { className: fe["meta-navigation"], "aria-label": t, children: [
    /* @__PURE__ */ u("ul", { className: fe["meta-navigation__items"], children: e == null ? void 0 : e.map((l, c) => /* @__PURE__ */ u(
      "li",
      {
        className: O(
          fe["meta-navigation__item"],
          ve(l.url, n) && fe["meta-navigation__item--active"]
        ),
        children: /* @__PURE__ */ u(
          "a",
          {
            className: fe["meta-navigation__item-link"],
            href: l.url,
            onClick: l.onClick,
            "aria-current": ve(l.url, n) ? "page" : !1,
            children: l.text ?? ""
          }
        )
      },
      c
    )) }),
    o && /* @__PURE__ */ u("div", { className: fe["meta-navigation__separator"] }),
    a && r && /* @__PURE__ */ u(
      mn,
      {
        currentLocale: r.currentLocale,
        currentPage: n,
        alternates: r.alternates,
        translatedLocale: r.translations.translatedLocale,
        translatedAriaLabel: r.translations.translatedAriaLabel,
        layout: pi.DROPDOWN,
        onClick: r.handleClickTracking
      }
    ),
    (s == null ? void 0 : s.url) && /* @__PURE__ */ u(
      "a",
      {
        className: O(
          fe["meta-navigation__item"],
          fe["meta-navigation__item--icon"],
          ve(s == null ? void 0 : s.url, n) && fe["meta-navigation__item--active"]
        ),
        href: s.url,
        onClick: s == null ? void 0 : s.onClick,
        "aria-label": s == null ? void 0 : s.label,
        "aria-current": ve(s.url, n) ? "page" : !1,
        children: /* @__PURE__ */ u("span", { className: fe["meta-navigation__item-icon"], children: /* @__PURE__ */ u(F, { icon: "globe", height: "20px", decorative: !0 }) })
      }
    ),
    (i == null ? void 0 : i.url) && /* @__PURE__ */ u(
      "a",
      {
        className: O(
          fe["meta-navigation__item"],
          fe["meta-navigation__item--icon"],
          ve(i == null ? void 0 : i.url, n) && fe["meta-navigation__item--active"]
        ),
        href: i.url,
        onClick: i == null ? void 0 : i.onClick,
        "aria-label": i == null ? void 0 : i.label,
        "aria-current": ve(i.url, n) ? "page" : !1,
        children: /* @__PURE__ */ u("span", { className: fe["meta-navigation__item-icon"], children: /* @__PURE__ */ u(F, { icon: "search", height: "20px", decorative: !0 }) })
      }
    )
  ] });
}, gn = () => {
  const [e, t] = V(!1);
  return G(() => {
    const i = window.matchMedia("(prefers-reduced-motion: reduce)");
    t(i.matches);
    const s = () => {
      t(i.matches);
    };
    return i.addEventListener("change", s), () => i.removeEventListener("change", s);
  }, []), e;
}, Rs = ({
  link: e,
  index: t,
  openItem: i,
  isNavOpen: s,
  currentPage: n,
  exploreLabel: r,
  handleToggleMenu: a
}) => {
  const { nestedLinks: o, text: l, url: c } = e, d = i === t, f = H(null), h = H(null), [g, m] = V(0);
  if (G(() => {
    f.current && h.current && m(d ? f.current.scrollHeight : 0);
  }, [d, s, r]), !e.url)
    return null;
  if (!(o != null && o.length))
    return /* @__PURE__ */ u("li", { className: yi("mobile-navigation__list-item", c, n), children: /* @__PURE__ */ u("a", { className: X["mobile-navigation__list-item-link"], href: c, onClick: e.onClick, children: l }) }, t);
  const b = O(
    X["mobile-navigation__list-item"],
    d && X["mobile-navigation__list-item--open"]
  );
  return /* @__PURE__ */ M("li", { className: b, children: [
    /* @__PURE__ */ M(
      "button",
      {
        className: X["mobile-navigation__list-item-button"],
        onClick: () => a(t),
        "aria-controls": c,
        "aria-expanded": d,
        children: [
          l,
          /* @__PURE__ */ u("span", { className: X["mobile-navigation__chevron"], children: /* @__PURE__ */ u(F, { icon: "chevron-down", height: "24px", decorative: !0 }) })
        ]
      }
    ),
    /* @__PURE__ */ M(
      "ul",
      {
        ref: f,
        className: X["mobile-navigation__submenu-list"],
        "aria-hidden": !d,
        style: {
          maxHeight: d ? `${g}px` : "0px",
          opacity: d ? 1 : 0
        },
        children: [
          /* @__PURE__ */ u("li", { className: yi("mobile-navigation__submenu-item-title", c, n), children: /* @__PURE__ */ M(
            "a",
            {
              className: X["mobile-navigation__submenu-item-link"],
              href: c,
              ref: h,
              onClick: e.onClick,
              "aria-label": l,
              "aria-current": ve(c, n) ? "page" : !1,
              children: [
                r,
                /* @__PURE__ */ u("span", { className: X["mobile-navigation__submenu-item-arrow"], children: /* @__PURE__ */ u(F, { icon: "arrow-right", height: "24px", decorative: !0 }) })
              ]
            }
          ) }, "title" + t),
          o == null ? void 0 : o.map((E, x) => /* @__PURE__ */ u(
            "li",
            {
              className: yi("mobile-navigation__submenu-item", E.url, n),
              children: /* @__PURE__ */ u(
                "a",
                {
                  className: X["mobile-navigation__submenu-item-link"],
                  href: E == null ? void 0 : E.url,
                  onClick: E == null ? void 0 : E.onClick,
                  "aria-current": ve(E == null ? void 0 : E.url, n) ? "page" : !1,
                  children: E.text
                }
              )
            },
            "sub" + x
          ))
        ]
      }
    )
  ] }, t);
}, zl = ({
  primaryNav: e,
  secondaryNav: t,
  worldWideLink: i,
  exploreLabel: s,
  closeNavLabel: n,
  currentPage: r,
  isNavOpen: a,
  setIsNavOpen: o,
  languageSwitchConfig: l
}) => {
  var v;
  const c = H(null), d = H(null), [f, h] = V(!1), [g, m] = V(null), b = gn();
  G(() => {
    const y = Pl(e, r);
    m(y);
  }, [r, e]), G(() => {
    var S;
    const y = d.current;
    if (y) {
      if (a) {
        y.showModal(), (S = c.current) == null || S.focus();
        return;
      }
      if (b) {
        y.close();
        return;
      }
      y.open && h(!0);
    }
  }, [a]);
  const E = () => {
    o(!1);
  }, x = (y) => {
    var S;
    y.target === d.current && f && y.propertyName === "transform" && (h(!1), (S = d.current) == null || S.close());
  }, p = (y) => {
    m((S) => S === y ? null : y);
  }, _ = O(
    X["mobile-navigation__overlay"],
    a && X["mobile-navigation__overlay--open"],
    f && X["mobile-navigation__overlay--closing"]
  ), w = ((v = (l == null ? void 0 : l.alternates) ?? []) == null ? void 0 : v.length) > 0;
  return /* @__PURE__ */ u("nav", { className: X["mobile-navigation"], children: /* @__PURE__ */ M(
    "dialog",
    {
      className: _,
      onClose: () => o(!1),
      id: "mobile-navigation",
      ref: d,
      inert: a ? null : "",
      "aria-hidden": !a,
      onTransitionEnd: x,
      children: [
        /* @__PURE__ */ M("header", { className: X["mobile-navigation__header"], children: [
          /* @__PURE__ */ M(
            "a",
            {
              className: X["mobile-navigation__worldwide-link"],
              href: i == null ? void 0 : i.url,
              onClick: i == null ? void 0 : i.onClick,
              children: [
                /* @__PURE__ */ u(F, { icon: "globe", height: "24px", decorative: !0 }),
                i == null ? void 0 : i.label
              ]
            }
          ),
          /* @__PURE__ */ u(
            "button",
            {
              className: X["mobile-navigation__close-button"],
              onClick: E,
              ref: c,
              "aria-label": n,
              "aria-controls": "mobile-navigation",
              children: /* @__PURE__ */ u(F, { icon: "mobile-close", height: "32px", decorative: !0 })
            }
          )
        ] }),
        /* @__PURE__ */ u("ul", { className: O(X["mobile-navigation__list"], X["mobile-navigation__list--primary"]), children: e == null ? void 0 : e.map((y, S) => /* @__PURE__ */ u(
          Rs,
          {
            link: y,
            index: S,
            openItem: g,
            isNavOpen: a,
            exploreLabel: s,
            currentPage: r,
            handleToggleMenu: p
          },
          S
        )) }),
        /* @__PURE__ */ u("ul", { className: X["mobile-navigation__list"], children: t == null ? void 0 : t.map((y, S) => /* @__PURE__ */ u(
          Rs,
          {
            link: y,
            index: S,
            openItem: g,
            isNavOpen: a,
            exploreLabel: s,
            currentPage: r,
            handleToggleMenu: p
          },
          S
        )) }),
        l && w && /* @__PURE__ */ u("div", { className: X["mobile-navigation__meta-nav"], children: /* @__PURE__ */ u(
          mn,
          {
            alternates: l.alternates,
            currentLocale: l.currentLocale,
            currentPage: r,
            translatedLocale: l.translations.translatedLocale,
            translatedAriaLabel: l.translations.translatedAriaLabel,
            layout: pi.INLINE_LIST,
            onClick: l.handleClickTracking
          }
        ) })
      ]
    }
  ) });
}, Vl = "grid__column", Bl = "header", Hl = "header__logo", Fl = "header__actions", Gl = "header__search", ql = "header__burger", J = {
  "no-print": "no-print",
  "print-grid-full-width": "print-grid-full-width",
  grid__column: Vl,
  "is-8": "is-8",
  "is-1": "is-1",
  "is-3": "is-3",
  header: Bl,
  "header__skip-link": "header__skip-link",
  "header__first-row": "header__first-row",
  "header__second-row": "header__second-row",
  header__logo: Hl,
  "header__logo-mobile": "header__logo-mobile",
  "header__logo-link": "header__logo-link",
  header__actions: Fl,
  header__search: Gl,
  "header__search--active": "header__search--active",
  header__burger: ql,
  "header__search-icon": "header__search-icon",
  "header__burger-icon": "header__burger-icon",
  "header__mobile-nav": "header__mobile-nav",
  "header__secondary-nav": "header__secondary-nav",
  "header--scrolled": "header--scrolled",
  "header--transparent": "header--transparent",
  "header--hidden": "header--hidden"
}, jl = 100, Ah = ({
  homeLink: e,
  searchLink: t,
  worldWideLink: i,
  exploreLabel: s,
  openNavLabel: n,
  closeNavLabel: r,
  currentPage: a,
  isFixed: o,
  primaryNav: l,
  secondaryNav: c,
  primaryNavLabel: d,
  secondaryNavLabel: f,
  skipToContentLabel: h,
  languageSwitchConfig: g
}) => {
  const [m, b] = V(!1);
  Ll(m);
  const E = () => {
    b(!m);
  }, x = pn(), p = Ol(), _ = x > 0, w = x < jl, v = !o && !w && p === "down", y = !_, S = O(
    J.header,
    o && J["header--fixed"],
    _ && J["header--scrolled"],
    y && J["header--transparent"],
    v && J["header--hidden"]
  ), N = a === (t == null ? void 0 : t.url);
  return /* @__PURE__ */ M("header", { className: S, children: [
    /* @__PURE__ */ u("a", { className: J["header__skip-link"], href: "#main-content", children: h }),
    /* @__PURE__ */ M("div", { className: J["header__first-row"], children: [
      /* @__PURE__ */ M(
        "a",
        {
          className: J["header__logo-link"],
          href: (e == null ? void 0 : e.url) ?? "/",
          "aria-label": e == null ? void 0 : e.label,
          onClick: e == null ? void 0 : e.onClick,
          children: [
            /* @__PURE__ */ u("span", { className: J.header__logo, children: /* @__PURE__ */ u(F, { icon: "logo", height: "40px", decorative: !0 }) }),
            /* @__PURE__ */ u("span", { className: J["header__logo-mobile"], children: /* @__PURE__ */ u(F, { icon: "logo", height: "30px", decorative: !0 }) })
          ]
        }
      ),
      /* @__PURE__ */ u("div", { className: J["header__secondary-nav"], children: /* @__PURE__ */ u(
        $l,
        {
          nav: c,
          secondaryNavLabel: f,
          worldWideLink: i,
          searchLink: t,
          currentPage: a,
          languageSwitchConfig: g
        }
      ) }),
      /* @__PURE__ */ M("div", { className: J.header__actions, children: [
        /* @__PURE__ */ u(
          "a",
          {
            href: t == null ? void 0 : t.url,
            className: O(J.header__search, N && J["header__search--active"]),
            "aria-label": t == null ? void 0 : t.label,
            "aria-current": N ? "page" : !1,
            onClick: t == null ? void 0 : t.onClick,
            children: /* @__PURE__ */ u("span", { className: J["header__search-icon"], children: /* @__PURE__ */ u(F, { icon: "search-mobile", height: "32px", decorative: !0 }) })
          }
        ),
        /* @__PURE__ */ u(
          "button",
          {
            className: J.header__burger,
            onClick: E,
            "aria-label": n,
            "aria-controls": "mobile-navigation",
            "aria-expanded": m,
            children: /* @__PURE__ */ u("span", { className: J["header__burger-icon"], children: /* @__PURE__ */ u(F, { icon: "mobile-menu", height: "32px", decorative: !0 }) })
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ u("div", { className: J["header__second-row"], children: /* @__PURE__ */ u(Dl, { nav: l, primaryNavLabel: d, currentPage: a }) }),
    /* @__PURE__ */ u("div", { className: J["header__mobile-nav"], children: /* @__PURE__ */ u(
      zl,
      {
        primaryNav: l,
        secondaryNav: c,
        worldWideLink: i,
        exploreLabel: s,
        closeNavLabel: r,
        currentPage: a,
        isNavOpen: m,
        setIsNavOpen: b,
        languageSwitchConfig: g
      }
    ) })
  ] });
}, Ul = "image", He = {
  "hero-teaser": "hero-teaser",
  "hero-teaser__info-container": "hero-teaser__info-container",
  "hero-teaser__text-container": "hero-teaser__text-container",
  "hero-teaser__title-container": "hero-teaser__title-container",
  "hero-teaser__title": "hero-teaser__title",
  "hero-teaser__overline": "hero-teaser__overline",
  "hero-teaser__button-container": "hero-teaser__button-container",
  "hero-teaser__image-container": "hero-teaser__image-container",
  image: Ul,
  "video-player": "video-player",
  "hero-teaser--unpublished": "hero-teaser--unpublished"
}, es = (e) => {
  const [t, i] = V(!1);
  return G(() => {
    const s = () => {
      i(window.innerWidth < e);
    };
    return s(), window.addEventListener("resize", s), () => window.removeEventListener("resize", s);
  }, [e]), t;
}, Wl = "image", Yl = "image__img", Xl = "image__container", Zl = "image__description", Kl = "image__caption", Ql = "image__copyright", pe = {
  image: Wl,
  image__img: Yl,
  image__container: Xl,
  "image--fullscreen": "image--fullscreen",
  "image--bleed": "image--bleed",
  "image--original": "image--original",
  "image--top": "image--top",
  "image--center": "image--center",
  "image--bottom": "image--bottom",
  "image--full-height": "image--full-height",
  image__description: Zl,
  image__caption: Kl,
  image__copyright: Ql,
  "image__ratio-hd": "image__ratio-hd",
  "image__ratio-wide": "image__ratio-wide",
  "image__ratio-square": "image__ratio-square",
  "image__ratio-vertical": "image__ratio-vertical",
  "image__ratio-normal": "image__ratio-normal",
  "image__ratio-sixtofive": "image__ratio-sixtofive"
};
var re = /* @__PURE__ */ ((e) => (e.HD = "16:9", e.WIDE = "2.39:1", e.SQUARE = "1:1", e.VERTICAL = "4:5", e.ORIGINAL = "original", e.NORMAL = "4:3", e.SIXTOFIVE = "6:5", e))(re || {}), Jl = /* @__PURE__ */ ((e) => (e.LAZY = "lazy", e.EAGER = "eager", e))(Jl || {}), nt = /* @__PURE__ */ ((e) => (e.TOP = "top", e.CENTER = "center", e.BOTTOM = "bottom", e))(nt || {});
const ec = [1, 1.5, 2, 3], tc = (e) => {
  const [t, i] = V({ width: 0, height: 0 });
  return G(() => {
    const s = new ResizeObserver((n) => {
      for (let r of n) {
        const { width: a, height: o } = r.contentRect;
        i({
          width: Math.round(a),
          height: Math.round(o)
        });
      }
    });
    return e.current && s.observe(e.current), () => {
      e.current && s.unobserve(e.current);
    };
  }, []), t;
}, ic = (e) => {
  const t = Object.values(re).includes(e) ? e : re.HD;
  if (t === re.ORIGINAL)
    return null;
  const [i, s] = t.split(":").map(parseFloat);
  return i / s;
}, Os = (e, t, i, s) => {
  const n = ic(i);
  let r = 0;
  return s ? r = s : n && (r = Math.round(t / n)), e.replace(/\$0/g, `${t}`).replace(/\$1/g, `${r}`);
}, sc = (e) => e.includes("$0"), nc = (e) => {
  var t;
  return ((t = Object.entries(re).find(([, i]) => i === e)) == null ? void 0 : t[0].toLowerCase()) || null;
}, rc = (e) => Object.values(nt).includes(e) ? e : nt.CENTER, ac = 300, hi = ({
  src: e,
  alt: t,
  slot: i,
  caption: s = void 0,
  copyright: n = void 0,
  ratio: r = re.HD,
  position: a = nt.CENTER,
  fullscreen: o = !1,
  showCaption: l = !1,
  showCopyright: c = !1,
  bleed: d = !1,
  forceHeight: f = void 0,
  loading: h = "lazy"
}) => {
  const g = Os(e, ne.SMALL, r, f), [{ fallbackSrc: m, width: b, srcSet: E }, x] = V({
    fallbackSrc: g,
    width: ne.SMALL,
    srcSet: ""
  }), p = H(null), _ = tc(p), w = nc(r), v = O({
    [pe.image__img]: !0,
    [pe[`image__ratio-${w}`]]: r !== re.ORIGINAL && w
  });
  sc(e) && G(() => {
    const N = setTimeout(() => {
      const R = window.devicePixelRatio || 1;
      if (_.width) {
        const A = ec.map((C) => {
          const P = Math.round(_.width * R);
          return `${Os(e, P, r, f)} ${C}x`;
        }).join(", ");
        x({ fallbackSrc: m, width: _.width, srcSet: A });
      }
    }, ac);
    return () => clearTimeout(N);
  }, [_, m]);
  const y = rc(a), S = O({
    [pe.image]: !0,
    [pe["image--fullscreen"]]: o,
    [pe["image--bleed"]]: d,
    [pe["image--top"]]: y === nt.TOP,
    [pe["image--center"]]: y === nt.CENTER,
    [pe["image--bottom"]]: y === nt.BOTTOM,
    [pe["image--original"]]: r === re.ORIGINAL,
    [pe["image--full-height"]]: f !== void 0
  });
  return /* @__PURE__ */ M("figure", { className: S, slot: i, "data-ratio": r, children: [
    /* @__PURE__ */ u("div", { className: pe.image__container, ref: p, children: /* @__PURE__ */ u(
      "img",
      {
        className: v,
        src: m,
        srcSet: E,
        sizes: `${b}px`,
        alt: t,
        title: s,
        loading: h
      }
    ) }),
    (l && s || c && n) && /* @__PURE__ */ M("div", { className: pe.image__description, children: [
      l && s && /* @__PURE__ */ u("figcaption", { className: pe.image__caption, children: s }),
      c && n && /* @__PURE__ */ M("div", { className: pe.image__copyright, children: [
        "© ",
        n
      ] })
    ] })
  ] });
}, Ls = "youtube-iframe-api-script", oc = "https://www.youtube.com/iframe_api";
let Gt = null, St = null;
const lc = () => (Gt || (Gt = new Promise((e) => {
  if (St = e, document.getElementById(Ls))
    if (typeof window.YT < "u" && window.YT.Player) {
      e(!0);
      return;
    } else {
      window.onYouTubeIframeAPIReady = () => {
        e(!0);
      };
      return;
    }
  const t = document.createElement("script");
  t.id = Ls, t.src = oc, t.async = !0, window.onYouTubeIframeAPIReady = () => {
    St && St(!0);
  }, t.onerror = () => {
    St && St(!1), Gt = null;
  }, document.head.appendChild(t);
})), Gt);
function cc() {
  const [e, t] = V(!1);
  return G(() => {
    let i = !0;
    return lc().then((s) => {
      i && t(s);
    }), () => {
      i = !1;
    };
  }, []), e;
}
const dc = "image", U = {
  "video-player": "video-player",
  "video-player__service--youtube": "video-player__service--youtube",
  "video-player__service--brightcove": "video-player__service--brightcove",
  "video-player__service--aws-video-js": "video-player__service--aws-video-js",
  "video-player__content--absolute": "video-player__content--absolute",
  "video-player__content--absolute-active": "video-player__content--absolute-active",
  "video-player__content--relative": "video-player__content--relative",
  "video-player__content--relative--fullscreen": "video-player__content--relative--fullscreen",
  "video-player__content--relative-ready": "video-player__content--relative-ready",
  "video-player__overlay": "video-player__overlay",
  "video-player__overlay-icon": "video-player__overlay-icon",
  "video-player__overlay-videoloop": "video-player__overlay-videoloop",
  "video-player__overlay--hidden": "video-player__overlay--hidden",
  "video-player__close-button": "video-player__close-button",
  "video-player--fullscreen": "video-player--fullscreen",
  "video-player__image": "video-player__image",
  image: dc,
  "video-player__image--hidden": "video-player__image--hidden",
  "video-player__image--fullscreen": "video-player__image--fullscreen",
  "video-player__image--fullscreen-playing": "video-player__image--fullscreen-playing",
  "video-player__image--error": "video-player__image--error",
  "video-player__placeholder": "video-player__placeholder",
  "video-player__placeholder--fullscreen": "video-player__placeholder--fullscreen",
  "video-player__placeholder--hidden": "video-player__placeholder--hidden",
  "video-description": "video-description",
  "video-description__caption": "video-description__caption",
  "video-description__copyright": "video-description__copyright"
}, uc = 64, fc = 80, pc = 24, _n = ({
  onPlay: e,
  onPause: t,
  fullscreen: i,
  isPlaying: s,
  videoloop: n,
  videoTitle: r,
  pauseLabel: a,
  playLabel: o
}) => {
  const l = es(ne.MEDIUM), c = `${Pe(l ? uc : fc)}rem`, d = `${Pe(pc)}rem`, f = O(U["video-player__overlay"], U["video-player__overlay-videoloop"]), h = O(
    U["video-player__overlay"],
    s && U["video-player__overlay--hidden"]
  ), g = n ? f : h, m = s ? "pause" : "play", b = s ? a : o, E = (p) => {
    p.preventDefault(), s && t ? t() : e();
  }, x = (p, _) => _ ? `${p} ${_}` : p;
  return s && i ? /* @__PURE__ */ u("button", { className: U["video-player__close-button"], onClick: E, children: /* @__PURE__ */ u(F, { icon: "close", height: d }) }) : /* @__PURE__ */ u("div", { className: g, children: /* @__PURE__ */ u(
    "button",
    {
      onClick: E,
      className: U["video-player__overlay-icon"],
      "aria-label": x(b, r),
      children: /* @__PURE__ */ u(F, { icon: m, height: c })
    }
  ) });
}, hc = (e) => {
  const t = Math.round(e.getCurrentTime()), i = Math.round(e.getDuration());
  return Math.round(t / i * 100);
}, vn = ({
  isPlaying: e,
  fullscreen: t,
  preview: i,
  previewAlt: s,
  error: n
}) => {
  const r = O(
    U["video-player__image"],
    t && U["video-player__image--fullscreen"],
    t && e && U["video-player__image--fullscreen-playing"],
    e && !t && U["video-player__image--hidden"]
  ), a = O(U["video-player__image"], U["video-player__image--error"]);
  return /* @__PURE__ */ u("div", { className: n ? a : r, "aria-hidden": !0, children: /* @__PURE__ */ u(
    hi,
    {
      src: i,
      alt: s,
      ratio: t ? re.WIDE : re.HD,
      fullscreen: t
    }
  ) });
}, mc = 1e3, gc = ({
  videoId: e,
  fullscreen: t,
  preview: i,
  previewAlt: s,
  pauseLabel: n,
  playLabel: r,
  onVideoStateChange: a
}) => {
  const o = cc(), l = `yt-video-${e}`, c = H(null), d = H(null), [f, h] = V(!1), [g, m] = V(!1), [b, E] = V(""), x = H(), p = (A) => {
    const C = document.getElementById(l);
    C && (C.style.width = A ? "auto" : "100%", C.style.height = A ? "90% " : "auto", C.style.aspectRatio = "16 / 9", C.style.display = "none");
  }, _ = () => {
    const A = document.getElementById(l);
    A && (A.style.display = "inline");
  }, w = (A) => ({
    videoId: e,
    videoTitle: A.getVideoData().title,
    videoType: "youtube",
    videoDurationTotal: A.getDuration(),
    videoPercentageViewed: hc(A),
    videoUrl: A.getVideoUrl()
  }), v = (A) => {
    switch (A.data) {
      case YT.PlayerState.PLAYING:
        y(), x.current = setInterval(
          () => S(A.target),
          mc
        ), a({
          type: "playing",
          base: { ...w(A.target) },
          trackingValue: "play"
        });
        break;
      case YT.PlayerState.ENDED:
        y(), a({
          type: "ended",
          base: { ...w(A.target) },
          trackingValue: "end"
        });
        break;
      case YT.PlayerState.PAUSED:
        y(), S(A.target), a({
          type: "pause",
          base: { ...w(A.target) },
          trackingValue: "pause"
        });
        break;
      default:
        y();
    }
  }, y = () => {
    clearInterval(x.current);
  }, S = (A) => {
    a({
      type: "timeupdate",
      base: { ...w(A) },
      trackingValue: "timeupdate"
    });
  };
  G(() => {
    if (o && d.current && !c.current && e && typeof YT < "u" && YT.Player)
      try {
        c.current = new YT.Player(d.current, {
          videoId: e,
          playerVars: {
            autoplay: 0,
            controls: 1
          },
          host: "https://www.youtube-nocookie.com",
          events: {
            onReady: (A) => {
              h(!0), p(t), E(A.target.getVideoData().title);
            },
            onStateChange: v,
            onError: (A) => {
              const C = (A == null ? void 0 : A.data) || "YOUTUBE_UNKNOWN_ERROR";
              a({
                type: "error",
                base: { ...w(A.target) },
                trackingValue: "videoError",
                errorCode: C
              });
            }
          }
        });
      } catch (A) {
        console.error(`Failed to create YouTube Player with videoId: ${e} - Error: ${A.message}`);
      }
  }, [o, e, t]);
  const N = () => {
    m(!0), o && c.current && f && (_(), c.current.playVideo());
  }, R = () => {
    m(!1), o && c.current && f && c.current.pauseVideo();
  };
  return /* @__PURE__ */ M("div", { className: U["video-player__service--youtube"], children: [
    i && /* @__PURE__ */ u(
      vn,
      {
        preview: i,
        previewAlt: s,
        isPlaying: g,
        fullscreen: t,
        error: g && !e
      }
    ),
    /* @__PURE__ */ u(
      "div",
      {
        className: O(
          U["video-player__content--absolute"],
          g && U["video-player__content--absolute-active"]
        ),
        children: /* @__PURE__ */ u("div", { id: l, ref: d })
      }
    ),
    /* @__PURE__ */ u(
      _n,
      {
        onPlay: N,
        onPause: R,
        isPlaying: g,
        pauseLabel: n,
        playLabel: r,
        videoTitle: b,
        fullscreen: t
      }
    )
  ] });
}, qt = {
  "aws-player": "aws-player",
  "video-js": "video-js",
  "vjs-dock-shelf": "vjs-dock-shelf",
  "vjs-dock-text": "vjs-dock-text",
  "vjs-load-progress": "vjs-load-progress",
  "vjs-volume-bar": "vjs-volume-bar",
  "vjs-volume-level": "vjs-volume-level",
  "vjs-play-progress": "vjs-play-progress",
  "vjs-picture-in-picture-control": "vjs-picture-in-picture-control",
  "vjs-duration-display": "vjs-duration-display",
  "vjs-current-time-display": "vjs-current-time-display",
  "vjs-time-control": "vjs-time-control",
  "vjs-remaining-time": "vjs-remaining-time",
  "vjs-custom-control-spacer": "vjs-custom-control-spacer",
  "vjs-progress-control": "vjs-progress-control",
  "vjs-progress-holder": "vjs-progress-holder",
  "vjs-live-display": "vjs-live-display",
  "vjs-big-play-button": "vjs-big-play-button",
  "aws-player__controls--hidden": "aws-player__controls--hidden",
  "vjs-control-bar": "vjs-control-bar",
  "vjs-loading-spinner": "vjs-loading-spinner",
  "aws-player--fullscreen-videoloop": "aws-player--fullscreen-videoloop",
  "vjs-tech": "vjs-tech",
  "aws-player--fullscreen": "aws-player--fullscreen"
}, _c = (e) => {
  const t = e.currentTime(), i = e.duration();
  return t && i ? Math.round(t / i * 100) : null;
}, vc = ({
  awsServiceBaseUrl: e,
  options: t,
  fullscreen: i,
  videoLoop: s,
  preview: n,
  previewAlt: r,
  pauseLabel: a,
  playLabel: o,
  caption: l,
  videoId: c,
  onVideoStateChange: d
}) => {
  const f = H(null), h = H(null), g = i && !s, m = i && s, [b, E] = V(!1), [x, p] = V(!1), [_, w] = V(!1), v = x && _, y = H(!1), S = H(!1), N = (L) => {
    var k;
    return {
      videoId: c,
      videoTitle: l ?? "",
      videoType: "aws",
      videoDurationTotal: L.duration() ?? 0,
      videoPercentageViewed: _c(L) ?? 0,
      videoUrl: ((k = t.sources) == null ? void 0 : k[0].src) ?? "unknown videoUrl"
    };
  }, R = `${e}${c}`;
  G(() => {
    x && fetch(`${R}/meta.json`).then((L) => L.json()).then((L) => {
      var k;
      h.current ? (k = L.meta.video.text_tracks) == null || k.forEach((I) => {
        var $;
        ($ = h.current) == null || $.addRemoteTextTrack({
          ...I,
          src: `${R}${I.src}`
        });
      }) : console.error("AWS video player: Player not properly initialized");
    }).catch((L) => {
      console.error("AWS video player: Error fetching meta data", L);
    });
  }, [x]), G(() => {
    var L;
    if (h.current) {
      const k = h.current;
      k.autoplay(t.autoplay), k.src(t.sources);
    } else {
      const k = document.createElement("video-js");
      (L = f.current) == null || L.appendChild(k);
      const I = h.current = Hn(k, t, () => {
      });
      I.on("ready", () => {
        p(!0);
      }), I.on("loadedmetadata", () => {
        w(!0);
      }), I.on("seeking", () => {
        S.current = !0;
      }), I.on("seeked", () => {
        y.current = !0;
      }), I.on("play", () => {
        E(!0), y.current ? y.current = !1 : d({
          type: "playing",
          base: { ...N(I) },
          trackingValue: "play"
        });
      }), I.on("pause", () => {
        S.current ? S.current = !1 : d({
          type: "pause",
          base: { ...N(I) },
          trackingValue: "pause"
        });
      }), I.on("ended", () => {
        d({
          type: "ended",
          base: { ...N(I) },
          trackingValue: "end"
        });
      }), I.on("timeupdate", () => {
        d({
          type: "timeupdate",
          base: { ...N(I) },
          trackingValue: "timeupdate"
        });
      }), I.on("error", ($) => {
        var te, K, ie;
        const q = ((ie = (K = (te = $ == null ? void 0 : $.target) == null ? void 0 : te.player) == null ? void 0 : K.error_) == null ? void 0 : ie.code) || "VIDEOJS_UNKNOWN_ERROR";
        d({
          type: "error",
          base: { ...N(I) },
          trackingValue: "videoError",
          errorCode: q
        }), console.error(q);
      });
    }
    return () => {
      const k = h.current;
      k && !k.isDisposed() && (k.dispose(), h.current = null);
    };
  }, []);
  const A = async () => {
    if (h.current && x)
      try {
        await h.current.play();
      } catch (L) {
        console.error("VideoJS (AWS) play failed:", L), E(!1);
      }
  }, C = () => {
    E(!1), h.current && h.current.pause();
  }, P = O(
    qt["aws-player"],
    s && qt["aws-player__controls--hidden"],
    g && qt["aws-player--fullscreen"],
    m && qt["aws-player--fullscreen-videoloop"]
  ), D = O(
    U["video-player__content--relative"],
    i && U["video-player__content--relative--fullscreen"],
    v && U["video-player__content--relative-ready"]
  ), B = O(
    U["video-player__content--absolute"],
    x && b && U["video-player__content--absolute-active"]
  ), z = s ? D : B;
  return /* @__PURE__ */ M("div", { className: U["video-player__service--aws-video-js"], children: [
    !s && n && /* @__PURE__ */ u(
      vn,
      {
        preview: n,
        previewAlt: r,
        isPlaying: b,
        fullscreen: i,
        error: !1
      }
    ),
    /* @__PURE__ */ u("div", { className: z, children: /* @__PURE__ */ u("div", { className: P, "data-vjs-player": !0, children: /* @__PURE__ */ u("div", { ref: f }) }) }),
    /* @__PURE__ */ u(
      _n,
      {
        onPlay: A,
        onPause: C,
        isPlaying: b,
        pauseLabel: a,
        playLabel: o,
        videoTitle: l,
        videoloop: s,
        fullscreen: g
      }
    )
  ] });
}, ts = ({
  awsServiceBaseUrl: e,
  service: t,
  fullscreen: i,
  videoLoop: s,
  caption: n,
  copyright: r,
  slot: a,
  ...o
}) => {
  const l = H(null), c = en(l), d = es(ne.MEDIUM), f = () => i ? s ? !0 : !d : !1, h = () => /* @__PURE__ */ u("div", { ref: l, className: b }), g = (x) => {
    switch (x) {
      case "youtube":
        return /* @__PURE__ */ u(gc, { fullscreen: f(), ...o });
      case "aws":
        if (e) {
          const p = `${e}${o.videoId}/hls/main.m3u8`;
          return /* @__PURE__ */ u(
            vc,
            {
              awsServiceBaseUrl: e,
              fullscreen: f(),
              videoLoop: s,
              options: {
                aspectRatio: re.HD,
                fluid: !0,
                preload: s ? "auto" : "none",
                muted: s,
                loop: s,
                autoplay: s,
                controls: !0,
                playsinline: !!s,
                disablePictureInPicture: !0,
                fullscreen: { navigationUI: "hide" },
                controlBar: {
                  fullscreenToggle: !0,
                  pictureInPictureToggle: !1
                },
                sources: [
                  {
                    src: p,
                    type: "application/x-mpegURL"
                  }
                ]
              },
              ...o
            }
          );
        }
        return console.error("Trying to render AWS video service without supplying video service URL"), h();
      default:
        console.info(`Trying to render not-implemented video service: - ${x}`);
        break;
    }
  }, m = () => (n || r) && /* @__PURE__ */ M("div", { className: U["video-description"], children: [
    n && /* @__PURE__ */ u("figcaption", { className: U["video-description__caption"], children: n }),
    r && /* @__PURE__ */ M("div", { className: U["video-description__copyright"], children: [
      "© ",
      r
    ] })
  ] }), b = O(
    U["video-player__placeholder"],
    i && U["video-player__placeholder--fullscreen"]
  ), E = O(
    U["video-player"],
    i && !s && U["video-player--fullscreen"]
  );
  return c ? /* @__PURE__ */ M("div", { className: E, slot: a, children: [
    g(t),
    m()
  ] }) : h();
}, Mh = ({
  teaserTitle: e,
  teaserOverline: t,
  teaserDescription: i,
  teaserImage: s,
  teaserImageRatio: n,
  teaserImageAlt: r,
  imageOnLeftSide: a = !1,
  primaryButtonUrl: o,
  primaryButtonText: l,
  secondaryButton: c,
  onPrimaryButtonClick: d,
  leftIcon: f,
  rightIcon: h,
  unpublished: g,
  playLabel: m,
  pauseLabel: b,
  onVideoStateChange: E,
  target: x,
  awsServiceBaseUrl: p
}) => {
  const w = es(ne.MEDIUM) ? !0 : a, v = !Number(s), y = s && /* @__PURE__ */ u("div", { className: He["hero-teaser__image-container"], children: v ? /* @__PURE__ */ u(hi, { src: s, alt: r ?? "", ratio: n }) : /* @__PURE__ */ u(
    ts,
    {
      awsServiceBaseUrl: p,
      service: "aws",
      videoId: s,
      previewAlt: r ?? "",
      playLabel: m ?? "",
      pauseLabel: b ?? "",
      videoLoop: !0,
      onVideoStateChange: (N) => {
        E && E(N);
      }
    }
  ) }), S = /* @__PURE__ */ M("div", { className: He["hero-teaser__info-container"], children: [
    /* @__PURE__ */ M("div", { className: He["hero-teaser__text-container"], children: [
      /* @__PURE__ */ M("div", { className: He["hero-teaser__title-container"], children: [
        t && t.length > 0 && /* @__PURE__ */ u("div", { className: He["hero-teaser__overline"], children: t }),
        e && /* @__PURE__ */ u("h2", { className: He["hero-teaser__title"], children: e })
      ] }),
      i && /* @__PURE__ */ u("p", { children: i })
    ] }),
    /* @__PURE__ */ M("div", { className: He["hero-teaser__button-container"], children: [
      l && /* @__PURE__ */ u(
        Lt,
        {
          target: x || ci.SELF,
          hasMarginTop: !1,
          href: o,
          appearance: Me.SECONDARY,
          text: l,
          onClick: d,
          leftIcon: f,
          rightIcon: h
        }
      ),
      c
    ] })
  ] });
  return /* @__PURE__ */ u("section", { className: O(He["hero-teaser"], g && He["hero-teaser--unpublished"]), children: w ? /* @__PURE__ */ M(Qe, { children: [
    y,
    " ",
    S
  ] }) : /* @__PURE__ */ M(Qe, { children: [
    S,
    " ",
    y
  ] }) });
}, Ps = {
  "highlight-box": "highlight-box",
  "highlight-box--transparent": "highlight-box--transparent",
  "highlight-box--theme-aware": "highlight-box--theme-aware",
  "highlight-box--neutral": "highlight-box--neutral",
  "highlight-box--neutral-100": "highlight-box--neutral-100",
  "highlight-box--neutral-200": "highlight-box--neutral-200",
  "highlight-box--grey": "highlight-box--grey",
  "highlight-box--grey-50": "highlight-box--grey-50",
  "highlight-box--grey-100": "highlight-box--grey-100",
  "highlight-box--grey-200": "highlight-box--grey-200",
  "highlight-box--grey-300": "highlight-box--grey-300",
  "highlight-box--white": "highlight-box--white"
}, Ch = ({ color: e, children: t }) => /* @__PURE__ */ u("section", { className: O(Ps["highlight-box"], Ps[`highlight-box--${e}`]), children: t }), wc = {
  "horizontal-center": "horizontal-center"
}, Ih = ({ children: e, slot: t }) => e != null && (Array.isArray(e) ? e.length > 0 : !0) ? /* @__PURE__ */ u("div", { className: wc["horizontal-center"], slot: t, children: e }) : null, bc = "input", yc = "input__wrapper", Ec = "input__label", xc = "input__hint", Sc = "input__input", Tc = "input__error", Ee = {
  input: bc,
  input__wrapper: yc,
  "input--disabled": "input--disabled",
  input__label: Ec,
  input__hint: xc,
  input__input: Sc,
  "input--error": "input--error",
  "input__label-wrapper": "input__label-wrapper",
  input__error: Tc,
  "input__error-text": "input__error-text",
  "input__clear-button": "input__clear-button"
};
var Xt = /* @__PURE__ */ ((e) => (e.TEXT = "text", e.EMAIL = "email", e.TEXTAREA = "textarea", e.SEARCH = "search", e))(Xt || {});
const Nc = "16px", Rh = ({
  id: e,
  label: t,
  value: i,
  placeholder: s,
  required: n = !1,
  className: r,
  tooltip: a,
  tooltipAriaLabel: o,
  type: l = Xt.TEXT,
  maxLength: c,
  hint: d,
  error: f,
  disabled: h = !1,
  withOptionalLabel: g = !0,
  translations: m,
  valid: b,
  dirty: E,
  hintParsed: x,
  onBlur: p,
  onChange: _
}) => {
  const w = E && !b, v = `${e}-error`, y = `${e}-hint`, S = O(
    Ee.input,
    w && Ee["input--error"],
    h && Ee["input--disabled"],
    r
  ), N = !!(t || n || d), R = [d && y, w && v].filter(Boolean).join(" "), A = (z) => {
    _(z.target.value);
  }, C = (z) => {
    _(z.target.value);
  }, P = () => {
    _("");
  }, D = () => l === Xt.SEARCH && i ? /* @__PURE__ */ u(
    "button",
    {
      className: Ee["input__clear-button"],
      onClick: P,
      "aria-label": m == null ? void 0 : m.clearInput,
      children: /* @__PURE__ */ u(F, { icon: "cross", height: Nc })
    }
  ) : null, B = () => /* @__PURE__ */ M("div", { className: Ee.input__wrapper, children: [
    l !== Xt.TEXTAREA ? /* @__PURE__ */ u(
      "input",
      {
        id: e,
        className: Ee.input__input,
        maxLength: c || void 0,
        placeholder: s,
        disabled: h,
        value: i,
        "aria-invalid": w,
        "aria-describedby": R || void 0,
        onBlur: p,
        onChange: A,
        type: l
      }
    ) : /* @__PURE__ */ u(
      "textarea",
      {
        id: e,
        className: Ee.input__input,
        maxLength: c || void 0,
        placeholder: s,
        disabled: h,
        value: i,
        "aria-invalid": w,
        "aria-describedby": R || void 0,
        onBlur: p,
        onChange: C,
        rows: 5
      }
    ),
    D()
  ] });
  return /* @__PURE__ */ M("div", { className: S, children: [
    N && /* @__PURE__ */ M("div", { className: Ee["input__label-wrapper"], children: [
      /* @__PURE__ */ M("label", { className: Ee.input__label, htmlFor: e, children: [
        t,
        !n && g && (m == null ? void 0 : m.optional) && ` ${m.optional}`
      ] }),
      a && /* @__PURE__ */ u(Ji, { ariaLabel: o, children: a }),
      d && /* @__PURE__ */ u("span", { id: y, className: Ee.input__hint, children: x })
    ] }),
    B(),
    /* @__PURE__ */ u("div", { id: v, className: Ee.input__error, ...w && { role: "alert" }, children: w && /* @__PURE__ */ M(Qe, { children: [
      /* @__PURE__ */ u(F, { icon: "info", width: "16px", decorative: !0 }),
      /* @__PURE__ */ u("p", { className: Ee["input__error-text"], children: f || `${m == null ? void 0 : m.error} ${t}` })
    ] }) })
  ] });
}, kc = {
  "lead-text": "lead-text",
  "highlight-box": "highlight-box"
}, Oh = ({ lead: e }) => /* @__PURE__ */ u("p", { className: kc["lead-text"], children: e }), Ei = {
  "loading-spinner": "loading-spinner",
  "loading-spinner__icon-container": "loading-spinner__icon-container",
  "loading-spinner__text": "loading-spinner__text"
}, Ac = "loading", Mc = "24px", Cc = ({ loadingText: e }) => /* @__PURE__ */ M("div", { className: Ei["loading-spinner"], children: [
  /* @__PURE__ */ u("div", { className: Ei["loading-spinner__icon-container"], children: /* @__PURE__ */ u(F, { icon: Ac, height: Mc, decorative: !0, display: "inline" }) }),
  /* @__PURE__ */ u("div", { className: Ei["loading-spinner__text"], "aria-live": "polite", "aria-busy": "true", children: e })
] }), Ic = "magnet", Rc = {
  magnet: Ic
}, Lh = () => /* @__PURE__ */ u("div", { className: Rc.magnet }), Oc = "marketo", Lc = "mktoForm", Pc = "mktoFormRow", Dc = "mktoFormCol", $c = "LblConsent_given_to_contact_for_Mktg_Info__c", zc = "LblConsent_given_to_store_data_in_Data_Base__c", Vc = "LblconsentforDataTracking", Bc = "mktoFieldWrap", Hc = "mktoError", Fc = "mktoRequiredField", Gc = "mktoCheckboxList", qc = "mktoRadioList", jc = "mktoButtonRow", Uc = "mktoButtonWrap", Wc = "mktoButton", Yc = "mktoHtmlText", Xc = "mktoDateButton", Zc = "mktoLabel", Kc = "mktoAsterix", Qc = "mktoErrorMsg", Jc = "mktoErrorDetail", ed = "mktoErrorArrowWrap", td = "mktoInvalid", id = "mktoOffset", sd = "mktoGutter", nd = {
  marketo: Oc,
  mktoForm: Lc,
  mktoFormRow: Pc,
  mktoFormCol: Dc,
  LblConsent_given_to_contact_for_Mktg_Info__c: $c,
  LblConsent_given_to_store_data_in_Data_Base__c: zc,
  LblconsentforDataTracking: Vc,
  mktoFieldWrap: Bc,
  mktoError: Hc,
  mktoRequiredField: Fc,
  mktoCheckboxList: Gc,
  mktoRadioList: qc,
  mktoButtonRow: jc,
  mktoButtonWrap: Uc,
  mktoButton: Wc,
  mktoHtmlText: Yc,
  mktoDateButton: Xc,
  mktoLabel: Zc,
  mktoAsterix: Kc,
  mktoErrorMsg: Qc,
  mktoErrorDetail: Jc,
  mktoErrorArrowWrap: ed,
  mktoInvalid: td,
  mktoOffset: id,
  mktoGutter: sd
}, Ph = ({ children: e }) => /* @__PURE__ */ u("div", { className: nd.marketo, children: e }), rd = "podcast", ad = "podcast__iframe", si = {
  podcast: rd,
  "podcast--soundcloud": "podcast--soundcloud",
  podcast__iframe: ad,
  "podcast--spotify": "podcast--spotify",
  "podcast--spotify-creators": "podcast--spotify-creators",
  "podcast--transistor": "podcast--transistor"
}, wn = [10, 25, 50, 75, 100], od = 80, ld = ({ src: e, onPodcastStateChange: t }) => {
  const i = H(null), s = H(null), [n, r] = V(null), [a, o] = V(!1), l = H(/* @__PURE__ */ new Set()), c = (b, E) => ({
    audioName: "Spotify Podcast",
    audioUrl: e,
    audioProvider: "spotify",
    audioDurationTotal: b,
    audioPercentage: E
  }), d = () => {
    l.current.clear();
  }, f = (b) => {
    const { position: E, duration: x } = b.data;
    if (x === 0) {
      g("No audio found");
      return;
    }
    const p = E / x * 100;
    for (const _ of wn)
      p >= _ && !l.current.has(_) && (l.current.add(_), t(_ === 100 ? {
        type: "completed",
        base: c(x, p),
        trackingValue: "audioComplete"
      } : {
        type: "progress",
        base: c(x, _),
        trackingValue: "audioProgress"
      }));
  }, h = (b) => {
    const { duration: E } = b.data;
    if (E === 0) {
      g("No audio found");
      return;
    }
    d(), t({
      type: "starting",
      base: c(E, 0),
      trackingValue: "audioStart"
    });
  }, g = (b) => {
    t({
      type: "error",
      base: c(0, 0),
      trackingValue: "audioError",
      errorMessage: b
    });
  }, m = (b) => {
    const E = b.match(/open\.spotify\.com\/embed\/(\w+)\/([\w\d]+)/);
    if (!E)
      return g("Failed to generate Spotify URI"), null;
    const [, x, p] = E;
    return `spotify:${x}:${p}`;
  };
  return G(() => {
    const b = document.createElement("script");
    return b.src = "https://open.spotify.com/embed/iframe-api/v1", b.async = !0, document.body.appendChild(b), () => {
      document.body.removeChild(b);
    };
  }, []), G(() => {
    n || (window.onSpotifyIframeApiReady = (b) => {
      r(b);
    });
  }, [n]), G(() => {
    if (!(a || n === null || !i.current))
      return n.createController(
        i.current,
        {
          height: od,
          uri: m(e) || ""
        },
        (b) => {
          b.addListener("ready", () => {
            o(!0);
          }), b.addListener("playback_started", h), b.addListener("playback_update", f), s.current = b;
        }
      ), () => {
        s.current && s.current.removeListener("playback_update");
      };
  }, [a, n, e]), /* @__PURE__ */ u(
    "iframe",
    {
      ref: i,
      className: si.podcast__iframe,
      title: "Podcast Player",
      src: e,
      width: "100%",
      seamless: !0,
      allow: "autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture",
      allowFullScreen: !0,
      loading: "lazy"
    }
  );
}, cd = ({ src: e, onPodcastStateChange: t }) => {
  const i = H(null), s = H(null), [n, r] = V(!1), [a, o] = V(""), [l, c] = V(0), d = H(/* @__PURE__ */ new Set()), f = H(!1), h = Re(
    (p, _, w) => ({
      audioName: p,
      audioUrl: e,
      audioProvider: "soundcloud",
      audioDurationTotal: _,
      audioPercentage: w
    }),
    [e]
  ), g = () => {
    d.current.clear(), f.current = !1;
  }, m = Re(() => {
    if (window.SC && typeof window.SC.Widget == "function") {
      r(!0);
      return;
    }
    const p = document.createElement("script");
    p.src = "https://w.soundcloud.com/player/api.js", p.async = !0, p.onload = () => r(!0), p.onerror = () => {
      t({
        type: "error",
        base: h("SoundCloud Player", 0, 0),
        errorMessage: "Failed to load SoundCloud Widget API",
        trackingValue: "audioError"
      });
    }, document.body.appendChild(p);
  }, [h, t]), b = Re(() => {
    !s.current || f.current || (f.current = !0, s.current.getCurrentSound((p) => {
      p && (o(p.title), c(p.duration), t({
        type: "starting",
        base: h(p.title, p.duration, 0),
        trackingValue: "audioStart"
      }));
    }));
  }, [h, t]), E = Re(
    (p) => {
      const _ = Math.round(p.relativePosition * 100);
      for (const w of wn)
        _ >= w && !d.current.has(w) && (d.current.add(w), t({
          type: "progress",
          base: h(a, l, w),
          trackingValue: "audioProgress"
        }));
    },
    [h, l, t, a]
  ), x = Re(() => {
    t({
      type: "completed",
      base: h(a, l, 100),
      trackingValue: "audioComplete"
    }), g();
  }, [h, l, t, a]);
  return G(() => {
    m();
  }, [m]), G(() => {
    n && i.current && (s.current = new window.SC.Widget(i.current));
  }, [n]), G(() => {
    const p = s.current;
    if (p)
      return p.bind(window.SC.Widget.Events.PLAY, b), p.bind(window.SC.Widget.Events.PLAY_PROGRESS, E), p.bind(window.SC.Widget.Events.FINISH, x), () => {
        p.unbind(window.SC.Widget.Events.PLAY, b), p.unbind(window.SC.Widget.Events.PLAY_PROGRESS, E), p.unbind(window.SC.Widget.Events.FINISH, x);
      };
  }, [b, E, x]), /* @__PURE__ */ u(
    "iframe",
    {
      ref: i,
      className: si.podcast__iframe,
      title: "SoundCloud Player",
      src: e,
      width: "100%",
      allow: "autoplay",
      allowFullScreen: !0,
      loading: "lazy",
      seamless: !0
    }
  );
}, Dh = ({ src: e, provider: t, slot: i, onPodcastStateChange: s }) => {
  const n = H(null), r = en(n);
  return /* @__PURE__ */ M("div", { className: O(si.podcast, `podcast--${t}`), slot: i, ref: n, children: [
    r && (t === "spotify-creators" || t === "spotify") && /* @__PURE__ */ u(ld, { src: e, onPodcastStateChange: s }),
    r && t === "soundcloud" && /* @__PURE__ */ u(cd, { src: e, onPodcastStateChange: s }),
    t === "transistor" && /* @__PURE__ */ u(
      "iframe",
      {
        className: si.podcast__iframe,
        title: "Podcast Player",
        src: e,
        width: "100%",
        seamless: !0,
        allow: "autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture",
        allowFullScreen: !0,
        loading: "lazy"
      }
    )
  ] });
}, dd = {
  "published-date": "published-date"
}, $h = ({ publishedDate: e }) => /* @__PURE__ */ u("div", { className: dd["published-date"], children: /* @__PURE__ */ u("time", { children: e }) }), ud = "image", Fe = {
  "roche-quote": "roche-quote",
  "roche-quote__image": "roche-quote__image",
  image: ud,
  "roche-quote__content": "roche-quote__content",
  "roche-quote__text": "roche-quote__text",
  "roche-quote__text--small": "roche-quote__text--small",
  "roche-quote__subline": "roche-quote__subline",
  "roche-quote__link": "roche-quote__link",
  "roche-quote--with-image": "roche-quote--with-image",
  "roche-quote--equal-ratio": "roche-quote--equal-ratio"
};
var zi = /* @__PURE__ */ ((e) => (e.BIG = "big", e.SMALL = "small", e))(zi || {}), Vi = /* @__PURE__ */ ((e) => (e.WITH_IMAGE = "with-image", e.NORMAL = "normal", e))(Vi || {});
const zh = ({
  quote: e,
  size: t = zi.BIG,
  layout: i = Vi.NORMAL,
  isEqualRatio: s = !1,
  image: n,
  sublines: r,
  link: a
}) => {
  const o = i === Vi.WITH_IMAGE, l = t === zi.SMALL, c = O(Fe["roche-quote"], {
    [Fe["roche-quote--with-image"]]: o,
    [Fe["roche-quote--equal-ratio"]]: s
  }), d = O(Fe["roche-quote__text"], {
    [Fe["roche-quote__text--small"]]: l
  });
  return /* @__PURE__ */ M("figure", { className: c, children: [
    o && /* @__PURE__ */ u("div", { className: Fe["roche-quote__image"], children: n }),
    /* @__PURE__ */ M("div", { className: Fe["roche-quote__content"], children: [
      /* @__PURE__ */ u("blockquote", { children: /* @__PURE__ */ u("p", { className: d, children: e }) }),
      /* @__PURE__ */ M("figcaption", { children: [
        r && r.length > 0 && /* @__PURE__ */ u("div", { className: Fe["roche-quote__subline"], children: r }),
        o && a && /* @__PURE__ */ u("div", { className: Fe["roche-quote__link"], children: a })
      ] })
    ] })
  ] });
}, fd = "grid__column", pd = "gnw_table_border_collapse", hd = "gnw_heading", md = "gnw_subhead", gd = "gnw_colhead", _d = "gnw_colhead_uline", vd = "gnw_colhead_dline", wd = "gnw_label", bd = "gnw_label_uline", yd = "gnw_label_uline_i10", Ed = "gnw_label_uline_i15", xd = "gnw_label_uline_i20", Sd = "gnw_label_uline_i25", Td = "gnw_label_uline_i30", Nd = "gnw_label_dline_i10", kd = "gnw_label_dline_i15", Ad = "gnw_label_dline_i20", Md = "gnw_label_dline_i25", Cd = "gnw_label_dline_i30", Id = "gnw_label_ulinetop", Rd = "gnw_label_dline", Od = "gnw_label_i10", Ld = "gnw_label_i15", Pd = "gnw_label_i20", Dd = "gnw_label_i25", $d = "gnw_label_i30", zd = "gnw_num", Vd = "gnw_num_uline", Bd = "gnw_num_ulinetop", Hd = "gnw_num_dline", Fd = "gnw_num_dlinetop", Gd = "gnw_data", qd = "gnw_data_uline", jd = "gnw_data_dline", Ud = "gnw_news_media_box", Wd = "gnw_media_caption", Yd = "gnw_media_bgcolor", Xd = "gnw_table", Zd = "gnw_videotitle", Kd = "gnw_border_top_solid", Qd = "gnw_border_right_solid", Jd = "gnw_border_bottom_solid", eu = "gnw_border_left_solid", tu = "gnw_border_top_double", iu = "gnw_border_right_double", su = "gnw_border_bottom_double", nu = "gnw_border_left_double", ru = "gnw_align_left", au = "gnw_align_center", ou = "gnw_align_right", lu = "gnw_align_justify", cu = "gnw_vertical_align_top", du = "gnw_vertical_align_middle", uu = "gnw_vertical_align_bottom", fu = "gnw_padding_left_none", pu = "gnw_padding_right_none", hu = "gnw_table_border_spacing", mu = "gnw_release_detail_printview", gu = "gnw_hidden_cell", _u = "hugin", vu = "superscript", wu = "subscript", bu = "headline", xi = {
  "no-print": "no-print",
  "print-grid-full-width": "print-grid-full-width",
  grid__column: fd,
  "is-8": "is-8",
  "is-1": "is-1",
  "is-3": "is-3",
  "rich-text": "rich-text",
  gnw_table_border_collapse: pd,
  gnw_heading: hd,
  gnw_subhead: md,
  gnw_colhead: gd,
  gnw_colhead_uline: _d,
  gnw_colhead_dline: vd,
  gnw_label: wd,
  gnw_label_uline: bd,
  gnw_label_uline_i10: yd,
  gnw_label_uline_i15: Ed,
  gnw_label_uline_i20: xd,
  gnw_label_uline_i25: Sd,
  gnw_label_uline_i30: Td,
  gnw_label_dline_i10: Nd,
  gnw_label_dline_i15: kd,
  gnw_label_dline_i20: Ad,
  gnw_label_dline_i25: Md,
  gnw_label_dline_i30: Cd,
  gnw_label_ulinetop: Id,
  gnw_label_dline: Rd,
  gnw_label_i10: Od,
  gnw_label_i15: Ld,
  gnw_label_i20: Pd,
  gnw_label_i25: Dd,
  gnw_label_i30: $d,
  gnw_num: zd,
  gnw_num_uline: Vd,
  gnw_num_ulinetop: Bd,
  gnw_num_dline: Hd,
  gnw_num_dlinetop: Fd,
  gnw_data: Gd,
  gnw_data_uline: qd,
  gnw_data_dline: jd,
  gnw_news_media_box: Ud,
  gnw_media_caption: Wd,
  gnw_media_bgcolor: Yd,
  gnw_table: Xd,
  gnw_videotitle: Zd,
  gnw_border_top_solid: Kd,
  gnw_border_right_solid: Qd,
  gnw_border_bottom_solid: Jd,
  gnw_border_left_solid: eu,
  gnw_border_top_double: tu,
  gnw_border_right_double: iu,
  gnw_border_bottom_double: su,
  gnw_border_left_double: nu,
  gnw_align_left: ru,
  gnw_align_center: au,
  gnw_align_right: ou,
  gnw_align_justify: lu,
  gnw_vertical_align_top: cu,
  gnw_vertical_align_middle: du,
  gnw_vertical_align_bottom: uu,
  gnw_padding_left_none: fu,
  gnw_padding_right_none: pu,
  gnw_table_border_spacing: hu,
  gnw_release_detail_printview: mu,
  "logo-area_printview": "logo-area_printview",
  gnw_hidden_cell: gu,
  "rich-text--is-footnote": "rich-text--is-footnote",
  "text-link": "text-link",
  "text-link__link": "text-link__link",
  "text-link__icon-container": "text-link__icon-container",
  "rich-text--is-footer-type": "rich-text--is-footer-type",
  hugin: _u,
  superscript: vu,
  subscript: wu,
  headline: bu,
  "icon-container": "icon-container"
}, Vh = ({
  children: e,
  isFootnote: t,
  isFooterType: i,
  markup: s,
  slot: n,
  dir: r
}) => {
  const a = {
    ...s && { dangerouslySetInnerHTML: { __html: s } }
  };
  return /* @__PURE__ */ u(
    "div",
    {
      slot: n,
      dir: r,
      ...a,
      className: O(
        xi["rich-text"],
        t && xi["rich-text--is-footnote"],
        i && xi["rich-text--is-footer-type"]
      ),
      children: e
    }
  );
}, yu = "search", Eu = "search__title", xu = "teaser", Su = "tabs", Tu = "search__counter", Nu = "search__pagination", Y = {
  search: yu,
  "search__sr-announcement": "search__sr-announcement",
  search__title: Eu,
  "search__input-container": "search__input-container",
  "search__loading-container": "search__loading-container",
  "search__support-content-wrapper": "search__support-content-wrapper",
  "search__popular-searches": "search__popular-searches",
  "search__quick-links": "search__quick-links",
  teaser: xu,
  "search__quick-links-title": "search__quick-links-title",
  "search__results-container": "search__results-container",
  tabs: Su,
  search__counter: Tu,
  "search__results-heading": "search__results-heading",
  "search__results-list": "search__results-list",
  "search__no-results": "search__no-results",
  "search__no-results-title": "search__no-results-title",
  "search__no-results-message": "search__no-results-message",
  "search__teaser-container": "search__teaser-container",
  "search__teaser-container--eight-columns": "search__teaser-container--eight-columns",
  "search__teaser-container--loading": "search__teaser-container--loading",
  search__pagination: Nu,
  "search__pagination--eight-columns": "search__pagination--eight-columns",
  "data-search": "data-search",
  "data-search--with-input": "data-search--with-input"
}, ku = "pagination", Au = "pagination__row", Mu = "pagination__item", Cu = "pagination__icon", Iu = "pagination__button", Ru = "pagination__separator", Z = {
  pagination: ku,
  pagination__row: Au,
  "pagination__large-numbers": "pagination__large-numbers",
  "pagination__small-numbers": "pagination__small-numbers",
  pagination__item: Mu,
  "pagination__item--colored": "pagination__item--colored",
  "pagination__item--active": "pagination__item--active",
  "pagination__item-text": "pagination__item-text",
  "pagination__item--disabled": "pagination__item--disabled",
  pagination__icon: Cu,
  pagination__button: Iu,
  pagination__separator: Ru,
  "pagination__visually-hidden": "pagination__visually-hidden"
}, ni = "…", Ou = ({ label: e }) => /* @__PURE__ */ u("span", { className: Z["pagination__item-text"], "aria-hidden": "true", children: e }), Ds = ({ enabled: e, onClick: t, onFocus: i, icon: s, label: n }) => /* @__PURE__ */ u(
  "li",
  {
    className: O(
      {
        [Z["pagination__item--disabled"]]: !e
      },
      Z.pagination__item,
      Z["pagination__item--colored"]
    ),
    children: /* @__PURE__ */ u(
      "button",
      {
        className: Z.pagination__button,
        onClick: t,
        onFocus: () => i && i(),
        onMouseEnter: () => i && i(),
        disabled: !e,
        "aria-disabled": !e,
        "aria-label": n,
        type: "button",
        children: /* @__PURE__ */ u("span", { className: Z.pagination__icon, children: /* @__PURE__ */ u(F, { icon: s, width: `${Pe(24)}rem`, height: `${Pe(24)}rem` }) })
      }
    )
  }
), Lu = ({
  page: e,
  isActive: t,
  setPage: i,
  focusPage: s,
  pageLabel: n,
  currentPageLabel: r
}) => {
  const a = `${n} ${e}`, o = t ? `${a}, ${r}` : a;
  return /* @__PURE__ */ u(
    "li",
    {
      className: O(
        Z["pagination__large-numbers"],
        Z.pagination__item,
        Z["pagination__item--colored"],
        {
          [Z["pagination__item--active"]]: t
        }
      ),
      children: /* @__PURE__ */ u(
        "button",
        {
          className: Z.pagination__button,
          onClick: () => i(e),
          onMouseOver: () => {
            s && !t && s(e);
          },
          onFocus: () => {
            s && !t && s(e);
          },
          "aria-current": t ? "page" : void 0,
          "aria-label": o,
          tabIndex: t ? -1 : void 0,
          type: "button",
          children: /* @__PURE__ */ u(Ou, { label: e })
        }
      )
    },
    `page-${e}`
  );
}, Pu = ({ index: e }) => /* @__PURE__ */ u(
  "li",
  {
    className: O(
      Z["pagination__large-numbers"],
      Z["pagination__item--disabled"],
      Z.pagination__item
    ),
    "aria-hidden": "true",
    role: "presentation",
    children: /* @__PURE__ */ u("span", { className: Z["pagination__item-text"], children: ni })
  },
  `ellipsis-${e}`
), Si = (e, t) => Array.from({ length: t - e }, (i, s) => s + e), Du = (e, t, i) => {
  const { floor: s, min: n, max: r } = Math;
  if (i <= e)
    return Si(1, i + 1);
  const a = e - 4, o = s(a / 2);
  let l = r(2, t - o), c = n(i - 1, t + o), d = l - 2, f = i - 1 - c;
  if (d <= 1 && f > 1) {
    l = 2;
    const g = l + e - 4;
    c = r(g, t + 1);
  } else if (f <= 1 && d > 1) {
    c = i - 1;
    const g = c - e + 4;
    l = n(g, t - 1);
  } else if (d <= 1 && f <= 1)
    return Si(1, i + 1);
  d = l - 2, f = i - 1 - c;
  const h = [1];
  return d > 1 ? h.push(ni) : d === 1 && h.push(2), h.push(...Si(l, c + 1)), f > 1 ? h.push(ni) : f === 1 && h.push(i - 1), h.push(i), h;
}, $u = ({
  totalPages: e,
  activePage: t,
  visiblePages: i,
  disableScrollTarget: s = !1,
  onPageChange: n,
  onPagePrefetch: r,
  scrollTarget: a,
  className: o,
  ariaLabels: l = {}
}) => {
  const {
    navigationLabel: c = "Search navigation",
    previousPageLabel: d = "Previous page",
    nextPageLabel: f = "Next page",
    pageLabel: h = "Page",
    currentPageLabel: g = "current page",
    pageStatusLabel: m = "Page {current} of {total}"
  } = l, b = Math.max(Math.ceil(e), 1);
  if (b === 1)
    return null;
  const E = (_) => {
    t !== _ && (n && n(_), !s && (a == null || a.scrollIntoView({ behavior: "smooth", block: "start" })));
  }, p = Du(i, t, b).map((_, w) => {
    if (_ === ni)
      return /* @__PURE__ */ u(Pu, { index: w }, `ellipsis-${w}`);
    const v = _;
    return /* @__PURE__ */ u(
      Lu,
      {
        page: v,
        isActive: v === t,
        setPage: E,
        focusPage: r,
        pageLabel: h,
        currentPageLabel: g
      },
      v
    );
  });
  return /* @__PURE__ */ M("nav", { className: O(Z.pagination, o), "aria-label": c, children: [
    /* @__PURE__ */ u("div", { role: "status", "aria-live": "polite", "aria-atomic": "true", className: Z["pagination__visually-hidden"], children: m.replaceAll("{current}", `${t}`).replaceAll("{total}", `${b}`) }),
    /* @__PURE__ */ M("ol", { className: Z.pagination__row, children: [
      /* @__PURE__ */ u(
        Ds,
        {
          enabled: t !== 1,
          onClick: () => {
            t > 1 && E(t - 1);
          },
          onFocus: () => {
            r && t > 1 && r(t - 1);
          },
          icon: "chevron-left",
          label: d
        }
      ),
      p,
      /* @__PURE__ */ u("li", { className: O(Z.pagination__item, Z["pagination__small-numbers"]), "aria-hidden": "true", children: /* @__PURE__ */ M("span", { className: Z["pagination__item-text"], children: [
        t,
        " ",
        /* @__PURE__ */ u("span", { className: Z.pagination__separator }),
        " ",
        b
      ] }) }),
      /* @__PURE__ */ u(
        Ds,
        {
          enabled: t !== b,
          onClick: () => {
            t < b && E(t + 1);
          },
          onFocus: () => {
            r && t < b && r(t + 1);
          },
          icon: "chevron-right",
          label: f
        }
      )
    ] })
  ] });
}, $s = 2;
function zu(e) {
  const [t, i] = V("none"), s = Re(() => {
    const n = e.current;
    if (!n) {
      i("none");
      return;
    }
    const r = document.documentElement.dir === "rtl", a = n.scrollLeft, o = n.clientWidth, l = n.scrollWidth, c = r ? a - $s > o - l : a > 0, d = l - o, f = r ? a < 0 : a + $s < d;
    i(c && f ? "both" : c ? "left" : f ? "right" : "none");
  }, [e.current]);
  return G(() => {
    const n = e.current;
    if (n)
      return s(), n.addEventListener("scroll", s), window.addEventListener("resize", s), () => {
        n.removeEventListener("scroll", s), window.removeEventListener("resize", s);
      };
  }, [s]), t;
}
const Vu = "tabs", Bu = "tabs__tab", Hu = "tabs__panel", xe = {
  tabs: Vu,
  tabs__tab: Bu,
  "tabs__tab--active": "tabs__tab--active",
  "tabs__tab-label": "tabs__tab-label",
  tabs__panel: Hu,
  "tabs__panel--active": "tabs__panel--active",
  "tabs__tab-list": "tabs__tab-list",
  "tabs__tab-list--blur-left": "tabs__tab-list--blur-left",
  "tabs__tab-list--blur-right": "tabs__tab-list--blur-right",
  "tabs__tab-list--blur-both": "tabs__tab-list--blur-both",
  "tabs__tab-list--filter": "tabs__tab-list--filter",
  "tabs__tab-list--filter-gray": "tabs__tab-list--filter-gray",
  "tabs--centered": "tabs--centered",
  "tabs__tab-list-wrapper": "tabs__tab-list-wrapper"
}, zs = ({
  initiallySelected: e = 0,
  appearance: t = "default",
  autoScroll: i = !0,
  centered: s = !1,
  tabs: n,
  children: r,
  slot: a,
  onTabClick: o
}) => {
  const [l, c] = V(e), d = H([]), f = H(null), h = zu(f), [g, m] = Qs(), { scrollToItem: b } = Js(d);
  G(() => {
    const v = g.substring(1), y = (n == null ? void 0 : n.findIndex((R) => R.id === v)) ?? null, S = e >= 0 && e < ((n == null ? void 0 : n.length) ?? 0) ? e : null, N = y !== null && y >= 0 ? y : S ?? 0;
    c(N), y !== null && d.current[y] && i && setTimeout(() => b(y), 0);
  }, [e]);
  const E = (v) => {
    var N;
    const S = v === e ? "" : ((N = n == null ? void 0 : n[v]) == null ? void 0 : N.id) || "";
    m(S);
  }, x = (v) => {
    var A;
    const y = (n == null ? void 0 : n.findIndex((C) => C.id === v.currentTarget.id)) ?? null;
    if (y === null || y < 0 || y === l)
      return;
    c(y), E(y);
    const S = n == null ? void 0 : n[y ?? 0], N = (S == null ? void 0 : S.headline) || "", R = (S == null ? void 0 : S.id) || "";
    d.current[y] && ((A = d.current[y]) == null || A.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" })), o == null || o(v, N, R);
  }, p = (v) => {
    var C, P, D, B;
    if (!n || n.length === 0 || !v.key)
      return;
    const { key: y } = v, S = {
      ArrowRight: (z, L) => (z + 1) % L,
      ArrowLeft: (z, L) => (z - 1 + L) % L,
      Home: () => 0,
      End: (z, L) => L - 1
    };
    if (!S[y])
      return;
    v.preventDefault();
    const N = S[y](l, n.length);
    if (N === l)
      return;
    c(N), E(N), (C = d.current[N]) == null || C.focus(), (P = d.current[N]) == null || P.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
    const R = ((D = n == null ? void 0 : n[N]) == null ? void 0 : D.headline) || "", A = ((B = n == null ? void 0 : n[N]) == null ? void 0 : B.id) || "";
    o == null || o(v, R, A);
  }, _ = O(xe.tabs, s && xe["tabs--centered"]), w = O(
    xe["tabs__tab-list"],
    (t === "filter" || t === "filter-gray") && xe["tabs__tab-list--filter"],
    t === "filter-gray" && xe["tabs__tab-list--filter-gray"],
    h !== "none" && xe[`tabs__tab-list--blur-${h}`]
  );
  return /* @__PURE__ */ M("div", { className: _, slot: a, children: [
    /* @__PURE__ */ u("div", { className: xe["tabs__tab-list-wrapper"], children: /* @__PURE__ */ u("div", { className: w, role: "tablist", ref: f, children: n == null ? void 0 : n.map((v, y) => /* @__PURE__ */ u(
      "button",
      {
        className: O(xe.tabs__tab, l === y && xe["tabs__tab--active"]),
        id: v.id,
        type: "button",
        role: "tab",
        "aria-selected": l === y,
        "aria-controls": `panel-${v.id}`,
        tabIndex: l === y ? 0 : -1,
        onClick: x,
        onKeyDown: p,
        ref: (S) => d.current[y] = S,
        children: /* @__PURE__ */ u("span", { className: xe["tabs__tab-label"], children: v.headline })
      },
      v.headline
    )) }) }),
    r == null ? void 0 : r.map((v, y) => {
      var S, N;
      return /* @__PURE__ */ u(
        "div",
        {
          className: O(xe.tabs__panel, l === y && xe["tabs__panel--active"]),
          id: `panel-${(S = n == null ? void 0 : n[y]) == null ? void 0 : S.id}`,
          role: "tabpanel",
          "aria-labelledby": (N = n == null ? void 0 : n[y]) == null ? void 0 : N.id,
          hidden: l !== y,
          tabIndex: 0,
          children: v
        },
        y
      );
    })
  ] });
}, Fu = ({
  variant: e,
  tabs: t,
  currentTab: i,
  alwaysShowTabs: s,
  searchQuery: n,
  setSearchParams: r,
  currentPage: a,
  totalResultFoundText: o,
  itemRenderer: l,
  labels: c,
  onPagePrefetch: d,
  isTabSwitchLoading: f
}) => {
  if (!i) return null;
  const h = t.findIndex((g) => g.tab === i);
  if (e === "main")
    return /* @__PURE__ */ u(
      zs,
      {
        autoScroll: !1,
        tabs: t.map((g) => ({
          headline: `${g.title} (${g.totalItems})`,
          id: g.tab
        })),
        onTabClick: (g, m, b) => {
          const E = t.map((x) => x.tab).find((x) => x === b);
          r({
            query: n,
            page: 1,
            activeTab: E
          });
        },
        appearance: "filter",
        initiallySelected: h,
        children: t.map((g) => /* @__PURE__ */ u(
          Vs,
          {
            title: g.title,
            labels: c,
            tab: g.tab,
            resultVariant: g.variant,
            searchVariant: e,
            items: g.items,
            itemRenderer: l,
            totalItems: g.totalItems,
            totalResultsFoundText: o,
            onPagePrefetch: (m, b) => d && d(m, b),
            onPageChange: (m, b) => {
              r({
                query: n,
                page: b,
                activeTab: m
              });
            },
            currentPage: a,
            isTabSwitchLoading: f
          },
          `roche-search-accordion-item-${g.tab}-${g.totalItems}`
        ))
      }
    );
  {
    const g = n.trim().length > 0;
    return /* @__PURE__ */ M(Qe, { children: [
      (!g || s) && /* @__PURE__ */ u(
        zs,
        {
          tabs: t.map((m) => ({
            headline: m.title,
            id: m.tab
          })),
          onTabClick: (m, b, E) => {
            const x = t.map((p) => p.tab).find((p) => p === E);
            r({
              query: n,
              page: 1,
              activeTab: x
            });
          },
          appearance: "filter",
          initiallySelected: h
        }
      ),
      /* @__PURE__ */ u("div", { children: t.filter((m) => m.tab === i).map((m) => /* @__PURE__ */ u(
        Vs,
        {
          title: m.title,
          labels: c,
          tab: m.tab,
          resultVariant: m.variant,
          searchVariant: e,
          itemRenderer: l,
          items: m.items,
          totalItems: m.totalItems,
          totalResultsFoundText: o,
          onPageChange: (b, E) => {
            r({
              query: n,
              page: E,
              activeTab: b
            });
          },
          onPagePrefetch: d,
          currentPage: a,
          isTabSwitchLoading: f
        },
        `roche-search-accordion-item-${m.tab}-${m.totalItems}`
      )) })
    ] });
  }
}, Vs = ({
  tab: e,
  resultVariant: t,
  searchVariant: i,
  items: s,
  totalItems: n,
  currentPage: r,
  onPageChange: a,
  onPagePrefetch: o,
  totalResultsFoundText: l,
  itemRenderer: c,
  labels: d,
  isTabSwitchLoading: f
}) => {
  const h = () => {
    if (s.length === 0) return null;
    const m = s.map((E, x) => c(E, e, x, r));
    if (t === "stories")
      return (
        // TODO: When refactoring teaser-wall, make sure the items are rendered in an UL/LI construct
        // as the other teasers for a11y improvements.
        /* @__PURE__ */ u(
          "roche-teaser-wall",
          {
            className: O(Y["search__teaser-container"], {
              [Y["search__teaser-container--loading"]]: f
            }),
            children: m
          },
          "teaser-wall-container"
        )
      );
    const b = s.map((E, x) => /* @__PURE__ */ u("li", { children: c(E, e, x, r) }, `teaser-${x}`));
    return /* @__PURE__ */ u(
      "div",
      {
        className: O(
          Y["search__teaser-container"],
          i === "main" ? Y["search__teaser-container--eight-columns"] : "",
          {
            [Y["search__teaser-container--loading"]]: f
          }
        ),
        children: /* @__PURE__ */ u("ul", { className: Y["search__results-list"], children: b })
      },
      "teaser-container"
    );
  }, g = n / (i === "main" ? 6 : 10);
  return /* @__PURE__ */ M("div", { children: [
    s.length === 0 && i === "main" && /* @__PURE__ */ M("div", { className: Y["search__no-results"], role: "status", "aria-live": "polite", children: [
      /* @__PURE__ */ u("h4", { className: Y["search__no-results-title"], children: d.noResultsTitle }),
      /* @__PURE__ */ u("p", { className: Y["search__no-results-message"], children: d.noResultsMessage })
    ] }),
    s.length === 0 && i === "data" && /* @__PURE__ */ u("div", { className: Y["search__no-results"], role: "status", "aria-live": "polite", children: /* @__PURE__ */ u("p", { className: Y["search__no-results-message"], children: d.noResultsMessage }) }),
    s.length > 0 && /* @__PURE__ */ M(Qe, { children: [
      /* @__PURE__ */ u("h2", { className: Y["search__results-heading"], "aria-live": "polite", "aria-atomic": "true", children: l.replace(/\$0/g, `${n}`) }),
      h(),
      Math.ceil(g) > 0 && /* @__PURE__ */ u(
        $u,
        {
          className: O(
            Y.search__pagination,
            t !== "stories" && i === "main" ? Y["search__pagination--eight-columns"] : ""
          ),
          onPageChange: (m) => a(e, m),
          totalPages: g,
          activePage: r,
          visiblePages: i === "main" ? 7 : 8,
          onPagePrefetch: (m) => o && o(e, m)
        }
      )
    ] })
  ] });
}, Bs = {
  "popular-search": "popular-search",
  "popular-search__title": "popular-search__title"
}, Gu = ({
  title: e,
  className: t,
  popularSearches: i,
  onPopularSearchTermClick: s
}) => /* @__PURE__ */ M("section", { "aria-labelledby": "popular-search-title", className: O(Bs["popular-search"], t), children: [
  /* @__PURE__ */ u("h2", { id: "popular-search-title", className: Bs["popular-search__title"], children: e }),
  /* @__PURE__ */ u("ul", { children: i.map((n) => /* @__PURE__ */ u("li", { onClick: () => s(n.label), children: /* @__PURE__ */ u("button", { children: n.label }) }, `popular-search-${n.label}`)) })
] });
var Zt = /* @__PURE__ */ ((e) => (e[e.INPUT = 0] = "INPUT", e[e.POPULAR_SEARCHES = 1] = "POPULAR_SEARCHES", e))(Zt || {});
const ft = {
  "search-input": "search-input",
  "search-input__label": "search-input__label",
  "search-input__description": "search-input__description",
  "search-input__input": "search-input__input",
  "search-input__search-icon": "search-input__search-icon",
  "search-input__clear-icon": "search-input__clear-icon"
}, Hs = "1.5rem", qu = ({
  className: e,
  placeholder: t,
  value: i,
  onChange: s,
  onClear: n,
  ariaLabels: r
}) => {
  const a = O(ft["search-input"], e), o = i && i.length > 0 && n, l = (c) => {
    c.key === "Escape" && n && n();
  };
  return /* @__PURE__ */ M("form", { className: a, onSubmit: (c) => c.preventDefault(), role: "search", "aria-label": r.siteSearch, children: [
    /* @__PURE__ */ u("label", { htmlFor: "search-input", className: ft["search-input__label"], children: r.searchInputLabel }),
    /* @__PURE__ */ u("span", { id: "search-description", className: ft["search-input__description"], children: r.searchInputDescription }),
    /* @__PURE__ */ u("span", { className: ft["search-input__search-icon"], "aria-hidden": "true", children: /* @__PURE__ */ u(F, { height: Hs, icon: "search" }) }),
    /* @__PURE__ */ u(
      "input",
      {
        className: ft["search-input__input"],
        id: "search-input",
        type: "search",
        autoComplete: "off",
        value: i,
        onChange: s,
        placeholder: t,
        onKeyDown: l,
        "aria-describedby": "search-description"
      }
    ),
    o && /* @__PURE__ */ u(
      "button",
      {
        type: "button",
        onClick: n,
        className: ft["search-input__clear-icon"],
        "aria-label": r.clearSearchTerm,
        tabIndex: -1,
        children: /* @__PURE__ */ u(F, { height: Hs, icon: "remove" })
      }
    )
  ] });
}, Bh = (e) => {
  const {
    labels: t,
    searchState: i,
    onSearchParamsChange: s,
    searchResults: n,
    isLoading: r,
    hasQueriesBeenFetched: a,
    variant: o,
    showInput: l,
    resultsRef: c,
    alwaysShowTabs: d = !1
  } = e, f = i.query, h = i.page, g = i.activeTab, m = t.totalResultsFoundText.replace("{totalResults}", "{0}"), b = n.some((N) => N.items.length > 0), E = () => {
    s({
      query: "",
      page: 1,
      activeTab: g,
      trigger: Zt.INPUT
    });
  }, x = (N, R) => {
    s({
      query: R,
      page: 1,
      activeTab: g,
      trigger: N
    });
  }, p = f.trim().length > 0, _ = o === "main" && e.support && !r && !b && !p, w = o === "data" && r && b, v = (r || p && !b && !a) && !w, y = n.reduce((N, R) => N + R.totalItems, 0), S = () => p ? r && !b ? e.ariaLabels.searchingFor.replace("{searchQuery}", f) : y === 0 ? e.ariaLabels.noResultsFoundFor.replace("{searchQuery}", f) : e.ariaLabels.resultsFoundFor.replace("{totalResults}", `${y}`).replace("{searchQuery}", f) : "";
  return /* @__PURE__ */ M(
    "div",
    {
      className: O(
        Y.search,
        o === "data" ? Y["data-search"] : "",
        o === "data" && l ? Y["data-search--with-input"] : ""
      ),
      children: [
        /* @__PURE__ */ u("div", { className: Y["search__sr-announcement"], "aria-live": "polite", "aria-atomic": "true", role: "status", children: S() }),
        o === "main" && t.searchTitle && /* @__PURE__ */ u("h1", { className: Y.search__title, children: t.searchTitle }),
        /* @__PURE__ */ M("div", { ref: c, children: [
          l && /* @__PURE__ */ u("div", { className: Y["search__input-container"], children: /* @__PURE__ */ u(
            qu,
            {
              placeholder: t.searchPlaceholder,
              value: f,
              onClear: E,
              onChange: (N) => x(Zt.INPUT, N.target.value),
              ariaLabels: {
                siteSearch: e.ariaLabels.siteSearch,
                searchInputLabel: e.ariaLabels.searchInputLabel,
                searchInputDescription: e.ariaLabels.searchInputDescription,
                clearSearchTerm: e.ariaLabels.clearSearchTerm
              }
            }
          ) }),
          v && /* @__PURE__ */ u("div", { className: Y["search__loading-container"], children: /* @__PURE__ */ u(Cc, { loadingText: t.loadingText }) }),
          _ && /* @__PURE__ */ M("div", { className: Y["search__support-content-wrapper"], children: [
            /* @__PURE__ */ u(
              Gu,
              {
                className: Y["search__popular-searches"],
                title: e.support.labels.popularSearchesTitle,
                popularSearches: e.support.popularSearches,
                onPopularSearchTermClick: (N) => x(Zt.POPULAR_SEARCHES, N)
              }
            ),
            /* @__PURE__ */ M("section", { className: Y["search__quick-links"], "aria-labelledby": "quick-links-title", children: [
              /* @__PURE__ */ u("h2", { id: "quick-links-title", className: Y["search__quick-links-title"], children: e.support.labels.quickLinksTitle }),
              /* @__PURE__ */ u("ul", { children: e.support.quick_links.map((N, R) => /* @__PURE__ */ u("li", { children: N }, `quick-link-${R}`)) })
            ] })
          ] }),
          !v && (o === "data" || !_) && /* @__PURE__ */ u("div", { className: Y["search__results-container"], "aria-busy": r, children: /* @__PURE__ */ u(
            Fu,
            {
              variant: o,
              labels: {
                noResultsMessage: e.labels.noResultsMessage,
                noResultsTitle: e.labels.noResultsTitle
              },
              alwaysShowTabs: d,
              tabs: n,
              itemRenderer: e.itemRenderer,
              currentTab: g,
              searchQuery: f,
              setSearchParams: s,
              currentPage: h,
              totalResultFoundText: m,
              onPagePrefetch: e.onPagePrefetch,
              isTabSwitchLoading: w
            }
          ) })
        ] })
      ]
    }
  );
}, ju = "select", Uu = "select__label", Wu = "select__error", ce = {
  select: ju,
  "select__native-input": "select__native-input",
  "select__native-input-custom-control": "select__native-input-custom-control",
  "select__native-input-custom-control--invalid": "select__native-input-custom-control--invalid",
  "select__native-input-icon": "select__native-input-icon",
  "select__native-input-icon--disabled": "select__native-input-icon--disabled",
  "select__input-wrapper": "select__input-wrapper",
  "select__label-wrapper": "select__label-wrapper",
  select__label: Uu,
  "select__label-icon": "select__label-icon",
  "select__label--disabled": "select__label--disabled",
  "select__item-label": "select__item-label",
  "select__item-label--disabled": "select__item-label--disabled",
  select__error: Wu,
  "select__error-text": "select__error-text"
}, Hh = ({
  disabled: e,
  label: t,
  options: i,
  isMultiSelect: s,
  showError: n,
  required: r,
  tooltip: a,
  tooltipAriaLabel: o,
  selected: l,
  onBlur: c,
  onSelect: d,
  optionalLabel: f,
  error: h
}) => {
  const g = s ? "checkbox" : "radio", m = Yu(t) || "selectGroupName", b = (w) => {
    d(w);
  }, E = () => {
    c == null || c();
  }, x = (w) => s && Array.isArray(l) ? l.includes(w) : l === w, p = (w, v) => {
    w.key === "Enter" && s && b(v);
  }, _ = O(ce.select, e && ce["select--disabled"]);
  return /* @__PURE__ */ M("div", { className: _, children: [
    /* @__PURE__ */ M("div", { className: ce["select__label-wrapper"], children: [
      /* @__PURE__ */ M("label", { className: O(ce.select__label, e && ce["select__label--disabled"]), children: [
        t,
        r ? "" : ` ${f}`
      ] }),
      a && /* @__PURE__ */ u(Ji, { ariaLabel: o, children: a })
    ] }),
    i.map((w, v) => {
      const y = x(w.value), S = `select-item-${w.value}-${v}`, N = `${S}-error`;
      return /* @__PURE__ */ M("label", { className: ce["select__input-wrapper"], children: [
        /* @__PURE__ */ u(
          "input",
          {
            type: g,
            id: S,
            name: m,
            value: w.value,
            checked: y,
            disabled: e,
            onChange: () => b(w),
            onBlur: E,
            className: ce["select__native-input"],
            onKeyDown: (R) => p(R, w),
            "aria-invalid": n,
            "aria-describedby": n ? N : void 0
          }
        ),
        /* @__PURE__ */ u(
          "div",
          {
            className: O(
              ce["select__native-input-custom-control"],
              n && ce["select__native-input-custom-control--invalid"]
            ),
            children: y && /* @__PURE__ */ u(
              "div",
              {
                className: O(
                  ce["select__native-input-icon"],
                  e && ce["select__native-input-icon--disabled"]
                ),
                children: /* @__PURE__ */ u(F, { icon: s ? "checkmark" : "circle" })
              }
            )
          }
        ),
        /* @__PURE__ */ u("span", { className: O(ce["select__item-label"], e && ce["select__item-label--disabled"]), children: w.label })
      ] }, S);
    }),
    /* @__PURE__ */ u("div", { className: ce.select__error, children: n && h && /* @__PURE__ */ M(Qe, { children: [
      /* @__PURE__ */ u(F, { icon: "info", width: "16px", decorative: !0 }),
      /* @__PURE__ */ u("p", { id: `error-${t}`, role: "alert", className: ce["select__error-text"], children: h })
    ] }) })
  ] });
}, Yu = (e) => e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
var Kt = /* @__PURE__ */ ((e) => (e.LEFT = "left", e.RIGHT = "right", e.SPACE_BETWEEN = "space-between", e))(Kt || {}), Qt = /* @__PURE__ */ ((e) => (e.TOP = "top", e.MIDDLE = "middle", e.BOTTOM = "bottom", e))(Qt || {});
const pt = {
  "side-by-side": "side-by-side",
  "side-by-side--right": "side-by-side--right",
  "side-by-side--space-between": "side-by-side--space-between",
  "side-by-side--top": "side-by-side--top",
  "side-by-side--bottom": "side-by-side--bottom",
  "side-by-side--equal-ratio": "side-by-side--equal-ratio"
}, Fh = ({
  horizontalAlignment: e = Kt.LEFT,
  verticalAlignment: t = Qt.MIDDLE,
  equalRatio: i = !1,
  children: s
}) => {
  const n = O(
    pt["side-by-side"],
    e === Kt.RIGHT && pt["side-by-side--right"],
    e === Kt.SPACE_BETWEEN && pt["side-by-side--space-between"],
    t === Qt.TOP && pt["side-by-side--top"],
    t === Qt.BOTTOM && pt["side-by-side--bottom"],
    i && pt["side-by-side--equal-ratio"]
  );
  return /* @__PURE__ */ u("div", { className: n, children: s });
}, Xu = "swiper", Zu = "teaser", Ku = "swiper__controls", Ge = {
  swiper: Xu,
  "swiper-slide": "swiper-slide",
  teaser: Zu,
  "swiper-pagination": "swiper-pagination",
  "swiper-pagination-current": "swiper-pagination-current",
  "swiper-pagination-total": "swiper-pagination-total",
  "swiper-pagination-fraction": "swiper-pagination-fraction",
  "swiper__button-next-custom": "swiper__button-next-custom",
  "swiper__button-prev-custom": "swiper__button-prev-custom",
  "swiper__button-icon-custom": "swiper__button-icon-custom",
  "swiper__button--disabled": "swiper__button--disabled",
  swiper__controls: Ku,
  "swiper__controls-wrapper": "swiper__controls-wrapper",
  "swiper__controls-wrapper--navigation-hidden": "swiper__controls-wrapper--navigation-hidden"
};
function Fs(e) {
  return e !== null && typeof e == "object" && "constructor" in e && e.constructor === Object;
}
function is(e, t) {
  e === void 0 && (e = {}), t === void 0 && (t = {});
  const i = ["__proto__", "constructor", "prototype"];
  Object.keys(t).filter((s) => i.indexOf(s) < 0).forEach((s) => {
    typeof e[s] > "u" ? e[s] = t[s] : Fs(t[s]) && Fs(e[s]) && Object.keys(t[s]).length > 0 && is(e[s], t[s]);
  });
}
const bn = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function Ue() {
  const e = typeof document < "u" ? document : {};
  return is(e, bn), e;
}
const Qu = {
  document: bn,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(e) {
    return typeof setTimeout > "u" ? (e(), null) : setTimeout(e, 0);
  },
  cancelAnimationFrame(e) {
    typeof setTimeout > "u" || clearTimeout(e);
  }
};
function ue() {
  const e = typeof window < "u" ? window : {};
  return is(e, Qu), e;
}
function Ju(e) {
  return e === void 0 && (e = ""), e.trim().split(" ").filter((t) => !!t.trim());
}
function ef(e) {
  const t = e;
  Object.keys(t).forEach((i) => {
    try {
      t[i] = null;
    } catch {
    }
    try {
      delete t[i];
    } catch {
    }
  });
}
function Bi(e, t) {
  return t === void 0 && (t = 0), setTimeout(e, t);
}
function ri() {
  return Date.now();
}
function tf(e) {
  const t = ue();
  let i;
  return t.getComputedStyle && (i = t.getComputedStyle(e, null)), !i && e.currentStyle && (i = e.currentStyle), i || (i = e.style), i;
}
function sf(e, t) {
  t === void 0 && (t = "x");
  const i = ue();
  let s, n, r;
  const a = tf(e);
  return i.WebKitCSSMatrix ? (n = a.transform || a.webkitTransform, n.split(",").length > 6 && (n = n.split(", ").map((o) => o.replace(",", ".")).join(", ")), r = new i.WebKitCSSMatrix(n === "none" ? "" : n)) : (r = a.MozTransform || a.OTransform || a.MsTransform || a.msTransform || a.transform || a.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), s = r.toString().split(",")), t === "x" && (i.WebKitCSSMatrix ? n = r.m41 : s.length === 16 ? n = parseFloat(s[12]) : n = parseFloat(s[4])), t === "y" && (i.WebKitCSSMatrix ? n = r.m42 : s.length === 16 ? n = parseFloat(s[13]) : n = parseFloat(s[5])), n || 0;
}
function jt(e) {
  return typeof e == "object" && e !== null && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object";
}
function nf(e) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? e instanceof HTMLElement : e && (e.nodeType === 1 || e.nodeType === 11);
}
function _e() {
  const e = Object(arguments.length <= 0 ? void 0 : arguments[0]), t = ["__proto__", "constructor", "prototype"];
  for (let i = 1; i < arguments.length; i += 1) {
    const s = i < 0 || arguments.length <= i ? void 0 : arguments[i];
    if (s != null && !nf(s)) {
      const n = Object.keys(Object(s)).filter((r) => t.indexOf(r) < 0);
      for (let r = 0, a = n.length; r < a; r += 1) {
        const o = n[r], l = Object.getOwnPropertyDescriptor(s, o);
        l !== void 0 && l.enumerable && (jt(e[o]) && jt(s[o]) ? s[o].__swiper__ ? e[o] = s[o] : _e(e[o], s[o]) : !jt(e[o]) && jt(s[o]) ? (e[o] = {}, s[o].__swiper__ ? e[o] = s[o] : _e(e[o], s[o])) : e[o] = s[o]);
      }
    }
  }
  return e;
}
function Ut(e, t, i) {
  e.style.setProperty(t, i);
}
function yn(e) {
  let {
    swiper: t,
    targetPosition: i,
    side: s
  } = e;
  const n = ue(), r = -t.translate;
  let a = null, o;
  const l = t.params.speed;
  t.wrapperEl.style.scrollSnapType = "none", n.cancelAnimationFrame(t.cssModeFrameID);
  const c = i > r ? "next" : "prev", d = (h, g) => c === "next" && h >= g || c === "prev" && h <= g, f = () => {
    o = (/* @__PURE__ */ new Date()).getTime(), a === null && (a = o);
    const h = Math.max(Math.min((o - a) / l, 1), 0), g = 0.5 - Math.cos(h * Math.PI) / 2;
    let m = r + g * (i - r);
    if (d(m, i) && (m = i), t.wrapperEl.scrollTo({
      [s]: m
    }), d(m, i)) {
      t.wrapperEl.style.overflow = "hidden", t.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        t.wrapperEl.style.overflow = "", t.wrapperEl.scrollTo({
          [s]: m
        });
      }), n.cancelAnimationFrame(t.cssModeFrameID);
      return;
    }
    t.cssModeFrameID = n.requestAnimationFrame(f);
  };
  f();
}
function En(e) {
  return e.querySelector(".swiper-slide-transform") || e.shadowRoot && e.shadowRoot.querySelector(".swiper-slide-transform") || e;
}
function Oe(e, t) {
  t === void 0 && (t = "");
  const i = ue(), s = [...e.children];
  return i.HTMLSlotElement && e instanceof HTMLSlotElement && s.push(...e.assignedElements()), t ? s.filter((n) => n.matches(t)) : s;
}
function rf(e, t) {
  const i = [t];
  for (; i.length > 0; ) {
    const s = i.shift();
    if (e === s)
      return !0;
    i.push(...s.children, ...s.shadowRoot ? s.shadowRoot.children : [], ...s.assignedElements ? s.assignedElements() : []);
  }
}
function af(e, t) {
  const i = ue();
  let s = t.contains(e);
  return !s && i.HTMLSlotElement && t instanceof HTMLSlotElement && (s = [...t.assignedElements()].includes(e), s || (s = rf(e, t))), s;
}
function ai(e) {
  try {
    console.warn(e);
    return;
  } catch {
  }
}
function Rt(e, t) {
  t === void 0 && (t = []);
  const i = document.createElement(e);
  return i.classList.add(...Array.isArray(t) ? t : Ju(t)), i;
}
function of(e, t) {
  const i = [];
  for (; e.previousElementSibling; ) {
    const s = e.previousElementSibling;
    t ? s.matches(t) && i.push(s) : i.push(s), e = s;
  }
  return i;
}
function lf(e, t) {
  const i = [];
  for (; e.nextElementSibling; ) {
    const s = e.nextElementSibling;
    t ? s.matches(t) && i.push(s) : i.push(s), e = s;
  }
  return i;
}
function Ke(e, t) {
  return ue().getComputedStyle(e, null).getPropertyValue(t);
}
function Ot(e) {
  let t = e, i;
  if (t) {
    for (i = 0; (t = t.previousSibling) !== null; )
      t.nodeType === 1 && (i += 1);
    return i;
  }
}
function xn(e, t) {
  const i = [];
  let s = e.parentElement;
  for (; s; )
    t ? s.matches(t) && i.push(s) : i.push(s), s = s.parentElement;
  return i;
}
function cf(e, t) {
  function i(s) {
    s.target === e && (t.call(e, s), e.removeEventListener("transitionend", i));
  }
  t && e.addEventListener("transitionend", i);
}
function Hi(e, t, i) {
  const s = ue();
  return e[t === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(s.getComputedStyle(e, null).getPropertyValue(t === "width" ? "margin-right" : "margin-top")) + parseFloat(s.getComputedStyle(e, null).getPropertyValue(t === "width" ? "margin-left" : "margin-bottom"));
}
function W(e) {
  return (Array.isArray(e) ? e : [e]).filter((t) => !!t);
}
function Fi(e, t) {
  t === void 0 && (t = ""), typeof trustedTypes < "u" ? e.innerHTML = trustedTypes.createPolicy("html", {
    createHTML: (i) => i
  }).createHTML(t) : e.innerHTML = t;
}
let Ti;
function df() {
  const e = ue(), t = Ue();
  return {
    smoothScroll: t.documentElement && t.documentElement.style && "scrollBehavior" in t.documentElement.style,
    touch: !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch)
  };
}
function Sn() {
  return Ti || (Ti = df()), Ti;
}
let Ni;
function uf(e) {
  let {
    userAgent: t
  } = e === void 0 ? {} : e;
  const i = Sn(), s = ue(), n = s.navigator.platform, r = t || s.navigator.userAgent, a = {
    ios: !1,
    android: !1
  }, o = s.screen.width, l = s.screen.height, c = r.match(/(Android);?[\s\/]+([\d.]+)?/);
  let d = r.match(/(iPad).*OS\s([\d_]+)/);
  const f = r.match(/(iPod)(.*OS\s([\d_]+))?/), h = !d && r.match(/(iPhone\sOS|iOS)\s([\d_]+)/), g = n === "Win32";
  let m = n === "MacIntel";
  const b = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !d && m && i.touch && b.indexOf(`${o}x${l}`) >= 0 && (d = r.match(/(Version)\/([\d.]+)/), d || (d = [0, 1, "13_0_0"]), m = !1), c && !g && (a.os = "android", a.android = !0), (d || h || f) && (a.os = "ios", a.ios = !0), a;
}
function Tn(e) {
  return e === void 0 && (e = {}), Ni || (Ni = uf(e)), Ni;
}
let ki;
function ff() {
  const e = ue(), t = Tn();
  let i = !1;
  function s() {
    const o = e.navigator.userAgent.toLowerCase();
    return o.indexOf("safari") >= 0 && o.indexOf("chrome") < 0 && o.indexOf("android") < 0;
  }
  if (s()) {
    const o = String(e.navigator.userAgent);
    if (o.includes("Version/")) {
      const [l, c] = o.split("Version/")[1].split(" ")[0].split(".").map((d) => Number(d));
      i = l < 16 || l === 16 && c < 2;
    }
  }
  const n = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent), r = s(), a = r || n && t.ios;
  return {
    isSafari: i || r,
    needPerspectiveFix: i,
    need3dFix: a,
    isWebView: n
  };
}
function Nn() {
  return ki || (ki = ff()), ki;
}
function pf(e) {
  let {
    swiper: t,
    on: i,
    emit: s
  } = e;
  const n = ue();
  let r = null, a = null;
  const o = () => {
    !t || t.destroyed || !t.initialized || (s("beforeResize"), s("resize"));
  }, l = () => {
    !t || t.destroyed || !t.initialized || (r = new ResizeObserver((f) => {
      a = n.requestAnimationFrame(() => {
        const {
          width: h,
          height: g
        } = t;
        let m = h, b = g;
        f.forEach((E) => {
          let {
            contentBoxSize: x,
            contentRect: p,
            target: _
          } = E;
          _ && _ !== t.el || (m = p ? p.width : (x[0] || x).inlineSize, b = p ? p.height : (x[0] || x).blockSize);
        }), (m !== h || b !== g) && o();
      });
    }), r.observe(t.el));
  }, c = () => {
    a && n.cancelAnimationFrame(a), r && r.unobserve && t.el && (r.unobserve(t.el), r = null);
  }, d = () => {
    !t || t.destroyed || !t.initialized || s("orientationchange");
  };
  i("init", () => {
    if (t.params.resizeObserver && typeof n.ResizeObserver < "u") {
      l();
      return;
    }
    n.addEventListener("resize", o), n.addEventListener("orientationchange", d);
  }), i("destroy", () => {
    c(), n.removeEventListener("resize", o), n.removeEventListener("orientationchange", d);
  });
}
function hf(e) {
  let {
    swiper: t,
    extendParams: i,
    on: s,
    emit: n
  } = e;
  const r = [], a = ue(), o = function(d, f) {
    f === void 0 && (f = {});
    const h = a.MutationObserver || a.WebkitMutationObserver, g = new h((m) => {
      if (t.__preventObserver__) return;
      if (m.length === 1) {
        n("observerUpdate", m[0]);
        return;
      }
      const b = function() {
        n("observerUpdate", m[0]);
      };
      a.requestAnimationFrame ? a.requestAnimationFrame(b) : a.setTimeout(b, 0);
    });
    g.observe(d, {
      attributes: typeof f.attributes > "u" ? !0 : f.attributes,
      childList: t.isElement || (typeof f.childList > "u" ? !0 : f).childList,
      characterData: typeof f.characterData > "u" ? !0 : f.characterData
    }), r.push(g);
  }, l = () => {
    if (t.params.observer) {
      if (t.params.observeParents) {
        const d = xn(t.hostEl);
        for (let f = 0; f < d.length; f += 1)
          o(d[f]);
      }
      o(t.hostEl, {
        childList: t.params.observeSlideChildren
      }), o(t.wrapperEl, {
        attributes: !1
      });
    }
  }, c = () => {
    r.forEach((d) => {
      d.disconnect();
    }), r.splice(0, r.length);
  };
  i({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), s("init", l), s("destroy", c);
}
var mf = {
  on(e, t, i) {
    const s = this;
    if (!s.eventsListeners || s.destroyed || typeof t != "function") return s;
    const n = i ? "unshift" : "push";
    return e.split(" ").forEach((r) => {
      s.eventsListeners[r] || (s.eventsListeners[r] = []), s.eventsListeners[r][n](t);
    }), s;
  },
  once(e, t, i) {
    const s = this;
    if (!s.eventsListeners || s.destroyed || typeof t != "function") return s;
    function n() {
      s.off(e, n), n.__emitterProxy && delete n.__emitterProxy;
      for (var r = arguments.length, a = new Array(r), o = 0; o < r; o++)
        a[o] = arguments[o];
      t.apply(s, a);
    }
    return n.__emitterProxy = t, s.on(e, n, i);
  },
  onAny(e, t) {
    const i = this;
    if (!i.eventsListeners || i.destroyed || typeof e != "function") return i;
    const s = t ? "unshift" : "push";
    return i.eventsAnyListeners.indexOf(e) < 0 && i.eventsAnyListeners[s](e), i;
  },
  offAny(e) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsAnyListeners) return t;
    const i = t.eventsAnyListeners.indexOf(e);
    return i >= 0 && t.eventsAnyListeners.splice(i, 1), t;
  },
  off(e, t) {
    const i = this;
    return !i.eventsListeners || i.destroyed || !i.eventsListeners || e.split(" ").forEach((s) => {
      typeof t > "u" ? i.eventsListeners[s] = [] : i.eventsListeners[s] && i.eventsListeners[s].forEach((n, r) => {
        (n === t || n.__emitterProxy && n.__emitterProxy === t) && i.eventsListeners[s].splice(r, 1);
      });
    }), i;
  },
  emit() {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsListeners) return e;
    let t, i, s;
    for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
      r[a] = arguments[a];
    return typeof r[0] == "string" || Array.isArray(r[0]) ? (t = r[0], i = r.slice(1, r.length), s = e) : (t = r[0].events, i = r[0].data, s = r[0].context || e), i.unshift(s), (Array.isArray(t) ? t : t.split(" ")).forEach((l) => {
      e.eventsAnyListeners && e.eventsAnyListeners.length && e.eventsAnyListeners.forEach((c) => {
        c.apply(s, [l, ...i]);
      }), e.eventsListeners && e.eventsListeners[l] && e.eventsListeners[l].forEach((c) => {
        c.apply(s, i);
      });
    }), e;
  }
};
function gf() {
  const e = this;
  let t, i;
  const s = e.el;
  typeof e.params.width < "u" && e.params.width !== null ? t = e.params.width : t = s.clientWidth, typeof e.params.height < "u" && e.params.height !== null ? i = e.params.height : i = s.clientHeight, !(t === 0 && e.isHorizontal() || i === 0 && e.isVertical()) && (t = t - parseInt(Ke(s, "padding-left") || 0, 10) - parseInt(Ke(s, "padding-right") || 0, 10), i = i - parseInt(Ke(s, "padding-top") || 0, 10) - parseInt(Ke(s, "padding-bottom") || 0, 10), Number.isNaN(t) && (t = 0), Number.isNaN(i) && (i = 0), Object.assign(e, {
    width: t,
    height: i,
    size: e.isHorizontal() ? t : i
  }));
}
function _f() {
  const e = this;
  function t(A, C) {
    return parseFloat(A.getPropertyValue(e.getDirectionLabel(C)) || 0);
  }
  const i = e.params, {
    wrapperEl: s,
    slidesEl: n,
    size: r,
    rtlTranslate: a,
    wrongRTL: o
  } = e, l = e.virtual && i.virtual.enabled, c = l ? e.virtual.slides.length : e.slides.length, d = Oe(n, `.${e.params.slideClass}, swiper-slide`), f = l ? e.virtual.slides.length : d.length;
  let h = [];
  const g = [], m = [];
  let b = i.slidesOffsetBefore;
  typeof b == "function" && (b = i.slidesOffsetBefore.call(e));
  let E = i.slidesOffsetAfter;
  typeof E == "function" && (E = i.slidesOffsetAfter.call(e));
  const x = e.snapGrid.length, p = e.slidesGrid.length;
  let _ = i.spaceBetween, w = -b, v = 0, y = 0;
  if (typeof r > "u")
    return;
  typeof _ == "string" && _.indexOf("%") >= 0 ? _ = parseFloat(_.replace("%", "")) / 100 * r : typeof _ == "string" && (_ = parseFloat(_)), e.virtualSize = -_, d.forEach((A) => {
    a ? A.style.marginLeft = "" : A.style.marginRight = "", A.style.marginBottom = "", A.style.marginTop = "";
  }), i.centeredSlides && i.cssMode && (Ut(s, "--swiper-centered-offset-before", ""), Ut(s, "--swiper-centered-offset-after", ""));
  const S = i.grid && i.grid.rows > 1 && e.grid;
  S ? e.grid.initSlides(d) : e.grid && e.grid.unsetSlides();
  let N;
  const R = i.slidesPerView === "auto" && i.breakpoints && Object.keys(i.breakpoints).filter((A) => typeof i.breakpoints[A].slidesPerView < "u").length > 0;
  for (let A = 0; A < f; A += 1) {
    N = 0;
    let C;
    if (d[A] && (C = d[A]), S && e.grid.updateSlide(A, C, d), !(d[A] && Ke(C, "display") === "none")) {
      if (i.slidesPerView === "auto") {
        R && (d[A].style[e.getDirectionLabel("width")] = "");
        const P = getComputedStyle(C), D = C.style.transform, B = C.style.webkitTransform;
        if (D && (C.style.transform = "none"), B && (C.style.webkitTransform = "none"), i.roundLengths)
          N = e.isHorizontal() ? Hi(C, "width") : Hi(C, "height");
        else {
          const z = t(P, "width"), L = t(P, "padding-left"), k = t(P, "padding-right"), I = t(P, "margin-left"), $ = t(P, "margin-right"), q = P.getPropertyValue("box-sizing");
          if (q && q === "border-box")
            N = z + I + $;
          else {
            const {
              clientWidth: te,
              offsetWidth: K
            } = C;
            N = z + L + k + I + $ + (K - te);
          }
        }
        D && (C.style.transform = D), B && (C.style.webkitTransform = B), i.roundLengths && (N = Math.floor(N));
      } else
        N = (r - (i.slidesPerView - 1) * _) / i.slidesPerView, i.roundLengths && (N = Math.floor(N)), d[A] && (d[A].style[e.getDirectionLabel("width")] = `${N}px`);
      d[A] && (d[A].swiperSlideSize = N), m.push(N), i.centeredSlides ? (w = w + N / 2 + v / 2 + _, v === 0 && A !== 0 && (w = w - r / 2 - _), A === 0 && (w = w - r / 2 - _), Math.abs(w) < 1 / 1e3 && (w = 0), i.roundLengths && (w = Math.floor(w)), y % i.slidesPerGroup === 0 && h.push(w), g.push(w)) : (i.roundLengths && (w = Math.floor(w)), (y - Math.min(e.params.slidesPerGroupSkip, y)) % e.params.slidesPerGroup === 0 && h.push(w), g.push(w), w = w + N + _), e.virtualSize += N + _, v = N, y += 1;
    }
  }
  if (e.virtualSize = Math.max(e.virtualSize, r) + E, a && o && (i.effect === "slide" || i.effect === "coverflow") && (s.style.width = `${e.virtualSize + _}px`), i.setWrapperSize && (s.style[e.getDirectionLabel("width")] = `${e.virtualSize + _}px`), S && e.grid.updateWrapperSize(N, h), !i.centeredSlides) {
    const A = [];
    for (let C = 0; C < h.length; C += 1) {
      let P = h[C];
      i.roundLengths && (P = Math.floor(P)), h[C] <= e.virtualSize - r && A.push(P);
    }
    h = A, Math.floor(e.virtualSize - r) - Math.floor(h[h.length - 1]) > 1 && h.push(e.virtualSize - r);
  }
  if (l && i.loop) {
    const A = m[0] + _;
    if (i.slidesPerGroup > 1) {
      const C = Math.ceil((e.virtual.slidesBefore + e.virtual.slidesAfter) / i.slidesPerGroup), P = A * i.slidesPerGroup;
      for (let D = 0; D < C; D += 1)
        h.push(h[h.length - 1] + P);
    }
    for (let C = 0; C < e.virtual.slidesBefore + e.virtual.slidesAfter; C += 1)
      i.slidesPerGroup === 1 && h.push(h[h.length - 1] + A), g.push(g[g.length - 1] + A), e.virtualSize += A;
  }
  if (h.length === 0 && (h = [0]), _ !== 0) {
    const A = e.isHorizontal() && a ? "marginLeft" : e.getDirectionLabel("marginRight");
    d.filter((C, P) => !i.cssMode || i.loop ? !0 : P !== d.length - 1).forEach((C) => {
      C.style[A] = `${_}px`;
    });
  }
  if (i.centeredSlides && i.centeredSlidesBounds) {
    let A = 0;
    m.forEach((P) => {
      A += P + (_ || 0);
    }), A -= _;
    const C = A > r ? A - r : 0;
    h = h.map((P) => P <= 0 ? -b : P > C ? C + E : P);
  }
  if (i.centerInsufficientSlides) {
    let A = 0;
    m.forEach((P) => {
      A += P + (_ || 0);
    }), A -= _;
    const C = (i.slidesOffsetBefore || 0) + (i.slidesOffsetAfter || 0);
    if (A + C < r) {
      const P = (r - A - C) / 2;
      h.forEach((D, B) => {
        h[B] = D - P;
      }), g.forEach((D, B) => {
        g[B] = D + P;
      });
    }
  }
  if (Object.assign(e, {
    slides: d,
    snapGrid: h,
    slidesGrid: g,
    slidesSizesGrid: m
  }), i.centeredSlides && i.cssMode && !i.centeredSlidesBounds) {
    Ut(s, "--swiper-centered-offset-before", `${-h[0]}px`), Ut(s, "--swiper-centered-offset-after", `${e.size / 2 - m[m.length - 1] / 2}px`);
    const A = -e.snapGrid[0], C = -e.slidesGrid[0];
    e.snapGrid = e.snapGrid.map((P) => P + A), e.slidesGrid = e.slidesGrid.map((P) => P + C);
  }
  if (f !== c && e.emit("slidesLengthChange"), h.length !== x && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), g.length !== p && e.emit("slidesGridLengthChange"), i.watchSlidesProgress && e.updateSlidesOffset(), e.emit("slidesUpdated"), !l && !i.cssMode && (i.effect === "slide" || i.effect === "fade")) {
    const A = `${i.containerModifierClass}backface-hidden`, C = e.el.classList.contains(A);
    f <= i.maxBackfaceHiddenSlides ? C || e.el.classList.add(A) : C && e.el.classList.remove(A);
  }
}
function vf(e) {
  const t = this, i = [], s = t.virtual && t.params.virtual.enabled;
  let n = 0, r;
  typeof e == "number" ? t.setTransition(e) : e === !0 && t.setTransition(t.params.speed);
  const a = (o) => s ? t.slides[t.getSlideIndexByData(o)] : t.slides[o];
  if (t.params.slidesPerView !== "auto" && t.params.slidesPerView > 1)
    if (t.params.centeredSlides)
      (t.visibleSlides || []).forEach((o) => {
        i.push(o);
      });
    else
      for (r = 0; r < Math.ceil(t.params.slidesPerView); r += 1) {
        const o = t.activeIndex + r;
        if (o > t.slides.length && !s) break;
        i.push(a(o));
      }
  else
    i.push(a(t.activeIndex));
  for (r = 0; r < i.length; r += 1)
    if (typeof i[r] < "u") {
      const o = i[r].offsetHeight;
      n = o > n ? o : n;
    }
  (n || n === 0) && (t.wrapperEl.style.height = `${n}px`);
}
function wf() {
  const e = this, t = e.slides, i = e.isElement ? e.isHorizontal() ? e.wrapperEl.offsetLeft : e.wrapperEl.offsetTop : 0;
  for (let s = 0; s < t.length; s += 1)
    t[s].swiperSlideOffset = (e.isHorizontal() ? t[s].offsetLeft : t[s].offsetTop) - i - e.cssOverflowAdjustment();
}
const Gs = (e, t, i) => {
  t && !e.classList.contains(i) ? e.classList.add(i) : !t && e.classList.contains(i) && e.classList.remove(i);
};
function bf(e) {
  e === void 0 && (e = this && this.translate || 0);
  const t = this, i = t.params, {
    slides: s,
    rtlTranslate: n,
    snapGrid: r
  } = t;
  if (s.length === 0) return;
  typeof s[0].swiperSlideOffset > "u" && t.updateSlidesOffset();
  let a = -e;
  n && (a = e), t.visibleSlidesIndexes = [], t.visibleSlides = [];
  let o = i.spaceBetween;
  typeof o == "string" && o.indexOf("%") >= 0 ? o = parseFloat(o.replace("%", "")) / 100 * t.size : typeof o == "string" && (o = parseFloat(o));
  for (let l = 0; l < s.length; l += 1) {
    const c = s[l];
    let d = c.swiperSlideOffset;
    i.cssMode && i.centeredSlides && (d -= s[0].swiperSlideOffset);
    const f = (a + (i.centeredSlides ? t.minTranslate() : 0) - d) / (c.swiperSlideSize + o), h = (a - r[0] + (i.centeredSlides ? t.minTranslate() : 0) - d) / (c.swiperSlideSize + o), g = -(a - d), m = g + t.slidesSizesGrid[l], b = g >= 0 && g <= t.size - t.slidesSizesGrid[l], E = g >= 0 && g < t.size - 1 || m > 1 && m <= t.size || g <= 0 && m >= t.size;
    E && (t.visibleSlides.push(c), t.visibleSlidesIndexes.push(l)), Gs(c, E, i.slideVisibleClass), Gs(c, b, i.slideFullyVisibleClass), c.progress = n ? -f : f, c.originalProgress = n ? -h : h;
  }
}
function yf(e) {
  const t = this;
  if (typeof e > "u") {
    const d = t.rtlTranslate ? -1 : 1;
    e = t && t.translate && t.translate * d || 0;
  }
  const i = t.params, s = t.maxTranslate() - t.minTranslate();
  let {
    progress: n,
    isBeginning: r,
    isEnd: a,
    progressLoop: o
  } = t;
  const l = r, c = a;
  if (s === 0)
    n = 0, r = !0, a = !0;
  else {
    n = (e - t.minTranslate()) / s;
    const d = Math.abs(e - t.minTranslate()) < 1, f = Math.abs(e - t.maxTranslate()) < 1;
    r = d || n <= 0, a = f || n >= 1, d && (n = 0), f && (n = 1);
  }
  if (i.loop) {
    const d = t.getSlideIndexByData(0), f = t.getSlideIndexByData(t.slides.length - 1), h = t.slidesGrid[d], g = t.slidesGrid[f], m = t.slidesGrid[t.slidesGrid.length - 1], b = Math.abs(e);
    b >= h ? o = (b - h) / m : o = (b + m - g) / m, o > 1 && (o -= 1);
  }
  Object.assign(t, {
    progress: n,
    progressLoop: o,
    isBeginning: r,
    isEnd: a
  }), (i.watchSlidesProgress || i.centeredSlides && i.autoHeight) && t.updateSlidesProgress(e), r && !l && t.emit("reachBeginning toEdge"), a && !c && t.emit("reachEnd toEdge"), (l && !r || c && !a) && t.emit("fromEdge"), t.emit("progress", n);
}
const Ai = (e, t, i) => {
  t && !e.classList.contains(i) ? e.classList.add(i) : !t && e.classList.contains(i) && e.classList.remove(i);
};
function Ef() {
  const e = this, {
    slides: t,
    params: i,
    slidesEl: s,
    activeIndex: n
  } = e, r = e.virtual && i.virtual.enabled, a = e.grid && i.grid && i.grid.rows > 1, o = (f) => Oe(s, `.${i.slideClass}${f}, swiper-slide${f}`)[0];
  let l, c, d;
  if (r)
    if (i.loop) {
      let f = n - e.virtual.slidesBefore;
      f < 0 && (f = e.virtual.slides.length + f), f >= e.virtual.slides.length && (f -= e.virtual.slides.length), l = o(`[data-swiper-slide-index="${f}"]`);
    } else
      l = o(`[data-swiper-slide-index="${n}"]`);
  else
    a ? (l = t.find((f) => f.column === n), d = t.find((f) => f.column === n + 1), c = t.find((f) => f.column === n - 1)) : l = t[n];
  l && (a || (d = lf(l, `.${i.slideClass}, swiper-slide`)[0], i.loop && !d && (d = t[0]), c = of(l, `.${i.slideClass}, swiper-slide`)[0], i.loop && !c === 0 && (c = t[t.length - 1]))), t.forEach((f) => {
    Ai(f, f === l, i.slideActiveClass), Ai(f, f === d, i.slideNextClass), Ai(f, f === c, i.slidePrevClass);
  }), e.emitSlidesClasses();
}
const Jt = (e, t) => {
  if (!e || e.destroyed || !e.params) return;
  const i = () => e.isElement ? "swiper-slide" : `.${e.params.slideClass}`, s = t.closest(i());
  if (s) {
    let n = s.querySelector(`.${e.params.lazyPreloaderClass}`);
    !n && e.isElement && (s.shadowRoot ? n = s.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
      s.shadowRoot && (n = s.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`), n && n.remove());
    })), n && n.remove();
  }
}, Mi = (e, t) => {
  if (!e.slides[t]) return;
  const i = e.slides[t].querySelector('[loading="lazy"]');
  i && i.removeAttribute("loading");
}, Gi = (e) => {
  if (!e || e.destroyed || !e.params) return;
  let t = e.params.lazyPreloadPrevNext;
  const i = e.slides.length;
  if (!i || !t || t < 0) return;
  t = Math.min(t, i);
  const s = e.params.slidesPerView === "auto" ? e.slidesPerViewDynamic() : Math.ceil(e.params.slidesPerView), n = e.activeIndex;
  if (e.params.grid && e.params.grid.rows > 1) {
    const a = n, o = [a - t];
    o.push(...Array.from({
      length: t
    }).map((l, c) => a + s + c)), e.slides.forEach((l, c) => {
      o.includes(l.column) && Mi(e, c);
    });
    return;
  }
  const r = n + s - 1;
  if (e.params.rewind || e.params.loop)
    for (let a = n - t; a <= r + t; a += 1) {
      const o = (a % i + i) % i;
      (o < n || o > r) && Mi(e, o);
    }
  else
    for (let a = Math.max(n - t, 0); a <= Math.min(r + t, i - 1); a += 1)
      a !== n && (a > r || a < n) && Mi(e, a);
};
function xf(e) {
  const {
    slidesGrid: t,
    params: i
  } = e, s = e.rtlTranslate ? e.translate : -e.translate;
  let n;
  for (let r = 0; r < t.length; r += 1)
    typeof t[r + 1] < "u" ? s >= t[r] && s < t[r + 1] - (t[r + 1] - t[r]) / 2 ? n = r : s >= t[r] && s < t[r + 1] && (n = r + 1) : s >= t[r] && (n = r);
  return i.normalizeSlideIndex && (n < 0 || typeof n > "u") && (n = 0), n;
}
function Sf(e) {
  const t = this, i = t.rtlTranslate ? t.translate : -t.translate, {
    snapGrid: s,
    params: n,
    activeIndex: r,
    realIndex: a,
    snapIndex: o
  } = t;
  let l = e, c;
  const d = (g) => {
    let m = g - t.virtual.slidesBefore;
    return m < 0 && (m = t.virtual.slides.length + m), m >= t.virtual.slides.length && (m -= t.virtual.slides.length), m;
  };
  if (typeof l > "u" && (l = xf(t)), s.indexOf(i) >= 0)
    c = s.indexOf(i);
  else {
    const g = Math.min(n.slidesPerGroupSkip, l);
    c = g + Math.floor((l - g) / n.slidesPerGroup);
  }
  if (c >= s.length && (c = s.length - 1), l === r && !t.params.loop) {
    c !== o && (t.snapIndex = c, t.emit("snapIndexChange"));
    return;
  }
  if (l === r && t.params.loop && t.virtual && t.params.virtual.enabled) {
    t.realIndex = d(l);
    return;
  }
  const f = t.grid && n.grid && n.grid.rows > 1;
  let h;
  if (t.virtual && n.virtual.enabled && n.loop)
    h = d(l);
  else if (f) {
    const g = t.slides.find((b) => b.column === l);
    let m = parseInt(g.getAttribute("data-swiper-slide-index"), 10);
    Number.isNaN(m) && (m = Math.max(t.slides.indexOf(g), 0)), h = Math.floor(m / n.grid.rows);
  } else if (t.slides[l]) {
    const g = t.slides[l].getAttribute("data-swiper-slide-index");
    g ? h = parseInt(g, 10) : h = l;
  } else
    h = l;
  Object.assign(t, {
    previousSnapIndex: o,
    snapIndex: c,
    previousRealIndex: a,
    realIndex: h,
    previousIndex: r,
    activeIndex: l
  }), t.initialized && Gi(t), t.emit("activeIndexChange"), t.emit("snapIndexChange"), (t.initialized || t.params.runCallbacksOnInit) && (a !== h && t.emit("realIndexChange"), t.emit("slideChange"));
}
function Tf(e, t) {
  const i = this, s = i.params;
  let n = e.closest(`.${s.slideClass}, swiper-slide`);
  !n && i.isElement && t && t.length > 1 && t.includes(e) && [...t.slice(t.indexOf(e) + 1, t.length)].forEach((o) => {
    !n && o.matches && o.matches(`.${s.slideClass}, swiper-slide`) && (n = o);
  });
  let r = !1, a;
  if (n) {
    for (let o = 0; o < i.slides.length; o += 1)
      if (i.slides[o] === n) {
        r = !0, a = o;
        break;
      }
  }
  if (n && r)
    i.clickedSlide = n, i.virtual && i.params.virtual.enabled ? i.clickedIndex = parseInt(n.getAttribute("data-swiper-slide-index"), 10) : i.clickedIndex = a;
  else {
    i.clickedSlide = void 0, i.clickedIndex = void 0;
    return;
  }
  s.slideToClickedSlide && i.clickedIndex !== void 0 && i.clickedIndex !== i.activeIndex && i.slideToClickedSlide();
}
var Nf = {
  updateSize: gf,
  updateSlides: _f,
  updateAutoHeight: vf,
  updateSlidesOffset: wf,
  updateSlidesProgress: bf,
  updateProgress: yf,
  updateSlidesClasses: Ef,
  updateActiveIndex: Sf,
  updateClickedSlide: Tf
};
function kf(e) {
  e === void 0 && (e = this.isHorizontal() ? "x" : "y");
  const t = this, {
    params: i,
    rtlTranslate: s,
    translate: n,
    wrapperEl: r
  } = t;
  if (i.virtualTranslate)
    return s ? -n : n;
  if (i.cssMode)
    return n;
  let a = sf(r, e);
  return a += t.cssOverflowAdjustment(), s && (a = -a), a || 0;
}
function Af(e, t) {
  const i = this, {
    rtlTranslate: s,
    params: n,
    wrapperEl: r,
    progress: a
  } = i;
  let o = 0, l = 0;
  const c = 0;
  i.isHorizontal() ? o = s ? -e : e : l = e, n.roundLengths && (o = Math.floor(o), l = Math.floor(l)), i.previousTranslate = i.translate, i.translate = i.isHorizontal() ? o : l, n.cssMode ? r[i.isHorizontal() ? "scrollLeft" : "scrollTop"] = i.isHorizontal() ? -o : -l : n.virtualTranslate || (i.isHorizontal() ? o -= i.cssOverflowAdjustment() : l -= i.cssOverflowAdjustment(), r.style.transform = `translate3d(${o}px, ${l}px, ${c}px)`);
  let d;
  const f = i.maxTranslate() - i.minTranslate();
  f === 0 ? d = 0 : d = (e - i.minTranslate()) / f, d !== a && i.updateProgress(e), i.emit("setTranslate", i.translate, t);
}
function Mf() {
  return -this.snapGrid[0];
}
function Cf() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function If(e, t, i, s, n) {
  e === void 0 && (e = 0), t === void 0 && (t = this.params.speed), i === void 0 && (i = !0), s === void 0 && (s = !0);
  const r = this, {
    params: a,
    wrapperEl: o
  } = r;
  if (r.animating && a.preventInteractionOnTransition)
    return !1;
  const l = r.minTranslate(), c = r.maxTranslate();
  let d;
  if (s && e > l ? d = l : s && e < c ? d = c : d = e, r.updateProgress(d), a.cssMode) {
    const f = r.isHorizontal();
    if (t === 0)
      o[f ? "scrollLeft" : "scrollTop"] = -d;
    else {
      if (!r.support.smoothScroll)
        return yn({
          swiper: r,
          targetPosition: -d,
          side: f ? "left" : "top"
        }), !0;
      o.scrollTo({
        [f ? "left" : "top"]: -d,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return t === 0 ? (r.setTransition(0), r.setTranslate(d), i && (r.emit("beforeTransitionStart", t, n), r.emit("transitionEnd"))) : (r.setTransition(t), r.setTranslate(d), i && (r.emit("beforeTransitionStart", t, n), r.emit("transitionStart")), r.animating || (r.animating = !0, r.onTranslateToWrapperTransitionEnd || (r.onTranslateToWrapperTransitionEnd = function(h) {
    !r || r.destroyed || h.target === this && (r.wrapperEl.removeEventListener("transitionend", r.onTranslateToWrapperTransitionEnd), r.onTranslateToWrapperTransitionEnd = null, delete r.onTranslateToWrapperTransitionEnd, r.animating = !1, i && r.emit("transitionEnd"));
  }), r.wrapperEl.addEventListener("transitionend", r.onTranslateToWrapperTransitionEnd))), !0;
}
var Rf = {
  getTranslate: kf,
  setTranslate: Af,
  minTranslate: Mf,
  maxTranslate: Cf,
  translateTo: If
};
function Of(e, t) {
  const i = this;
  i.params.cssMode || (i.wrapperEl.style.transitionDuration = `${e}ms`, i.wrapperEl.style.transitionDelay = e === 0 ? "0ms" : ""), i.emit("setTransition", e, t);
}
function kn(e) {
  let {
    swiper: t,
    runCallbacks: i,
    direction: s,
    step: n
  } = e;
  const {
    activeIndex: r,
    previousIndex: a
  } = t;
  let o = s;
  o || (r > a ? o = "next" : r < a ? o = "prev" : o = "reset"), t.emit(`transition${n}`), i && o === "reset" ? t.emit(`slideResetTransition${n}`) : i && r !== a && (t.emit(`slideChangeTransition${n}`), o === "next" ? t.emit(`slideNextTransition${n}`) : t.emit(`slidePrevTransition${n}`));
}
function Lf(e, t) {
  e === void 0 && (e = !0);
  const i = this, {
    params: s
  } = i;
  s.cssMode || (s.autoHeight && i.updateAutoHeight(), kn({
    swiper: i,
    runCallbacks: e,
    direction: t,
    step: "Start"
  }));
}
function Pf(e, t) {
  e === void 0 && (e = !0);
  const i = this, {
    params: s
  } = i;
  i.animating = !1, !s.cssMode && (i.setTransition(0), kn({
    swiper: i,
    runCallbacks: e,
    direction: t,
    step: "End"
  }));
}
var Df = {
  setTransition: Of,
  transitionStart: Lf,
  transitionEnd: Pf
};
function $f(e, t, i, s, n) {
  e === void 0 && (e = 0), i === void 0 && (i = !0), typeof e == "string" && (e = parseInt(e, 10));
  const r = this;
  let a = e;
  a < 0 && (a = 0);
  const {
    params: o,
    snapGrid: l,
    slidesGrid: c,
    previousIndex: d,
    activeIndex: f,
    rtlTranslate: h,
    wrapperEl: g,
    enabled: m
  } = r;
  if (!m && !s && !n || r.destroyed || r.animating && o.preventInteractionOnTransition)
    return !1;
  typeof t > "u" && (t = r.params.speed);
  const b = Math.min(r.params.slidesPerGroupSkip, a);
  let E = b + Math.floor((a - b) / r.params.slidesPerGroup);
  E >= l.length && (E = l.length - 1);
  const x = -l[E];
  if (o.normalizeSlideIndex)
    for (let S = 0; S < c.length; S += 1) {
      const N = -Math.floor(x * 100), R = Math.floor(c[S] * 100), A = Math.floor(c[S + 1] * 100);
      typeof c[S + 1] < "u" ? N >= R && N < A - (A - R) / 2 ? a = S : N >= R && N < A && (a = S + 1) : N >= R && (a = S);
    }
  if (r.initialized && a !== f && (!r.allowSlideNext && (h ? x > r.translate && x > r.minTranslate() : x < r.translate && x < r.minTranslate()) || !r.allowSlidePrev && x > r.translate && x > r.maxTranslate() && (f || 0) !== a))
    return !1;
  a !== (d || 0) && i && r.emit("beforeSlideChangeStart"), r.updateProgress(x);
  let p;
  a > f ? p = "next" : a < f ? p = "prev" : p = "reset";
  const _ = r.virtual && r.params.virtual.enabled;
  if (!(_ && n) && (h && -x === r.translate || !h && x === r.translate))
    return r.updateActiveIndex(a), o.autoHeight && r.updateAutoHeight(), r.updateSlidesClasses(), o.effect !== "slide" && r.setTranslate(x), p !== "reset" && (r.transitionStart(i, p), r.transitionEnd(i, p)), !1;
  if (o.cssMode) {
    const S = r.isHorizontal(), N = h ? x : -x;
    if (t === 0)
      _ && (r.wrapperEl.style.scrollSnapType = "none", r._immediateVirtual = !0), _ && !r._cssModeVirtualInitialSet && r.params.initialSlide > 0 ? (r._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
        g[S ? "scrollLeft" : "scrollTop"] = N;
      })) : g[S ? "scrollLeft" : "scrollTop"] = N, _ && requestAnimationFrame(() => {
        r.wrapperEl.style.scrollSnapType = "", r._immediateVirtual = !1;
      });
    else {
      if (!r.support.smoothScroll)
        return yn({
          swiper: r,
          targetPosition: N,
          side: S ? "left" : "top"
        }), !0;
      g.scrollTo({
        [S ? "left" : "top"]: N,
        behavior: "smooth"
      });
    }
    return !0;
  }
  const y = Nn().isSafari;
  return _ && !n && y && r.isElement && r.virtual.update(!1, !1, a), r.setTransition(t), r.setTranslate(x), r.updateActiveIndex(a), r.updateSlidesClasses(), r.emit("beforeTransitionStart", t, s), r.transitionStart(i, p), t === 0 ? r.transitionEnd(i, p) : r.animating || (r.animating = !0, r.onSlideToWrapperTransitionEnd || (r.onSlideToWrapperTransitionEnd = function(N) {
    !r || r.destroyed || N.target === this && (r.wrapperEl.removeEventListener("transitionend", r.onSlideToWrapperTransitionEnd), r.onSlideToWrapperTransitionEnd = null, delete r.onSlideToWrapperTransitionEnd, r.transitionEnd(i, p));
  }), r.wrapperEl.addEventListener("transitionend", r.onSlideToWrapperTransitionEnd)), !0;
}
function zf(e, t, i, s) {
  e === void 0 && (e = 0), i === void 0 && (i = !0), typeof e == "string" && (e = parseInt(e, 10));
  const n = this;
  if (n.destroyed) return;
  typeof t > "u" && (t = n.params.speed);
  const r = n.grid && n.params.grid && n.params.grid.rows > 1;
  let a = e;
  if (n.params.loop)
    if (n.virtual && n.params.virtual.enabled)
      a = a + n.virtual.slidesBefore;
    else {
      let o;
      if (r) {
        const h = a * n.params.grid.rows;
        o = n.slides.find((g) => g.getAttribute("data-swiper-slide-index") * 1 === h).column;
      } else
        o = n.getSlideIndexByData(a);
      const l = r ? Math.ceil(n.slides.length / n.params.grid.rows) : n.slides.length, {
        centeredSlides: c
      } = n.params;
      let d = n.params.slidesPerView;
      d === "auto" ? d = n.slidesPerViewDynamic() : (d = Math.ceil(parseFloat(n.params.slidesPerView, 10)), c && d % 2 === 0 && (d = d + 1));
      let f = l - o < d;
      if (c && (f = f || o < Math.ceil(d / 2)), s && c && n.params.slidesPerView !== "auto" && !r && (f = !1), f) {
        const h = c ? o < n.activeIndex ? "prev" : "next" : o - n.activeIndex - 1 < n.params.slidesPerView ? "next" : "prev";
        n.loopFix({
          direction: h,
          slideTo: !0,
          activeSlideIndex: h === "next" ? o + 1 : o - l + 1,
          slideRealIndex: h === "next" ? n.realIndex : void 0
        });
      }
      if (r) {
        const h = a * n.params.grid.rows;
        a = n.slides.find((g) => g.getAttribute("data-swiper-slide-index") * 1 === h).column;
      } else
        a = n.getSlideIndexByData(a);
    }
  return requestAnimationFrame(() => {
    n.slideTo(a, t, i, s);
  }), n;
}
function Vf(e, t, i) {
  t === void 0 && (t = !0);
  const s = this, {
    enabled: n,
    params: r,
    animating: a
  } = s;
  if (!n || s.destroyed) return s;
  typeof e > "u" && (e = s.params.speed);
  let o = r.slidesPerGroup;
  r.slidesPerView === "auto" && r.slidesPerGroup === 1 && r.slidesPerGroupAuto && (o = Math.max(s.slidesPerViewDynamic("current", !0), 1));
  const l = s.activeIndex < r.slidesPerGroupSkip ? 1 : o, c = s.virtual && r.virtual.enabled;
  if (r.loop) {
    if (a && !c && r.loopPreventsSliding) return !1;
    if (s.loopFix({
      direction: "next"
    }), s._clientLeft = s.wrapperEl.clientLeft, s.activeIndex === s.slides.length - 1 && r.cssMode)
      return requestAnimationFrame(() => {
        s.slideTo(s.activeIndex + l, e, t, i);
      }), !0;
  }
  return r.rewind && s.isEnd ? s.slideTo(0, e, t, i) : s.slideTo(s.activeIndex + l, e, t, i);
}
function Bf(e, t, i) {
  t === void 0 && (t = !0);
  const s = this, {
    params: n,
    snapGrid: r,
    slidesGrid: a,
    rtlTranslate: o,
    enabled: l,
    animating: c
  } = s;
  if (!l || s.destroyed) return s;
  typeof e > "u" && (e = s.params.speed);
  const d = s.virtual && n.virtual.enabled;
  if (n.loop) {
    if (c && !d && n.loopPreventsSliding) return !1;
    s.loopFix({
      direction: "prev"
    }), s._clientLeft = s.wrapperEl.clientLeft;
  }
  const f = o ? s.translate : -s.translate;
  function h(p) {
    return p < 0 ? -Math.floor(Math.abs(p)) : Math.floor(p);
  }
  const g = h(f), m = r.map((p) => h(p)), b = n.freeMode && n.freeMode.enabled;
  let E = r[m.indexOf(g) - 1];
  if (typeof E > "u" && (n.cssMode || b)) {
    let p;
    r.forEach((_, w) => {
      g >= _ && (p = w);
    }), typeof p < "u" && (E = b ? r[p] : r[p > 0 ? p - 1 : p]);
  }
  let x = 0;
  if (typeof E < "u" && (x = a.indexOf(E), x < 0 && (x = s.activeIndex - 1), n.slidesPerView === "auto" && n.slidesPerGroup === 1 && n.slidesPerGroupAuto && (x = x - s.slidesPerViewDynamic("previous", !0) + 1, x = Math.max(x, 0))), n.rewind && s.isBeginning) {
    const p = s.params.virtual && s.params.virtual.enabled && s.virtual ? s.virtual.slides.length - 1 : s.slides.length - 1;
    return s.slideTo(p, e, t, i);
  } else if (n.loop && s.activeIndex === 0 && n.cssMode)
    return requestAnimationFrame(() => {
      s.slideTo(x, e, t, i);
    }), !0;
  return s.slideTo(x, e, t, i);
}
function Hf(e, t, i) {
  t === void 0 && (t = !0);
  const s = this;
  if (!s.destroyed)
    return typeof e > "u" && (e = s.params.speed), s.slideTo(s.activeIndex, e, t, i);
}
function Ff(e, t, i, s) {
  t === void 0 && (t = !0), s === void 0 && (s = 0.5);
  const n = this;
  if (n.destroyed) return;
  typeof e > "u" && (e = n.params.speed);
  let r = n.activeIndex;
  const a = Math.min(n.params.slidesPerGroupSkip, r), o = a + Math.floor((r - a) / n.params.slidesPerGroup), l = n.rtlTranslate ? n.translate : -n.translate;
  if (l >= n.snapGrid[o]) {
    const c = n.snapGrid[o], d = n.snapGrid[o + 1];
    l - c > (d - c) * s && (r += n.params.slidesPerGroup);
  } else {
    const c = n.snapGrid[o - 1], d = n.snapGrid[o];
    l - c <= (d - c) * s && (r -= n.params.slidesPerGroup);
  }
  return r = Math.max(r, 0), r = Math.min(r, n.slidesGrid.length - 1), n.slideTo(r, e, t, i);
}
function Gf() {
  const e = this;
  if (e.destroyed) return;
  const {
    params: t,
    slidesEl: i
  } = e, s = t.slidesPerView === "auto" ? e.slidesPerViewDynamic() : t.slidesPerView;
  let n = e.clickedIndex, r;
  const a = e.isElement ? "swiper-slide" : `.${t.slideClass}`;
  if (t.loop) {
    if (e.animating) return;
    r = parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10), t.centeredSlides ? n < e.loopedSlides - s / 2 || n > e.slides.length - e.loopedSlides + s / 2 ? (e.loopFix(), n = e.getSlideIndex(Oe(i, `${a}[data-swiper-slide-index="${r}"]`)[0]), Bi(() => {
      e.slideTo(n);
    })) : e.slideTo(n) : n > e.slides.length - s ? (e.loopFix(), n = e.getSlideIndex(Oe(i, `${a}[data-swiper-slide-index="${r}"]`)[0]), Bi(() => {
      e.slideTo(n);
    })) : e.slideTo(n);
  } else
    e.slideTo(n);
}
var qf = {
  slideTo: $f,
  slideToLoop: zf,
  slideNext: Vf,
  slidePrev: Bf,
  slideReset: Hf,
  slideToClosest: Ff,
  slideToClickedSlide: Gf
};
function jf(e, t) {
  const i = this, {
    params: s,
    slidesEl: n
  } = i;
  if (!s.loop || i.virtual && i.params.virtual.enabled) return;
  const r = () => {
    Oe(n, `.${s.slideClass}, swiper-slide`).forEach((h, g) => {
      h.setAttribute("data-swiper-slide-index", g);
    });
  }, a = i.grid && s.grid && s.grid.rows > 1, o = s.slidesPerGroup * (a ? s.grid.rows : 1), l = i.slides.length % o !== 0, c = a && i.slides.length % s.grid.rows !== 0, d = (f) => {
    for (let h = 0; h < f; h += 1) {
      const g = i.isElement ? Rt("swiper-slide", [s.slideBlankClass]) : Rt("div", [s.slideClass, s.slideBlankClass]);
      i.slidesEl.append(g);
    }
  };
  if (l) {
    if (s.loopAddBlankSlides) {
      const f = o - i.slides.length % o;
      d(f), i.recalcSlides(), i.updateSlides();
    } else
      ai("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    r();
  } else if (c) {
    if (s.loopAddBlankSlides) {
      const f = s.grid.rows - i.slides.length % s.grid.rows;
      d(f), i.recalcSlides(), i.updateSlides();
    } else
      ai("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    r();
  } else
    r();
  i.loopFix({
    slideRealIndex: e,
    direction: s.centeredSlides ? void 0 : "next",
    initial: t
  });
}
function Uf(e) {
  let {
    slideRealIndex: t,
    slideTo: i = !0,
    direction: s,
    setTranslate: n,
    activeSlideIndex: r,
    initial: a,
    byController: o,
    byMousewheel: l
  } = e === void 0 ? {} : e;
  const c = this;
  if (!c.params.loop) return;
  c.emit("beforeLoopFix");
  const {
    slides: d,
    allowSlidePrev: f,
    allowSlideNext: h,
    slidesEl: g,
    params: m
  } = c, {
    centeredSlides: b,
    initialSlide: E
  } = m;
  if (c.allowSlidePrev = !0, c.allowSlideNext = !0, c.virtual && m.virtual.enabled) {
    i && (!m.centeredSlides && c.snapIndex === 0 ? c.slideTo(c.virtual.slides.length, 0, !1, !0) : m.centeredSlides && c.snapIndex < m.slidesPerView ? c.slideTo(c.virtual.slides.length + c.snapIndex, 0, !1, !0) : c.snapIndex === c.snapGrid.length - 1 && c.slideTo(c.virtual.slidesBefore, 0, !1, !0)), c.allowSlidePrev = f, c.allowSlideNext = h, c.emit("loopFix");
    return;
  }
  let x = m.slidesPerView;
  x === "auto" ? x = c.slidesPerViewDynamic() : (x = Math.ceil(parseFloat(m.slidesPerView, 10)), b && x % 2 === 0 && (x = x + 1));
  const p = m.slidesPerGroupAuto ? x : m.slidesPerGroup;
  let _ = p;
  _ % p !== 0 && (_ += p - _ % p), _ += m.loopAdditionalSlides, c.loopedSlides = _;
  const w = c.grid && m.grid && m.grid.rows > 1;
  d.length < x + _ || c.params.effect === "cards" && d.length < x + _ * 2 ? ai("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : w && m.grid.fill === "row" && ai("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
  const v = [], y = [], S = w ? Math.ceil(d.length / m.grid.rows) : d.length, N = a && S - E < x && !b;
  let R = N ? E : c.activeIndex;
  typeof r > "u" ? r = c.getSlideIndex(d.find((L) => L.classList.contains(m.slideActiveClass))) : R = r;
  const A = s === "next" || !s, C = s === "prev" || !s;
  let P = 0, D = 0;
  const z = (w ? d[r].column : r) + (b && typeof n > "u" ? -x / 2 + 0.5 : 0);
  if (z < _) {
    P = Math.max(_ - z, p);
    for (let L = 0; L < _ - z; L += 1) {
      const k = L - Math.floor(L / S) * S;
      if (w) {
        const I = S - k - 1;
        for (let $ = d.length - 1; $ >= 0; $ -= 1)
          d[$].column === I && v.push($);
      } else
        v.push(S - k - 1);
    }
  } else if (z + x > S - _) {
    D = Math.max(z - (S - _ * 2), p), N && (D = Math.max(D, x - S + E + 1));
    for (let L = 0; L < D; L += 1) {
      const k = L - Math.floor(L / S) * S;
      w ? d.forEach((I, $) => {
        I.column === k && y.push($);
      }) : y.push(k);
    }
  }
  if (c.__preventObserver__ = !0, requestAnimationFrame(() => {
    c.__preventObserver__ = !1;
  }), c.params.effect === "cards" && d.length < x + _ * 2 && (y.includes(r) && y.splice(y.indexOf(r), 1), v.includes(r) && v.splice(v.indexOf(r), 1)), C && v.forEach((L) => {
    d[L].swiperLoopMoveDOM = !0, g.prepend(d[L]), d[L].swiperLoopMoveDOM = !1;
  }), A && y.forEach((L) => {
    d[L].swiperLoopMoveDOM = !0, g.append(d[L]), d[L].swiperLoopMoveDOM = !1;
  }), c.recalcSlides(), m.slidesPerView === "auto" ? c.updateSlides() : w && (v.length > 0 && C || y.length > 0 && A) && c.slides.forEach((L, k) => {
    c.grid.updateSlide(k, L, c.slides);
  }), m.watchSlidesProgress && c.updateSlidesOffset(), i) {
    if (v.length > 0 && C) {
      if (typeof t > "u") {
        const L = c.slidesGrid[R], I = c.slidesGrid[R + P] - L;
        l ? c.setTranslate(c.translate - I) : (c.slideTo(R + Math.ceil(P), 0, !1, !0), n && (c.touchEventsData.startTranslate = c.touchEventsData.startTranslate - I, c.touchEventsData.currentTranslate = c.touchEventsData.currentTranslate - I));
      } else if (n) {
        const L = w ? v.length / m.grid.rows : v.length;
        c.slideTo(c.activeIndex + L, 0, !1, !0), c.touchEventsData.currentTranslate = c.translate;
      }
    } else if (y.length > 0 && A)
      if (typeof t > "u") {
        const L = c.slidesGrid[R], I = c.slidesGrid[R - D] - L;
        l ? c.setTranslate(c.translate - I) : (c.slideTo(R - D, 0, !1, !0), n && (c.touchEventsData.startTranslate = c.touchEventsData.startTranslate - I, c.touchEventsData.currentTranslate = c.touchEventsData.currentTranslate - I));
      } else {
        const L = w ? y.length / m.grid.rows : y.length;
        c.slideTo(c.activeIndex - L, 0, !1, !0);
      }
  }
  if (c.allowSlidePrev = f, c.allowSlideNext = h, c.controller && c.controller.control && !o) {
    const L = {
      slideRealIndex: t,
      direction: s,
      setTranslate: n,
      activeSlideIndex: r,
      byController: !0
    };
    Array.isArray(c.controller.control) ? c.controller.control.forEach((k) => {
      !k.destroyed && k.params.loop && k.loopFix({
        ...L,
        slideTo: k.params.slidesPerView === m.slidesPerView ? i : !1
      });
    }) : c.controller.control instanceof c.constructor && c.controller.control.params.loop && c.controller.control.loopFix({
      ...L,
      slideTo: c.controller.control.params.slidesPerView === m.slidesPerView ? i : !1
    });
  }
  c.emit("loopFix");
}
function Wf() {
  const e = this, {
    params: t,
    slidesEl: i
  } = e;
  if (!t.loop || !i || e.virtual && e.params.virtual.enabled) return;
  e.recalcSlides();
  const s = [];
  e.slides.forEach((n) => {
    const r = typeof n.swiperSlideIndex > "u" ? n.getAttribute("data-swiper-slide-index") * 1 : n.swiperSlideIndex;
    s[r] = n;
  }), e.slides.forEach((n) => {
    n.removeAttribute("data-swiper-slide-index");
  }), s.forEach((n) => {
    i.append(n);
  }), e.recalcSlides(), e.slideTo(e.realIndex, 0);
}
var Yf = {
  loopCreate: jf,
  loopFix: Uf,
  loopDestroy: Wf
};
function Xf(e) {
  const t = this;
  if (!t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode) return;
  const i = t.params.touchEventsTarget === "container" ? t.el : t.wrapperEl;
  t.isElement && (t.__preventObserver__ = !0), i.style.cursor = "move", i.style.cursor = e ? "grabbing" : "grab", t.isElement && requestAnimationFrame(() => {
    t.__preventObserver__ = !1;
  });
}
function Zf() {
  const e = this;
  e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.isElement && (e.__preventObserver__ = !0), e[e.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", e.isElement && requestAnimationFrame(() => {
    e.__preventObserver__ = !1;
  }));
}
var Kf = {
  setGrabCursor: Xf,
  unsetGrabCursor: Zf
};
function Qf(e, t) {
  t === void 0 && (t = this);
  function i(s) {
    if (!s || s === Ue() || s === ue()) return null;
    s.assignedSlot && (s = s.assignedSlot);
    const n = s.closest(e);
    return !n && !s.getRootNode ? null : n || i(s.getRootNode().host);
  }
  return i(t);
}
function qs(e, t, i) {
  const s = ue(), {
    params: n
  } = e, r = n.edgeSwipeDetection, a = n.edgeSwipeThreshold;
  return r && (i <= a || i >= s.innerWidth - a) ? r === "prevent" ? (t.preventDefault(), !0) : !1 : !0;
}
function Jf(e) {
  const t = this, i = Ue();
  let s = e;
  s.originalEvent && (s = s.originalEvent);
  const n = t.touchEventsData;
  if (s.type === "pointerdown") {
    if (n.pointerId !== null && n.pointerId !== s.pointerId)
      return;
    n.pointerId = s.pointerId;
  } else s.type === "touchstart" && s.targetTouches.length === 1 && (n.touchId = s.targetTouches[0].identifier);
  if (s.type === "touchstart") {
    qs(t, s, s.targetTouches[0].pageX);
    return;
  }
  const {
    params: r,
    touches: a,
    enabled: o
  } = t;
  if (!o || !r.simulateTouch && s.pointerType === "mouse" || t.animating && r.preventInteractionOnTransition)
    return;
  !t.animating && r.cssMode && r.loop && t.loopFix();
  let l = s.target;
  if (r.touchEventsTarget === "wrapper" && !af(l, t.wrapperEl) || "which" in s && s.which === 3 || "button" in s && s.button > 0 || n.isTouched && n.isMoved) return;
  const c = !!r.noSwipingClass && r.noSwipingClass !== "", d = s.composedPath ? s.composedPath() : s.path;
  c && s.target && s.target.shadowRoot && d && (l = d[0]);
  const f = r.noSwipingSelector ? r.noSwipingSelector : `.${r.noSwipingClass}`, h = !!(s.target && s.target.shadowRoot);
  if (r.noSwiping && (h ? Qf(f, l) : l.closest(f))) {
    t.allowClick = !0;
    return;
  }
  if (r.swipeHandler && !l.closest(r.swipeHandler))
    return;
  a.currentX = s.pageX, a.currentY = s.pageY;
  const g = a.currentX, m = a.currentY;
  if (!qs(t, s, g))
    return;
  Object.assign(n, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), a.startX = g, a.startY = m, n.touchStartTime = ri(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, r.threshold > 0 && (n.allowThresholdMove = !1);
  let b = !0;
  l.matches(n.focusableElements) && (b = !1, l.nodeName === "SELECT" && (n.isTouched = !1)), i.activeElement && i.activeElement.matches(n.focusableElements) && i.activeElement !== l && (s.pointerType === "mouse" || s.pointerType !== "mouse" && !l.matches(n.focusableElements)) && i.activeElement.blur();
  const E = b && t.allowTouchMove && r.touchStartPreventDefault;
  (r.touchStartForcePreventDefault || E) && !l.isContentEditable && s.preventDefault(), r.freeMode && r.freeMode.enabled && t.freeMode && t.animating && !r.cssMode && t.freeMode.onTouchStart(), t.emit("touchStart", s);
}
function ep(e) {
  const t = Ue(), i = this, s = i.touchEventsData, {
    params: n,
    touches: r,
    rtlTranslate: a,
    enabled: o
  } = i;
  if (!o || !n.simulateTouch && e.pointerType === "mouse") return;
  let l = e;
  if (l.originalEvent && (l = l.originalEvent), l.type === "pointermove" && (s.touchId !== null || l.pointerId !== s.pointerId))
    return;
  let c;
  if (l.type === "touchmove") {
    if (c = [...l.changedTouches].find((y) => y.identifier === s.touchId), !c || c.identifier !== s.touchId) return;
  } else
    c = l;
  if (!s.isTouched) {
    s.startMoving && s.isScrolling && i.emit("touchMoveOpposite", l);
    return;
  }
  const d = c.pageX, f = c.pageY;
  if (l.preventedByNestedSwiper) {
    r.startX = d, r.startY = f;
    return;
  }
  if (!i.allowTouchMove) {
    l.target.matches(s.focusableElements) || (i.allowClick = !1), s.isTouched && (Object.assign(r, {
      startX: d,
      startY: f,
      currentX: d,
      currentY: f
    }), s.touchStartTime = ri());
    return;
  }
  if (n.touchReleaseOnEdges && !n.loop)
    if (i.isVertical()) {
      if (f < r.startY && i.translate <= i.maxTranslate() || f > r.startY && i.translate >= i.minTranslate()) {
        s.isTouched = !1, s.isMoved = !1;
        return;
      }
    } else {
      if (a && (d > r.startX && -i.translate <= i.maxTranslate() || d < r.startX && -i.translate >= i.minTranslate()))
        return;
      if (!a && (d < r.startX && i.translate <= i.maxTranslate() || d > r.startX && i.translate >= i.minTranslate()))
        return;
    }
  if (t.activeElement && t.activeElement.matches(s.focusableElements) && t.activeElement !== l.target && l.pointerType !== "mouse" && t.activeElement.blur(), t.activeElement && l.target === t.activeElement && l.target.matches(s.focusableElements)) {
    s.isMoved = !0, i.allowClick = !1;
    return;
  }
  s.allowTouchCallbacks && i.emit("touchMove", l), r.previousX = r.currentX, r.previousY = r.currentY, r.currentX = d, r.currentY = f;
  const h = r.currentX - r.startX, g = r.currentY - r.startY;
  if (i.params.threshold && Math.sqrt(h ** 2 + g ** 2) < i.params.threshold) return;
  if (typeof s.isScrolling > "u") {
    let y;
    i.isHorizontal() && r.currentY === r.startY || i.isVertical() && r.currentX === r.startX ? s.isScrolling = !1 : h * h + g * g >= 25 && (y = Math.atan2(Math.abs(g), Math.abs(h)) * 180 / Math.PI, s.isScrolling = i.isHorizontal() ? y > n.touchAngle : 90 - y > n.touchAngle);
  }
  if (s.isScrolling && i.emit("touchMoveOpposite", l), typeof s.startMoving > "u" && (r.currentX !== r.startX || r.currentY !== r.startY) && (s.startMoving = !0), s.isScrolling || l.type === "touchmove" && s.preventTouchMoveFromPointerMove) {
    s.isTouched = !1;
    return;
  }
  if (!s.startMoving)
    return;
  i.allowClick = !1, !n.cssMode && l.cancelable && l.preventDefault(), n.touchMoveStopPropagation && !n.nested && l.stopPropagation();
  let m = i.isHorizontal() ? h : g, b = i.isHorizontal() ? r.currentX - r.previousX : r.currentY - r.previousY;
  n.oneWayMovement && (m = Math.abs(m) * (a ? 1 : -1), b = Math.abs(b) * (a ? 1 : -1)), r.diff = m, m *= n.touchRatio, a && (m = -m, b = -b);
  const E = i.touchesDirection;
  i.swipeDirection = m > 0 ? "prev" : "next", i.touchesDirection = b > 0 ? "prev" : "next";
  const x = i.params.loop && !n.cssMode, p = i.touchesDirection === "next" && i.allowSlideNext || i.touchesDirection === "prev" && i.allowSlidePrev;
  if (!s.isMoved) {
    if (x && p && i.loopFix({
      direction: i.swipeDirection
    }), s.startTranslate = i.getTranslate(), i.setTransition(0), i.animating) {
      const y = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          bySwiperTouchMove: !0
        }
      });
      i.wrapperEl.dispatchEvent(y);
    }
    s.allowMomentumBounce = !1, n.grabCursor && (i.allowSlideNext === !0 || i.allowSlidePrev === !0) && i.setGrabCursor(!0), i.emit("sliderFirstMove", l);
  }
  let _;
  if ((/* @__PURE__ */ new Date()).getTime(), n._loopSwapReset !== !1 && s.isMoved && s.allowThresholdMove && E !== i.touchesDirection && x && p && Math.abs(m) >= 1) {
    Object.assign(r, {
      startX: d,
      startY: f,
      currentX: d,
      currentY: f,
      startTranslate: s.currentTranslate
    }), s.loopSwapReset = !0, s.startTranslate = s.currentTranslate;
    return;
  }
  i.emit("sliderMove", l), s.isMoved = !0, s.currentTranslate = m + s.startTranslate;
  let w = !0, v = n.resistanceRatio;
  if (n.touchReleaseOnEdges && (v = 0), m > 0 ? (x && p && !_ && s.allowThresholdMove && s.currentTranslate > (n.centeredSlides ? i.minTranslate() - i.slidesSizesGrid[i.activeIndex + 1] - (n.slidesPerView !== "auto" && i.slides.length - n.slidesPerView >= 2 ? i.slidesSizesGrid[i.activeIndex + 1] + i.params.spaceBetween : 0) - i.params.spaceBetween : i.minTranslate()) && i.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), s.currentTranslate > i.minTranslate() && (w = !1, n.resistance && (s.currentTranslate = i.minTranslate() - 1 + (-i.minTranslate() + s.startTranslate + m) ** v))) : m < 0 && (x && p && !_ && s.allowThresholdMove && s.currentTranslate < (n.centeredSlides ? i.maxTranslate() + i.slidesSizesGrid[i.slidesSizesGrid.length - 1] + i.params.spaceBetween + (n.slidesPerView !== "auto" && i.slides.length - n.slidesPerView >= 2 ? i.slidesSizesGrid[i.slidesSizesGrid.length - 1] + i.params.spaceBetween : 0) : i.maxTranslate()) && i.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: i.slides.length - (n.slidesPerView === "auto" ? i.slidesPerViewDynamic() : Math.ceil(parseFloat(n.slidesPerView, 10)))
  }), s.currentTranslate < i.maxTranslate() && (w = !1, n.resistance && (s.currentTranslate = i.maxTranslate() + 1 - (i.maxTranslate() - s.startTranslate - m) ** v))), w && (l.preventedByNestedSwiper = !0), !i.allowSlideNext && i.swipeDirection === "next" && s.currentTranslate < s.startTranslate && (s.currentTranslate = s.startTranslate), !i.allowSlidePrev && i.swipeDirection === "prev" && s.currentTranslate > s.startTranslate && (s.currentTranslate = s.startTranslate), !i.allowSlidePrev && !i.allowSlideNext && (s.currentTranslate = s.startTranslate), n.threshold > 0)
    if (Math.abs(m) > n.threshold || s.allowThresholdMove) {
      if (!s.allowThresholdMove) {
        s.allowThresholdMove = !0, r.startX = r.currentX, r.startY = r.currentY, s.currentTranslate = s.startTranslate, r.diff = i.isHorizontal() ? r.currentX - r.startX : r.currentY - r.startY;
        return;
      }
    } else {
      s.currentTranslate = s.startTranslate;
      return;
    }
  !n.followFinger || n.cssMode || ((n.freeMode && n.freeMode.enabled && i.freeMode || n.watchSlidesProgress) && (i.updateActiveIndex(), i.updateSlidesClasses()), n.freeMode && n.freeMode.enabled && i.freeMode && i.freeMode.onTouchMove(), i.updateProgress(s.currentTranslate), i.setTranslate(s.currentTranslate));
}
function tp(e) {
  const t = this, i = t.touchEventsData;
  let s = e;
  s.originalEvent && (s = s.originalEvent);
  let n;
  if (s.type === "touchend" || s.type === "touchcancel") {
    if (n = [...s.changedTouches].find((v) => v.identifier === i.touchId), !n || n.identifier !== i.touchId) return;
  } else {
    if (i.touchId !== null || s.pointerId !== i.pointerId) return;
    n = s;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(s.type) && !(["pointercancel", "contextmenu"].includes(s.type) && (t.browser.isSafari || t.browser.isWebView)))
    return;
  i.pointerId = null, i.touchId = null;
  const {
    params: a,
    touches: o,
    rtlTranslate: l,
    slidesGrid: c,
    enabled: d
  } = t;
  if (!d || !a.simulateTouch && s.pointerType === "mouse") return;
  if (i.allowTouchCallbacks && t.emit("touchEnd", s), i.allowTouchCallbacks = !1, !i.isTouched) {
    i.isMoved && a.grabCursor && t.setGrabCursor(!1), i.isMoved = !1, i.startMoving = !1;
    return;
  }
  a.grabCursor && i.isMoved && i.isTouched && (t.allowSlideNext === !0 || t.allowSlidePrev === !0) && t.setGrabCursor(!1);
  const f = ri(), h = f - i.touchStartTime;
  if (t.allowClick) {
    const v = s.path || s.composedPath && s.composedPath();
    t.updateClickedSlide(v && v[0] || s.target, v), t.emit("tap click", s), h < 300 && f - i.lastClickTime < 300 && t.emit("doubleTap doubleClick", s);
  }
  if (i.lastClickTime = ri(), Bi(() => {
    t.destroyed || (t.allowClick = !0);
  }), !i.isTouched || !i.isMoved || !t.swipeDirection || o.diff === 0 && !i.loopSwapReset || i.currentTranslate === i.startTranslate && !i.loopSwapReset) {
    i.isTouched = !1, i.isMoved = !1, i.startMoving = !1;
    return;
  }
  i.isTouched = !1, i.isMoved = !1, i.startMoving = !1;
  let g;
  if (a.followFinger ? g = l ? t.translate : -t.translate : g = -i.currentTranslate, a.cssMode)
    return;
  if (a.freeMode && a.freeMode.enabled) {
    t.freeMode.onTouchEnd({
      currentPos: g
    });
    return;
  }
  const m = g >= -t.maxTranslate() && !t.params.loop;
  let b = 0, E = t.slidesSizesGrid[0];
  for (let v = 0; v < c.length; v += v < a.slidesPerGroupSkip ? 1 : a.slidesPerGroup) {
    const y = v < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
    typeof c[v + y] < "u" ? (m || g >= c[v] && g < c[v + y]) && (b = v, E = c[v + y] - c[v]) : (m || g >= c[v]) && (b = v, E = c[c.length - 1] - c[c.length - 2]);
  }
  let x = null, p = null;
  a.rewind && (t.isBeginning ? p = a.virtual && a.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1 : t.isEnd && (x = 0));
  const _ = (g - c[b]) / E, w = b < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
  if (h > a.longSwipesMs) {
    if (!a.longSwipes) {
      t.slideTo(t.activeIndex);
      return;
    }
    t.swipeDirection === "next" && (_ >= a.longSwipesRatio ? t.slideTo(a.rewind && t.isEnd ? x : b + w) : t.slideTo(b)), t.swipeDirection === "prev" && (_ > 1 - a.longSwipesRatio ? t.slideTo(b + w) : p !== null && _ < 0 && Math.abs(_) > a.longSwipesRatio ? t.slideTo(p) : t.slideTo(b));
  } else {
    if (!a.shortSwipes) {
      t.slideTo(t.activeIndex);
      return;
    }
    t.navigation && (s.target === t.navigation.nextEl || s.target === t.navigation.prevEl) ? s.target === t.navigation.nextEl ? t.slideTo(b + w) : t.slideTo(b) : (t.swipeDirection === "next" && t.slideTo(x !== null ? x : b + w), t.swipeDirection === "prev" && t.slideTo(p !== null ? p : b));
  }
}
function js() {
  const e = this, {
    params: t,
    el: i
  } = e;
  if (i && i.offsetWidth === 0) return;
  t.breakpoints && e.setBreakpoint();
  const {
    allowSlideNext: s,
    allowSlidePrev: n,
    snapGrid: r
  } = e, a = e.virtual && e.params.virtual.enabled;
  e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses();
  const o = a && t.loop;
  (t.slidesPerView === "auto" || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides && !o ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.params.loop && !a ? e.slideToLoop(e.realIndex, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && (clearTimeout(e.autoplay.resizeTimeout), e.autoplay.resizeTimeout = setTimeout(() => {
    e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume();
  }, 500)), e.allowSlidePrev = n, e.allowSlideNext = s, e.params.watchOverflow && r !== e.snapGrid && e.checkOverflow();
}
function ip(e) {
  const t = this;
  t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
}
function sp() {
  const e = this, {
    wrapperEl: t,
    rtlTranslate: i,
    enabled: s
  } = e;
  if (!s) return;
  e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = -t.scrollLeft : e.translate = -t.scrollTop, e.translate === 0 && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
  let n;
  const r = e.maxTranslate() - e.minTranslate();
  r === 0 ? n = 0 : n = (e.translate - e.minTranslate()) / r, n !== e.progress && e.updateProgress(i ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
}
function np(e) {
  const t = this;
  Jt(t, e.target), !(t.params.cssMode || t.params.slidesPerView !== "auto" && !t.params.autoHeight) && t.update();
}
function rp() {
  const e = this;
  e.documentTouchHandlerProceeded || (e.documentTouchHandlerProceeded = !0, e.params.touchReleaseOnEdges && (e.el.style.touchAction = "auto"));
}
const An = (e, t) => {
  const i = Ue(), {
    params: s,
    el: n,
    wrapperEl: r,
    device: a
  } = e, o = !!s.nested, l = t === "on" ? "addEventListener" : "removeEventListener", c = t;
  !n || typeof n == "string" || (i[l]("touchstart", e.onDocumentTouchStart, {
    passive: !1,
    capture: o
  }), n[l]("touchstart", e.onTouchStart, {
    passive: !1
  }), n[l]("pointerdown", e.onTouchStart, {
    passive: !1
  }), i[l]("touchmove", e.onTouchMove, {
    passive: !1,
    capture: o
  }), i[l]("pointermove", e.onTouchMove, {
    passive: !1,
    capture: o
  }), i[l]("touchend", e.onTouchEnd, {
    passive: !0
  }), i[l]("pointerup", e.onTouchEnd, {
    passive: !0
  }), i[l]("pointercancel", e.onTouchEnd, {
    passive: !0
  }), i[l]("touchcancel", e.onTouchEnd, {
    passive: !0
  }), i[l]("pointerout", e.onTouchEnd, {
    passive: !0
  }), i[l]("pointerleave", e.onTouchEnd, {
    passive: !0
  }), i[l]("contextmenu", e.onTouchEnd, {
    passive: !0
  }), (s.preventClicks || s.preventClicksPropagation) && n[l]("click", e.onClick, !0), s.cssMode && r[l]("scroll", e.onScroll), s.updateOnWindowResize ? e[c](a.ios || a.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", js, !0) : e[c]("observerUpdate", js, !0), n[l]("load", e.onLoad, {
    capture: !0
  }));
};
function ap() {
  const e = this, {
    params: t
  } = e;
  e.onTouchStart = Jf.bind(e), e.onTouchMove = ep.bind(e), e.onTouchEnd = tp.bind(e), e.onDocumentTouchStart = rp.bind(e), t.cssMode && (e.onScroll = sp.bind(e)), e.onClick = ip.bind(e), e.onLoad = np.bind(e), An(e, "on");
}
function op() {
  An(this, "off");
}
var lp = {
  attachEvents: ap,
  detachEvents: op
};
const Us = (e, t) => e.grid && t.grid && t.grid.rows > 1;
function cp() {
  const e = this, {
    realIndex: t,
    initialized: i,
    params: s,
    el: n
  } = e, r = s.breakpoints;
  if (!r || r && Object.keys(r).length === 0) return;
  const a = Ue(), o = s.breakpointsBase === "window" || !s.breakpointsBase ? s.breakpointsBase : "container", l = ["window", "container"].includes(s.breakpointsBase) || !s.breakpointsBase ? e.el : a.querySelector(s.breakpointsBase), c = e.getBreakpoint(r, o, l);
  if (!c || e.currentBreakpoint === c) return;
  const f = (c in r ? r[c] : void 0) || e.originalParams, h = Us(e, s), g = Us(e, f), m = e.params.grabCursor, b = f.grabCursor, E = s.enabled;
  h && !g ? (n.classList.remove(`${s.containerModifierClass}grid`, `${s.containerModifierClass}grid-column`), e.emitContainerClasses()) : !h && g && (n.classList.add(`${s.containerModifierClass}grid`), (f.grid.fill && f.grid.fill === "column" || !f.grid.fill && s.grid.fill === "column") && n.classList.add(`${s.containerModifierClass}grid-column`), e.emitContainerClasses()), m && !b ? e.unsetGrabCursor() : !m && b && e.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach((y) => {
    if (typeof f[y] > "u") return;
    const S = s[y] && s[y].enabled, N = f[y] && f[y].enabled;
    S && !N && e[y].disable(), !S && N && e[y].enable();
  });
  const x = f.direction && f.direction !== s.direction, p = s.loop && (f.slidesPerView !== s.slidesPerView || x), _ = s.loop;
  x && i && e.changeDirection(), _e(e.params, f);
  const w = e.params.enabled, v = e.params.loop;
  Object.assign(e, {
    allowTouchMove: e.params.allowTouchMove,
    allowSlideNext: e.params.allowSlideNext,
    allowSlidePrev: e.params.allowSlidePrev
  }), E && !w ? e.disable() : !E && w && e.enable(), e.currentBreakpoint = c, e.emit("_beforeBreakpoint", f), i && (p ? (e.loopDestroy(), e.loopCreate(t), e.updateSlides()) : !_ && v ? (e.loopCreate(t), e.updateSlides()) : _ && !v && e.loopDestroy()), e.emit("breakpoint", f);
}
function dp(e, t, i) {
  if (t === void 0 && (t = "window"), !e || t === "container" && !i) return;
  let s = !1;
  const n = ue(), r = t === "window" ? n.innerHeight : i.clientHeight, a = Object.keys(e).map((o) => {
    if (typeof o == "string" && o.indexOf("@") === 0) {
      const l = parseFloat(o.substr(1));
      return {
        value: r * l,
        point: o
      };
    }
    return {
      value: o,
      point: o
    };
  });
  a.sort((o, l) => parseInt(o.value, 10) - parseInt(l.value, 10));
  for (let o = 0; o < a.length; o += 1) {
    const {
      point: l,
      value: c
    } = a[o];
    t === "window" ? n.matchMedia(`(min-width: ${c}px)`).matches && (s = l) : c <= i.clientWidth && (s = l);
  }
  return s || "max";
}
var up = {
  setBreakpoint: cp,
  getBreakpoint: dp
};
function fp(e, t) {
  const i = [];
  return e.forEach((s) => {
    typeof s == "object" ? Object.keys(s).forEach((n) => {
      s[n] && i.push(t + n);
    }) : typeof s == "string" && i.push(t + s);
  }), i;
}
function pp() {
  const e = this, {
    classNames: t,
    params: i,
    rtl: s,
    el: n,
    device: r
  } = e, a = fp(["initialized", i.direction, {
    "free-mode": e.params.freeMode && i.freeMode.enabled
  }, {
    autoheight: i.autoHeight
  }, {
    rtl: s
  }, {
    grid: i.grid && i.grid.rows > 1
  }, {
    "grid-column": i.grid && i.grid.rows > 1 && i.grid.fill === "column"
  }, {
    android: r.android
  }, {
    ios: r.ios
  }, {
    "css-mode": i.cssMode
  }, {
    centered: i.cssMode && i.centeredSlides
  }, {
    "watch-progress": i.watchSlidesProgress
  }], i.containerModifierClass);
  t.push(...a), n.classList.add(...t), e.emitContainerClasses();
}
function hp() {
  const e = this, {
    el: t,
    classNames: i
  } = e;
  !t || typeof t == "string" || (t.classList.remove(...i), e.emitContainerClasses());
}
var mp = {
  addClasses: pp,
  removeClasses: hp
};
function gp() {
  const e = this, {
    isLocked: t,
    params: i
  } = e, {
    slidesOffsetBefore: s
  } = i;
  if (s) {
    const n = e.slides.length - 1, r = e.slidesGrid[n] + e.slidesSizesGrid[n] + s * 2;
    e.isLocked = e.size > r;
  } else
    e.isLocked = e.snapGrid.length === 1;
  i.allowSlideNext === !0 && (e.allowSlideNext = !e.isLocked), i.allowSlidePrev === !0 && (e.allowSlidePrev = !e.isLocked), t && t !== e.isLocked && (e.isEnd = !1), t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
}
var _p = {
  checkOverflow: gp
}, Ws = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  swiperElementNodeName: "SWIPER-CONTAINER",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  eventsPrefix: "swiper",
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // loop
  loop: !1,
  loopAddBlankSlides: !0,
  loopAdditionalSlides: 0,
  loopPreventsSliding: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-blank",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideFullyVisibleClass: "swiper-slide-fully-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function vp(e, t) {
  return function(s) {
    s === void 0 && (s = {});
    const n = Object.keys(s)[0], r = s[n];
    if (typeof r != "object" || r === null) {
      _e(t, s);
      return;
    }
    if (e[n] === !0 && (e[n] = {
      enabled: !0
    }), n === "navigation" && e[n] && e[n].enabled && !e[n].prevEl && !e[n].nextEl && (e[n].auto = !0), ["pagination", "scrollbar"].indexOf(n) >= 0 && e[n] && e[n].enabled && !e[n].el && (e[n].auto = !0), !(n in e && "enabled" in r)) {
      _e(t, s);
      return;
    }
    typeof e[n] == "object" && !("enabled" in e[n]) && (e[n].enabled = !0), e[n] || (e[n] = {
      enabled: !1
    }), _e(t, s);
  };
}
const Ci = {
  eventsEmitter: mf,
  update: Nf,
  translate: Rf,
  transition: Df,
  slide: qf,
  loop: Yf,
  grabCursor: Kf,
  events: lp,
  breakpoints: up,
  checkOverflow: _p,
  classes: mp
}, Ii = {};
class Se {
  constructor() {
    let t, i;
    for (var s = arguments.length, n = new Array(s), r = 0; r < s; r++)
      n[r] = arguments[r];
    n.length === 1 && n[0].constructor && Object.prototype.toString.call(n[0]).slice(8, -1) === "Object" ? i = n[0] : [t, i] = n, i || (i = {}), i = _e({}, i), t && !i.el && (i.el = t);
    const a = Ue();
    if (i.el && typeof i.el == "string" && a.querySelectorAll(i.el).length > 1) {
      const d = [];
      return a.querySelectorAll(i.el).forEach((f) => {
        const h = _e({}, i, {
          el: f
        });
        d.push(new Se(h));
      }), d;
    }
    const o = this;
    o.__swiper__ = !0, o.support = Sn(), o.device = Tn({
      userAgent: i.userAgent
    }), o.browser = Nn(), o.eventsListeners = {}, o.eventsAnyListeners = [], o.modules = [...o.__modules__], i.modules && Array.isArray(i.modules) && o.modules.push(...i.modules);
    const l = {};
    o.modules.forEach((d) => {
      d({
        params: i,
        swiper: o,
        extendParams: vp(i, l),
        on: o.on.bind(o),
        once: o.once.bind(o),
        off: o.off.bind(o),
        emit: o.emit.bind(o)
      });
    });
    const c = _e({}, Ws, l);
    return o.params = _e({}, c, Ii, i), o.originalParams = _e({}, o.params), o.passedParams = _e({}, i), o.params && o.params.on && Object.keys(o.params.on).forEach((d) => {
      o.on(d, o.params.on[d]);
    }), o.params && o.params.onAny && o.onAny(o.params.onAny), Object.assign(o, {
      enabled: o.params.enabled,
      el: t,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return o.params.direction === "horizontal";
      },
      isVertical() {
        return o.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: o.params.allowSlideNext,
      allowSlidePrev: o.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: o.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: o.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), o.emit("_swiper"), o.params.init && o.init(), o;
  }
  getDirectionLabel(t) {
    return this.isHorizontal() ? t : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[t];
  }
  getSlideIndex(t) {
    const {
      slidesEl: i,
      params: s
    } = this, n = Oe(i, `.${s.slideClass}, swiper-slide`), r = Ot(n[0]);
    return Ot(t) - r;
  }
  getSlideIndexByData(t) {
    return this.getSlideIndex(this.slides.find((i) => i.getAttribute("data-swiper-slide-index") * 1 === t));
  }
  recalcSlides() {
    const t = this, {
      slidesEl: i,
      params: s
    } = t;
    t.slides = Oe(i, `.${s.slideClass}, swiper-slide`);
  }
  enable() {
    const t = this;
    t.enabled || (t.enabled = !0, t.params.grabCursor && t.setGrabCursor(), t.emit("enable"));
  }
  disable() {
    const t = this;
    t.enabled && (t.enabled = !1, t.params.grabCursor && t.unsetGrabCursor(), t.emit("disable"));
  }
  setProgress(t, i) {
    const s = this;
    t = Math.min(Math.max(t, 0), 1);
    const n = s.minTranslate(), a = (s.maxTranslate() - n) * t + n;
    s.translateTo(a, typeof i > "u" ? 0 : i), s.updateActiveIndex(), s.updateSlidesClasses();
  }
  emitContainerClasses() {
    const t = this;
    if (!t.params._emitClasses || !t.el) return;
    const i = t.el.className.split(" ").filter((s) => s.indexOf("swiper") === 0 || s.indexOf(t.params.containerModifierClass) === 0);
    t.emit("_containerClasses", i.join(" "));
  }
  getSlideClasses(t) {
    const i = this;
    return i.destroyed ? "" : t.className.split(" ").filter((s) => s.indexOf("swiper-slide") === 0 || s.indexOf(i.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const t = this;
    if (!t.params._emitClasses || !t.el) return;
    const i = [];
    t.slides.forEach((s) => {
      const n = t.getSlideClasses(s);
      i.push({
        slideEl: s,
        classNames: n
      }), t.emit("_slideClass", s, n);
    }), t.emit("_slideClasses", i);
  }
  slidesPerViewDynamic(t, i) {
    t === void 0 && (t = "current"), i === void 0 && (i = !1);
    const s = this, {
      params: n,
      slides: r,
      slidesGrid: a,
      slidesSizesGrid: o,
      size: l,
      activeIndex: c
    } = s;
    let d = 1;
    if (typeof n.slidesPerView == "number") return n.slidesPerView;
    if (n.centeredSlides) {
      let f = r[c] ? Math.ceil(r[c].swiperSlideSize) : 0, h;
      for (let g = c + 1; g < r.length; g += 1)
        r[g] && !h && (f += Math.ceil(r[g].swiperSlideSize), d += 1, f > l && (h = !0));
      for (let g = c - 1; g >= 0; g -= 1)
        r[g] && !h && (f += r[g].swiperSlideSize, d += 1, f > l && (h = !0));
    } else if (t === "current")
      for (let f = c + 1; f < r.length; f += 1)
        (i ? a[f] + o[f] - a[c] < l : a[f] - a[c] < l) && (d += 1);
    else
      for (let f = c - 1; f >= 0; f -= 1)
        a[c] - a[f] < l && (d += 1);
    return d;
  }
  update() {
    const t = this;
    if (!t || t.destroyed) return;
    const {
      snapGrid: i,
      params: s
    } = t;
    s.breakpoints && t.setBreakpoint(), [...t.el.querySelectorAll('[loading="lazy"]')].forEach((a) => {
      a.complete && Jt(t, a);
    }), t.updateSize(), t.updateSlides(), t.updateProgress(), t.updateSlidesClasses();
    function n() {
      const a = t.rtlTranslate ? t.translate * -1 : t.translate, o = Math.min(Math.max(a, t.maxTranslate()), t.minTranslate());
      t.setTranslate(o), t.updateActiveIndex(), t.updateSlidesClasses();
    }
    let r;
    if (s.freeMode && s.freeMode.enabled && !s.cssMode)
      n(), s.autoHeight && t.updateAutoHeight();
    else {
      if ((s.slidesPerView === "auto" || s.slidesPerView > 1) && t.isEnd && !s.centeredSlides) {
        const a = t.virtual && s.virtual.enabled ? t.virtual.slides : t.slides;
        r = t.slideTo(a.length - 1, 0, !1, !0);
      } else
        r = t.slideTo(t.activeIndex, 0, !1, !0);
      r || n();
    }
    s.watchOverflow && i !== t.snapGrid && t.checkOverflow(), t.emit("update");
  }
  changeDirection(t, i) {
    i === void 0 && (i = !0);
    const s = this, n = s.params.direction;
    return t || (t = n === "horizontal" ? "vertical" : "horizontal"), t === n || t !== "horizontal" && t !== "vertical" || (s.el.classList.remove(`${s.params.containerModifierClass}${n}`), s.el.classList.add(`${s.params.containerModifierClass}${t}`), s.emitContainerClasses(), s.params.direction = t, s.slides.forEach((r) => {
      t === "vertical" ? r.style.width = "" : r.style.height = "";
    }), s.emit("changeDirection"), i && s.update()), s;
  }
  changeLanguageDirection(t) {
    const i = this;
    i.rtl && t === "rtl" || !i.rtl && t === "ltr" || (i.rtl = t === "rtl", i.rtlTranslate = i.params.direction === "horizontal" && i.rtl, i.rtl ? (i.el.classList.add(`${i.params.containerModifierClass}rtl`), i.el.dir = "rtl") : (i.el.classList.remove(`${i.params.containerModifierClass}rtl`), i.el.dir = "ltr"), i.update());
  }
  mount(t) {
    const i = this;
    if (i.mounted) return !0;
    let s = t || i.params.el;
    if (typeof s == "string" && (s = document.querySelector(s)), !s)
      return !1;
    s.swiper = i, s.parentNode && s.parentNode.host && s.parentNode.host.nodeName === i.params.swiperElementNodeName.toUpperCase() && (i.isElement = !0);
    const n = () => `.${(i.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let a = s && s.shadowRoot && s.shadowRoot.querySelector ? s.shadowRoot.querySelector(n()) : Oe(s, n())[0];
    return !a && i.params.createElements && (a = Rt("div", i.params.wrapperClass), s.append(a), Oe(s, `.${i.params.slideClass}`).forEach((o) => {
      a.append(o);
    })), Object.assign(i, {
      el: s,
      wrapperEl: a,
      slidesEl: i.isElement && !s.parentNode.host.slideSlots ? s.parentNode.host : a,
      hostEl: i.isElement ? s.parentNode.host : s,
      mounted: !0,
      // RTL
      rtl: s.dir.toLowerCase() === "rtl" || Ke(s, "direction") === "rtl",
      rtlTranslate: i.params.direction === "horizontal" && (s.dir.toLowerCase() === "rtl" || Ke(s, "direction") === "rtl"),
      wrongRTL: Ke(a, "display") === "-webkit-box"
    }), !0;
  }
  init(t) {
    const i = this;
    if (i.initialized || i.mount(t) === !1) return i;
    i.emit("beforeInit"), i.params.breakpoints && i.setBreakpoint(), i.addClasses(), i.updateSize(), i.updateSlides(), i.params.watchOverflow && i.checkOverflow(), i.params.grabCursor && i.enabled && i.setGrabCursor(), i.params.loop && i.virtual && i.params.virtual.enabled ? i.slideTo(i.params.initialSlide + i.virtual.slidesBefore, 0, i.params.runCallbacksOnInit, !1, !0) : i.slideTo(i.params.initialSlide, 0, i.params.runCallbacksOnInit, !1, !0), i.params.loop && i.loopCreate(void 0, !0), i.attachEvents();
    const n = [...i.el.querySelectorAll('[loading="lazy"]')];
    return i.isElement && n.push(...i.hostEl.querySelectorAll('[loading="lazy"]')), n.forEach((r) => {
      r.complete ? Jt(i, r) : r.addEventListener("load", (a) => {
        Jt(i, a.target);
      });
    }), Gi(i), i.initialized = !0, Gi(i), i.emit("init"), i.emit("afterInit"), i;
  }
  destroy(t, i) {
    t === void 0 && (t = !0), i === void 0 && (i = !0);
    const s = this, {
      params: n,
      el: r,
      wrapperEl: a,
      slides: o
    } = s;
    return typeof s.params > "u" || s.destroyed || (s.emit("beforeDestroy"), s.initialized = !1, s.detachEvents(), n.loop && s.loopDestroy(), i && (s.removeClasses(), r && typeof r != "string" && r.removeAttribute("style"), a && a.removeAttribute("style"), o && o.length && o.forEach((l) => {
      l.classList.remove(n.slideVisibleClass, n.slideFullyVisibleClass, n.slideActiveClass, n.slideNextClass, n.slidePrevClass), l.removeAttribute("style"), l.removeAttribute("data-swiper-slide-index");
    })), s.emit("destroy"), Object.keys(s.eventsListeners).forEach((l) => {
      s.off(l);
    }), t !== !1 && (s.el && typeof s.el != "string" && (s.el.swiper = null), ef(s)), s.destroyed = !0), null;
  }
  static extendDefaults(t) {
    _e(Ii, t);
  }
  static get extendedDefaults() {
    return Ii;
  }
  static get defaults() {
    return Ws;
  }
  static installModule(t) {
    Se.prototype.__modules__ || (Se.prototype.__modules__ = []);
    const i = Se.prototype.__modules__;
    typeof t == "function" && i.indexOf(t) < 0 && i.push(t);
  }
  static use(t) {
    return Array.isArray(t) ? (t.forEach((i) => Se.installModule(i)), Se) : (Se.installModule(t), Se);
  }
}
Object.keys(Ci).forEach((e) => {
  Object.keys(Ci[e]).forEach((t) => {
    Se.prototype[t] = Ci[e][t];
  });
});
Se.use([pf, hf]);
function wp(e, t, i, s) {
  return e.params.createElements && Object.keys(s).forEach((n) => {
    if (!i[n] && i.auto === !0) {
      let r = Oe(e.el, `.${s[n]}`)[0];
      r || (r = Rt("div", s[n]), r.className = s[n], e.el.append(r)), i[n] = r, t[n] = r;
    }
  }), i;
}
function Xe(e) {
  return e === void 0 && (e = ""), `.${e.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`;
}
function bp(e) {
  let {
    swiper: t,
    extendParams: i,
    on: s,
    emit: n
  } = e;
  const r = "swiper-pagination";
  i({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (p) => p,
      formatFractionTotal: (p) => p,
      bulletClass: `${r}-bullet`,
      bulletActiveClass: `${r}-bullet-active`,
      modifierClass: `${r}-`,
      currentClass: `${r}-current`,
      totalClass: `${r}-total`,
      hiddenClass: `${r}-hidden`,
      progressbarFillClass: `${r}-progressbar-fill`,
      progressbarOppositeClass: `${r}-progressbar-opposite`,
      clickableClass: `${r}-clickable`,
      lockClass: `${r}-lock`,
      horizontalClass: `${r}-horizontal`,
      verticalClass: `${r}-vertical`,
      paginationDisabledClass: `${r}-disabled`
    }
  }), t.pagination = {
    el: null,
    bullets: []
  };
  let a, o = 0;
  function l() {
    return !t.params.pagination.el || !t.pagination.el || Array.isArray(t.pagination.el) && t.pagination.el.length === 0;
  }
  function c(p, _) {
    const {
      bulletActiveClass: w
    } = t.params.pagination;
    p && (p = p[`${_ === "prev" ? "previous" : "next"}ElementSibling`], p && (p.classList.add(`${w}-${_}`), p = p[`${_ === "prev" ? "previous" : "next"}ElementSibling`], p && p.classList.add(`${w}-${_}-${_}`)));
  }
  function d(p, _, w) {
    if (p = p % w, _ = _ % w, _ === p + 1)
      return "next";
    if (_ === p - 1)
      return "previous";
  }
  function f(p) {
    const _ = p.target.closest(Xe(t.params.pagination.bulletClass));
    if (!_)
      return;
    p.preventDefault();
    const w = Ot(_) * t.params.slidesPerGroup;
    if (t.params.loop) {
      if (t.realIndex === w) return;
      const v = d(t.realIndex, w, t.slides.length);
      v === "next" ? t.slideNext() : v === "previous" ? t.slidePrev() : t.slideToLoop(w);
    } else
      t.slideTo(w);
  }
  function h() {
    const p = t.rtl, _ = t.params.pagination;
    if (l()) return;
    let w = t.pagination.el;
    w = W(w);
    let v, y;
    const S = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length, N = t.params.loop ? Math.ceil(S / t.params.slidesPerGroup) : t.snapGrid.length;
    if (t.params.loop ? (y = t.previousRealIndex || 0, v = t.params.slidesPerGroup > 1 ? Math.floor(t.realIndex / t.params.slidesPerGroup) : t.realIndex) : typeof t.snapIndex < "u" ? (v = t.snapIndex, y = t.previousSnapIndex) : (y = t.previousIndex || 0, v = t.activeIndex || 0), _.type === "bullets" && t.pagination.bullets && t.pagination.bullets.length > 0) {
      const R = t.pagination.bullets;
      let A, C, P;
      if (_.dynamicBullets && (a = Hi(R[0], t.isHorizontal() ? "width" : "height"), w.forEach((D) => {
        D.style[t.isHorizontal() ? "width" : "height"] = `${a * (_.dynamicMainBullets + 4)}px`;
      }), _.dynamicMainBullets > 1 && y !== void 0 && (o += v - (y || 0), o > _.dynamicMainBullets - 1 ? o = _.dynamicMainBullets - 1 : o < 0 && (o = 0)), A = Math.max(v - o, 0), C = A + (Math.min(R.length, _.dynamicMainBullets) - 1), P = (C + A) / 2), R.forEach((D) => {
        const B = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((z) => `${_.bulletActiveClass}${z}`)].map((z) => typeof z == "string" && z.includes(" ") ? z.split(" ") : z).flat();
        D.classList.remove(...B);
      }), w.length > 1)
        R.forEach((D) => {
          const B = Ot(D);
          B === v ? D.classList.add(..._.bulletActiveClass.split(" ")) : t.isElement && D.setAttribute("part", "bullet"), _.dynamicBullets && (B >= A && B <= C && D.classList.add(...`${_.bulletActiveClass}-main`.split(" ")), B === A && c(D, "prev"), B === C && c(D, "next"));
        });
      else {
        const D = R[v];
        if (D && D.classList.add(..._.bulletActiveClass.split(" ")), t.isElement && R.forEach((B, z) => {
          B.setAttribute("part", z === v ? "bullet-active" : "bullet");
        }), _.dynamicBullets) {
          const B = R[A], z = R[C];
          for (let L = A; L <= C; L += 1)
            R[L] && R[L].classList.add(...`${_.bulletActiveClass}-main`.split(" "));
          c(B, "prev"), c(z, "next");
        }
      }
      if (_.dynamicBullets) {
        const D = Math.min(R.length, _.dynamicMainBullets + 4), B = (a * D - a) / 2 - P * a, z = p ? "right" : "left";
        R.forEach((L) => {
          L.style[t.isHorizontal() ? z : "top"] = `${B}px`;
        });
      }
    }
    w.forEach((R, A) => {
      if (_.type === "fraction" && (R.querySelectorAll(Xe(_.currentClass)).forEach((C) => {
        C.textContent = _.formatFractionCurrent(v + 1);
      }), R.querySelectorAll(Xe(_.totalClass)).forEach((C) => {
        C.textContent = _.formatFractionTotal(N);
      })), _.type === "progressbar") {
        let C;
        _.progressbarOpposite ? C = t.isHorizontal() ? "vertical" : "horizontal" : C = t.isHorizontal() ? "horizontal" : "vertical";
        const P = (v + 1) / N;
        let D = 1, B = 1;
        C === "horizontal" ? D = P : B = P, R.querySelectorAll(Xe(_.progressbarFillClass)).forEach((z) => {
          z.style.transform = `translate3d(0,0,0) scaleX(${D}) scaleY(${B})`, z.style.transitionDuration = `${t.params.speed}ms`;
        });
      }
      _.type === "custom" && _.renderCustom ? (Fi(R, _.renderCustom(t, v + 1, N)), A === 0 && n("paginationRender", R)) : (A === 0 && n("paginationRender", R), n("paginationUpdate", R)), t.params.watchOverflow && t.enabled && R.classList[t.isLocked ? "add" : "remove"](_.lockClass);
    });
  }
  function g() {
    const p = t.params.pagination;
    if (l()) return;
    const _ = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.grid && t.params.grid.rows > 1 ? t.slides.length / Math.ceil(t.params.grid.rows) : t.slides.length;
    let w = t.pagination.el;
    w = W(w);
    let v = "";
    if (p.type === "bullets") {
      let y = t.params.loop ? Math.ceil(_ / t.params.slidesPerGroup) : t.snapGrid.length;
      t.params.freeMode && t.params.freeMode.enabled && y > _ && (y = _);
      for (let S = 0; S < y; S += 1)
        p.renderBullet ? v += p.renderBullet.call(t, S, p.bulletClass) : v += `<${p.bulletElement} ${t.isElement ? 'part="bullet"' : ""} class="${p.bulletClass}"></${p.bulletElement}>`;
    }
    p.type === "fraction" && (p.renderFraction ? v = p.renderFraction.call(t, p.currentClass, p.totalClass) : v = `<span class="${p.currentClass}"></span> / <span class="${p.totalClass}"></span>`), p.type === "progressbar" && (p.renderProgressbar ? v = p.renderProgressbar.call(t, p.progressbarFillClass) : v = `<span class="${p.progressbarFillClass}"></span>`), t.pagination.bullets = [], w.forEach((y) => {
      p.type !== "custom" && Fi(y, v || ""), p.type === "bullets" && t.pagination.bullets.push(...y.querySelectorAll(Xe(p.bulletClass)));
    }), p.type !== "custom" && n("paginationRender", w[0]);
  }
  function m() {
    t.params.pagination = wp(t, t.originalParams.pagination, t.params.pagination, {
      el: "swiper-pagination"
    });
    const p = t.params.pagination;
    if (!p.el) return;
    let _;
    typeof p.el == "string" && t.isElement && (_ = t.el.querySelector(p.el)), !_ && typeof p.el == "string" && (_ = [...document.querySelectorAll(p.el)]), _ || (_ = p.el), !(!_ || _.length === 0) && (t.params.uniqueNavElements && typeof p.el == "string" && Array.isArray(_) && _.length > 1 && (_ = [...t.el.querySelectorAll(p.el)], _.length > 1 && (_ = _.find((w) => xn(w, ".swiper")[0] === t.el))), Array.isArray(_) && _.length === 1 && (_ = _[0]), Object.assign(t.pagination, {
      el: _
    }), _ = W(_), _.forEach((w) => {
      p.type === "bullets" && p.clickable && w.classList.add(...(p.clickableClass || "").split(" ")), w.classList.add(p.modifierClass + p.type), w.classList.add(t.isHorizontal() ? p.horizontalClass : p.verticalClass), p.type === "bullets" && p.dynamicBullets && (w.classList.add(`${p.modifierClass}${p.type}-dynamic`), o = 0, p.dynamicMainBullets < 1 && (p.dynamicMainBullets = 1)), p.type === "progressbar" && p.progressbarOpposite && w.classList.add(p.progressbarOppositeClass), p.clickable && w.addEventListener("click", f), t.enabled || w.classList.add(p.lockClass);
    }));
  }
  function b() {
    const p = t.params.pagination;
    if (l()) return;
    let _ = t.pagination.el;
    _ && (_ = W(_), _.forEach((w) => {
      w.classList.remove(p.hiddenClass), w.classList.remove(p.modifierClass + p.type), w.classList.remove(t.isHorizontal() ? p.horizontalClass : p.verticalClass), p.clickable && (w.classList.remove(...(p.clickableClass || "").split(" ")), w.removeEventListener("click", f));
    })), t.pagination.bullets && t.pagination.bullets.forEach((w) => w.classList.remove(...p.bulletActiveClass.split(" ")));
  }
  s("changeDirection", () => {
    if (!t.pagination || !t.pagination.el) return;
    const p = t.params.pagination;
    let {
      el: _
    } = t.pagination;
    _ = W(_), _.forEach((w) => {
      w.classList.remove(p.horizontalClass, p.verticalClass), w.classList.add(t.isHorizontal() ? p.horizontalClass : p.verticalClass);
    });
  }), s("init", () => {
    t.params.pagination.enabled === !1 ? x() : (m(), g(), h());
  }), s("activeIndexChange", () => {
    typeof t.snapIndex > "u" && h();
  }), s("snapIndexChange", () => {
    h();
  }), s("snapGridLengthChange", () => {
    g(), h();
  }), s("destroy", () => {
    b();
  }), s("enable disable", () => {
    let {
      el: p
    } = t.pagination;
    p && (p = W(p), p.forEach((_) => _.classList[t.enabled ? "remove" : "add"](t.params.pagination.lockClass)));
  }), s("lock unlock", () => {
    h();
  }), s("click", (p, _) => {
    const w = _.target, v = W(t.pagination.el);
    if (t.params.pagination.el && t.params.pagination.hideOnClick && v && v.length > 0 && !w.classList.contains(t.params.pagination.bulletClass)) {
      if (t.navigation && (t.navigation.nextEl && w === t.navigation.nextEl || t.navigation.prevEl && w === t.navigation.prevEl)) return;
      const y = v[0].classList.contains(t.params.pagination.hiddenClass);
      n(y === !0 ? "paginationShow" : "paginationHide"), v.forEach((S) => S.classList.toggle(t.params.pagination.hiddenClass));
    }
  });
  const E = () => {
    t.el.classList.remove(t.params.pagination.paginationDisabledClass);
    let {
      el: p
    } = t.pagination;
    p && (p = W(p), p.forEach((_) => _.classList.remove(t.params.pagination.paginationDisabledClass))), m(), g(), h();
  }, x = () => {
    t.el.classList.add(t.params.pagination.paginationDisabledClass);
    let {
      el: p
    } = t.pagination;
    p && (p = W(p), p.forEach((_) => _.classList.add(t.params.pagination.paginationDisabledClass))), b();
  };
  Object.assign(t.pagination, {
    enable: E,
    disable: x,
    render: g,
    update: h,
    init: m,
    destroy: b
  });
}
function yp(e) {
  let {
    swiper: t,
    extendParams: i,
    on: s
  } = e;
  i({
    a11y: {
      enabled: !0,
      notificationClass: "swiper-notification",
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
      firstSlideMessage: "This is the first slide",
      lastSlideMessage: "This is the last slide",
      paginationBulletMessage: "Go to slide {{index}}",
      slideLabelMessage: "{{index}} / {{slidesLength}}",
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      containerRole: null,
      itemRoleDescriptionMessage: null,
      slideRole: "group",
      id: null,
      scrollOnFocus: !0
    }
  }), t.a11y = {
    clicked: !1
  };
  let n = null, r, a, o = (/* @__PURE__ */ new Date()).getTime();
  function l(k) {
    const I = n;
    I.length !== 0 && Fi(I, k);
  }
  function c(k) {
    const I = () => Math.round(16 * Math.random()).toString(16);
    return "x".repeat(k).replace(/x/g, I);
  }
  function d(k) {
    k = W(k), k.forEach((I) => {
      I.setAttribute("tabIndex", "0");
    });
  }
  function f(k) {
    k = W(k), k.forEach((I) => {
      I.setAttribute("tabIndex", "-1");
    });
  }
  function h(k, I) {
    k = W(k), k.forEach(($) => {
      $.setAttribute("role", I);
    });
  }
  function g(k, I) {
    k = W(k), k.forEach(($) => {
      $.setAttribute("aria-roledescription", I);
    });
  }
  function m(k, I) {
    k = W(k), k.forEach(($) => {
      $.setAttribute("aria-controls", I);
    });
  }
  function b(k, I) {
    k = W(k), k.forEach(($) => {
      $.setAttribute("aria-label", I);
    });
  }
  function E(k, I) {
    k = W(k), k.forEach(($) => {
      $.setAttribute("id", I);
    });
  }
  function x(k, I) {
    k = W(k), k.forEach(($) => {
      $.setAttribute("aria-live", I);
    });
  }
  function p(k) {
    k = W(k), k.forEach((I) => {
      I.setAttribute("aria-disabled", !0);
    });
  }
  function _(k) {
    k = W(k), k.forEach((I) => {
      I.setAttribute("aria-disabled", !1);
    });
  }
  function w(k) {
    if (k.keyCode !== 13 && k.keyCode !== 32) return;
    const I = t.params.a11y, $ = k.target;
    if (!(t.pagination && t.pagination.el && ($ === t.pagination.el || t.pagination.el.contains(k.target)) && !k.target.matches(Xe(t.params.pagination.bulletClass)))) {
      if (t.navigation && t.navigation.prevEl && t.navigation.nextEl) {
        const q = W(t.navigation.prevEl);
        W(t.navigation.nextEl).includes($) && (t.isEnd && !t.params.loop || t.slideNext(), t.isEnd ? l(I.lastSlideMessage) : l(I.nextSlideMessage)), q.includes($) && (t.isBeginning && !t.params.loop || t.slidePrev(), t.isBeginning ? l(I.firstSlideMessage) : l(I.prevSlideMessage));
      }
      t.pagination && $.matches(Xe(t.params.pagination.bulletClass)) && $.click();
    }
  }
  function v() {
    if (t.params.loop || t.params.rewind || !t.navigation) return;
    const {
      nextEl: k,
      prevEl: I
    } = t.navigation;
    I && (t.isBeginning ? (p(I), f(I)) : (_(I), d(I))), k && (t.isEnd ? (p(k), f(k)) : (_(k), d(k)));
  }
  function y() {
    return t.pagination && t.pagination.bullets && t.pagination.bullets.length;
  }
  function S() {
    return y() && t.params.pagination.clickable;
  }
  function N() {
    const k = t.params.a11y;
    y() && t.pagination.bullets.forEach((I) => {
      t.params.pagination.clickable && (d(I), t.params.pagination.renderBullet || (h(I, "button"), b(I, k.paginationBulletMessage.replace(/\{\{index\}\}/, Ot(I) + 1)))), I.matches(Xe(t.params.pagination.bulletActiveClass)) ? I.setAttribute("aria-current", "true") : I.removeAttribute("aria-current");
    });
  }
  const R = (k, I, $) => {
    d(k), k.tagName !== "BUTTON" && (h(k, "button"), k.addEventListener("keydown", w)), b(k, $), m(k, I);
  }, A = (k) => {
    a && a !== k.target && !a.contains(k.target) && (r = !0), t.a11y.clicked = !0;
  }, C = () => {
    r = !1, requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        t.destroyed || (t.a11y.clicked = !1);
      });
    });
  }, P = (k) => {
    o = (/* @__PURE__ */ new Date()).getTime();
  }, D = (k) => {
    if (t.a11y.clicked || !t.params.a11y.scrollOnFocus || (/* @__PURE__ */ new Date()).getTime() - o < 100) return;
    const I = k.target.closest(`.${t.params.slideClass}, swiper-slide`);
    if (!I || !t.slides.includes(I)) return;
    a = I;
    const $ = t.slides.indexOf(I) === t.activeIndex, q = t.params.watchSlidesProgress && t.visibleSlides && t.visibleSlides.includes(I);
    $ || q || k.sourceCapabilities && k.sourceCapabilities.firesTouchEvents || (t.isHorizontal() ? t.el.scrollLeft = 0 : t.el.scrollTop = 0, requestAnimationFrame(() => {
      r || (t.params.loop ? t.slideToLoop(parseInt(I.getAttribute("data-swiper-slide-index")), 0) : t.slideTo(t.slides.indexOf(I), 0), r = !1);
    }));
  }, B = () => {
    const k = t.params.a11y;
    k.itemRoleDescriptionMessage && g(t.slides, k.itemRoleDescriptionMessage), k.slideRole && h(t.slides, k.slideRole);
    const I = t.slides.length;
    k.slideLabelMessage && t.slides.forEach(($, q) => {
      const te = t.params.loop ? parseInt($.getAttribute("data-swiper-slide-index"), 10) : q, K = k.slideLabelMessage.replace(/\{\{index\}\}/, te + 1).replace(/\{\{slidesLength\}\}/, I);
      b($, K);
    });
  }, z = () => {
    const k = t.params.a11y;
    t.el.append(n);
    const I = t.el;
    k.containerRoleDescriptionMessage && g(I, k.containerRoleDescriptionMessage), k.containerMessage && b(I, k.containerMessage), k.containerRole && h(I, k.containerRole);
    const $ = t.wrapperEl, q = k.id || $.getAttribute("id") || `swiper-wrapper-${c(16)}`, te = t.params.autoplay && t.params.autoplay.enabled ? "off" : "polite";
    E($, q), x($, te), B();
    let {
      nextEl: K,
      prevEl: ie
    } = t.navigation ? t.navigation : {};
    K = W(K), ie = W(ie), K && K.forEach((le) => R(le, q, k.nextSlideMessage)), ie && ie.forEach((le) => R(le, q, k.prevSlideMessage)), S() && W(t.pagination.el).forEach((ze) => {
      ze.addEventListener("keydown", w);
    }), Ue().addEventListener("visibilitychange", P), t.el.addEventListener("focus", D, !0), t.el.addEventListener("focus", D, !0), t.el.addEventListener("pointerdown", A, !0), t.el.addEventListener("pointerup", C, !0);
  };
  function L() {
    n && n.remove();
    let {
      nextEl: k,
      prevEl: I
    } = t.navigation ? t.navigation : {};
    k = W(k), I = W(I), k && k.forEach((q) => q.removeEventListener("keydown", w)), I && I.forEach((q) => q.removeEventListener("keydown", w)), S() && W(t.pagination.el).forEach((te) => {
      te.removeEventListener("keydown", w);
    }), Ue().removeEventListener("visibilitychange", P), t.el && typeof t.el != "string" && (t.el.removeEventListener("focus", D, !0), t.el.removeEventListener("pointerdown", A, !0), t.el.removeEventListener("pointerup", C, !0));
  }
  s("beforeInit", () => {
    n = Rt("span", t.params.a11y.notificationClass), n.setAttribute("aria-live", "assertive"), n.setAttribute("aria-atomic", "true");
  }), s("afterInit", () => {
    t.params.a11y.enabled && z();
  }), s("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
    t.params.a11y.enabled && B();
  }), s("fromEdge toEdge afterInit lock unlock", () => {
    t.params.a11y.enabled && v();
  }), s("paginationUpdate", () => {
    t.params.a11y.enabled && N();
  }), s("destroy", () => {
    t.params.a11y.enabled && L();
  });
}
function Ep(e) {
  const {
    effect: t,
    swiper: i,
    on: s,
    setTranslate: n,
    setTransition: r,
    overwriteParams: a,
    perspective: o,
    recreateShadows: l,
    getEffectParams: c
  } = e;
  s("beforeInit", () => {
    if (i.params.effect !== t) return;
    i.classNames.push(`${i.params.containerModifierClass}${t}`), o && o() && i.classNames.push(`${i.params.containerModifierClass}3d`);
    const f = a ? a() : {};
    Object.assign(i.params, f), Object.assign(i.originalParams, f);
  }), s("setTranslate _virtualUpdated", () => {
    i.params.effect === t && n();
  }), s("setTransition", (f, h) => {
    i.params.effect === t && r(h);
  }), s("transitionEnd", () => {
    if (i.params.effect === t && l) {
      if (!c || !c().slideShadows) return;
      i.slides.forEach((f) => {
        f.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((h) => h.remove());
      }), l();
    }
  });
  let d;
  s("virtualUpdate", () => {
    i.params.effect === t && (i.slides.length || (d = !0), requestAnimationFrame(() => {
      d && i.slides && i.slides.length && (n(), d = !1);
    }));
  });
}
function xp(e, t) {
  const i = En(t);
  return i !== t && (i.style.backfaceVisibility = "hidden", i.style["-webkit-backface-visibility"] = "hidden"), i;
}
function Sp(e) {
  let {
    swiper: t,
    duration: i,
    transformElements: s,
    allSlides: n
  } = e;
  const {
    activeIndex: r
  } = t, a = (o) => o.parentElement ? o.parentElement : t.slides.find((c) => c.shadowRoot && c.shadowRoot === o.parentNode);
  if (t.params.virtualTranslate && i !== 0) {
    let o = !1, l;
    n ? l = s : l = s.filter((c) => {
      const d = c.classList.contains("swiper-slide-transform") ? a(c) : c;
      return t.getSlideIndex(d) === r;
    }), l.forEach((c) => {
      cf(c, () => {
        if (o || !t || t.destroyed) return;
        o = !0, t.animating = !1;
        const d = new window.CustomEvent("transitionend", {
          bubbles: !0,
          cancelable: !0
        });
        t.wrapperEl.dispatchEvent(d);
      });
    });
  }
}
function Tp(e) {
  let {
    swiper: t,
    extendParams: i,
    on: s
  } = e;
  i({
    fadeEffect: {
      crossFade: !1
    }
  }), Ep({
    effect: "fade",
    swiper: t,
    on: s,
    setTranslate: () => {
      const {
        slides: a
      } = t, o = t.params.fadeEffect;
      for (let l = 0; l < a.length; l += 1) {
        const c = t.slides[l];
        let f = -c.swiperSlideOffset;
        t.params.virtualTranslate || (f -= t.translate);
        let h = 0;
        t.isHorizontal() || (h = f, f = 0);
        const g = t.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(c.progress), 0) : 1 + Math.min(Math.max(c.progress, -1), 0), m = xp(o, c);
        m.style.opacity = g, m.style.transform = `translate3d(${f}px, ${h}px, 0px)`;
      }
    },
    setTransition: (a) => {
      const o = t.slides.map((l) => En(l));
      o.forEach((l) => {
        l.style.transitionDuration = `${a}ms`;
      }), Sp({
        swiper: t,
        duration: a,
        transformElements: o,
        allSlides: !0
      });
    },
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !t.params.cssMode
    })
  });
}
var oi = /* @__PURE__ */ ((e) => (e.BY_SLIDE = "by-slide", e.BY_PAGE = "by-page", e))(oi || {}), Je = /* @__PURE__ */ ((e) => (e.ENTER_FROM_RIGHT = "enter-from-right", e.CROSSFADE = "crossfade", e))(Je || {});
const Ys = (e) => e <= 2 ? 1 : 2, Ri = {
  [ne.SMALL]: 25,
  [ne.MEDIUM]: 24,
  [ne.LARGE]: 30,
  [ne.X_LARGE]: 0,
  // unused, 0 is library default
  [ne.XX_LARGE]: 0
  // unused, 0 is library default
}, Np = {
  [Je.ENTER_FROM_RIGHT]: 500,
  [Je.CROSSFADE]: 800
}, kp = {
  [Je.ENTER_FROM_RIGHT]: "slide",
  [Je.CROSSFADE]: "fade"
}, Ap = (e, t, i) => ({
  [ne.SMALL]: {
    spaceBetween: Ri[ne.SMALL],
    slidesPerView: 1,
    slidesPerGroup: 1
  },
  [ne.MEDIUM]: {
    spaceBetween: Ri[ne.MEDIUM],
    slidesPerView: Ys(e),
    slidesPerGroup: i === oi.BY_PAGE ? Ys(e) : 1
  },
  [ne.LARGE]: {
    spaceBetween: Ri[ne.LARGE],
    /**
     * https://github.com/nolimits4web/swiper/issues/2062
     */
    slidesPerView: t === Je.CROSSFADE ? 1 : e,
    slidesPerGroup: i === oi.BY_PAGE ? e : 1
  }
}), Mp = (e) => Np[e], Cp = (e) => kp[e], Oi = (e) => {
  const t = e.el.querySelectorAll(".swiper-slide-visible"), i = Array.from(t);
  e.slides.forEach((s) => {
    i.includes(s) ? (s.removeAttribute("inert"), s.removeAttribute("aria-hidden")) : (s.setAttribute("inert", ""), s.setAttribute("aria-hidden", "true"));
  });
}, Gh = ({
  id: e,
  slidesPerPage: t,
  nextSlideLabel: i,
  prevSlideLabel: s,
  trackSlide: n,
  transition: r = oi.BY_PAGE,
  animation: a,
  slot: o,
  children: l
}) => {
  const c = `${Pe(36)}rem`, [d, f] = V(0), [h, g] = V(!0), [m, b] = V(!1), [E, x] = V(!1), p = H(null), _ = H(null), w = gn(), v = (N) => {
    g(N.isBeginning), b(N.isEnd);
  };
  G(() => (w && a !== Je.CROSSFADE ? f(0) : f(Mp(a)), p.current && (_.current = new Se(p.current, {
    a11y: { enabled: !0 },
    modules: [bp, Tp, yp],
    watchSlidesProgress: !0,
    watchOverflow: !0,
    noSwipingClass: "vjs-control-bar",
    navigation: !1,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
      renderFraction(N, R) {
        return document.documentElement.getAttribute("dir") === "rtl" ? `<span class="${R}"></span>/<span class="${N}"></span>` : `<span class="${N}"></span>/<span class="${R}"></span>`;
      }
    },
    on: {
      init: (N) => {
        v(N), Oi(N), x(N.isLocked);
      },
      slideChange: (N) => {
        v(N), Oi(N);
      },
      activeIndexChange: (N) => {
        n(N.snapIndex, N.previousIndex, e);
      },
      resize: (N) => {
        v(N), Oi(N), x(N.isLocked);
      },
      lock: () => x(!0),
      unlock: () => x(!1)
    },
    effect: Cp(a),
    fadeEffect: {
      crossFade: a === Je.CROSSFADE
    },
    speed: d,
    observer: !0,
    observeParents: !0,
    breakpoints: Ap(t, a, r)
  })), () => {
    _.current && (_.current.destroy(), _.current = null);
  }), [w]);
  const y = () => {
    _.current && _.current.slideNext(d);
  }, S = () => {
    _.current && _.current.slidePrev(d);
  };
  return l ? /* @__PURE__ */ M("div", { className: "swiper", ref: p, slot: o, children: [
    /* @__PURE__ */ u("div", { className: "swiper-wrapper", children: l.map((N, R) => /* @__PURE__ */ u("div", { className: "swiper-slide", children: N }, `swiper-slide-${R}`)) }),
    /* @__PURE__ */ u(
      "div",
      {
        className: O(
          Ge["swiper__controls-wrapper"],
          E && Ge["swiper__controls-wrapper--navigation-hidden"]
        ),
        children: /* @__PURE__ */ M("div", { className: Ge.swiper__controls, children: [
          /* @__PURE__ */ u(
            "button",
            {
              className: O(Ge["swiper__button-prev-custom"], h && Ge["swiper__button--disabled"]),
              onClick: S,
              disabled: h,
              "aria-disabled": h,
              "aria-label": s,
              children: /* @__PURE__ */ u("span", { className: Ge["swiper__button-icon-custom"], children: /* @__PURE__ */ u(F, { icon: "chevron-left", height: c, decorative: !0 }) })
            }
          ),
          /* @__PURE__ */ u("div", { className: "swiper-pagination" }),
          /* @__PURE__ */ u(
            "button",
            {
              className: O(Ge["swiper__button-next-custom"], m && Ge["swiper__button--disabled"]),
              onClick: y,
              disabled: m,
              "aria-disabled": m,
              "aria-label": i,
              children: /* @__PURE__ */ u("span", { className: Ge["swiper__button-icon-custom"], children: /* @__PURE__ */ u(F, { icon: "chevron-right", height: c, decorative: !0 }) })
            }
          )
        ] })
      }
    )
  ] }) : null;
};
var Nt = /* @__PURE__ */ ((e) => (e.DEFAULT = "", e.LEFT = "left", e.CENTER = "center", e.RIGHT = "right", e))(Nt || {});
const he = {
  "social-media": "social-media",
  "social-media__overline": "social-media__overline",
  "social-media__links-list": "social-media__links-list",
  "social-media__icon": "social-media__icon",
  "social-media__link-wrapper": "social-media__link-wrapper",
  "social-media__link": "social-media__link",
  "social-media__copy-feedback": "social-media__copy-feedback",
  "social-media__copy-feedback--show": "social-media__copy-feedback--show",
  "social-media__copy-feedback-content": "social-media__copy-feedback-content",
  "social-media__copy-feedback-arrow": "social-media__copy-feedback-arrow",
  "social-media--align-left": "social-media--align-left",
  "social-media--align-center": "social-media--align-center",
  "social-media--align-right": "social-media--align-right"
}, Ip = 24, qh = ({
  overline: e,
  align: t = Nt.DEFAULT,
  disableFacebook: i = !1,
  disableTwitter: s = !1,
  disableLinkedin: n = !1,
  mailToSubject: r,
  url: a,
  facebookLabel: o,
  twitterLabel: l,
  linkedinLabel: c,
  copylinkLabel: d,
  copySuccessLabel: f,
  onClick: h
}) => {
  const [g, m] = V(!1), b = [
    {
      "data-social": "email",
      icon: "mobile",
      href: `mailto:?subject=${r}&body=${a}`,
      type: "link",
      shouldRender: !1
    },
    {
      "data-social": "facebook",
      icon: "facebook",
      href: `https://www.facebook.com/sharer/sharer.php?u=${a}`,
      type: "link",
      shouldRender: !i,
      ariaLabel: o
    },
    {
      "data-social": "twitter",
      icon: "twitter",
      href: `http://twitter.com/intent/tweet?url=${a}`,
      type: "link",
      shouldRender: !s,
      ariaLabel: l
    },
    {
      "data-social": "linkedin",
      icon: "linkedin",
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${a}`,
      type: "link",
      shouldRender: !n,
      ariaLabel: c
    },
    {
      "data-social": "xing",
      icon: "mobile",
      href: `https://www.xing.com/spi/shares/new?url=${a}`,
      type: "link",
      shouldRender: !1
    },
    {
      "data-social": "copy",
      icon: "copy-link",
      href: "#",
      type: "button",
      shouldRender: !0,
      ariaLabel: d
    }
  ], E = async (p) => {
    const _ = p.currentTarget.getAttribute("data-social");
    _ === "copy" && (p.preventDefault(), await navigator.clipboard.writeText(a), m(!0), setTimeout(() => m(!1), 2200)), _ && h && h(p, _);
  }, x = O(
    he["social-media"],
    t === Nt.LEFT && he["social-media--align-left"],
    t === Nt.CENTER && he["social-media--align-center"],
    t === Nt.RIGHT && he["social-media--align-right"]
  );
  return /* @__PURE__ */ M("div", { className: x, children: [
    e && /* @__PURE__ */ u("p", { className: he["social-media__overline"], children: e }),
    /* @__PURE__ */ u("ul", { className: he["social-media__links-list"], children: b.map((p, _) => {
      const { shouldRender: w, icon: v, ariaLabel: y, type: S, ...N } = p;
      if (!w)
        return null;
      const R = p["data-social"], A = R === "copy";
      return /* @__PURE__ */ M("li", { className: he["social-media__link-wrapper"], children: [
        /* @__PURE__ */ u("span", { className: he["social-media__icon"], children: /* @__PURE__ */ u(F, { icon: v, height: `${Pe(Ip)}rem`, decorative: !0 }) }),
        S === "button" ? /* @__PURE__ */ u(
          "button",
          {
            className: he["social-media__link"],
            onClick: E,
            "aria-label": y,
            "data-social": R,
            type: "button"
          }
        ) : /* @__PURE__ */ u(
          "a",
          {
            className: he["social-media__link"],
            target: "_blank",
            rel: "noreferrer",
            onClick: E,
            "aria-label": y,
            ...N
          }
        ),
        A && /* @__PURE__ */ M(
          "div",
          {
            className: O(
              he["social-media__copy-feedback"],
              g && he["social-media__copy-feedback--show"]
            ),
            role: "alert",
            "aria-live": "assertive",
            "aria-atomic": "true",
            children: [
              /* @__PURE__ */ u("span", { className: he["social-media__copy-feedback-content"], children: f }),
              /* @__PURE__ */ u("div", { className: he["social-media__copy-feedback-arrow"] })
            ]
          }
        )
      ] }, _);
    }) })
  ] });
}, Tt = {
  "stage-home-teaser": "stage-home-teaser",
  "stage-home-teaser__title": "stage-home-teaser__title",
  "stage-home-teaser__description": "stage-home-teaser__description",
  "stage-home-teaser__button-wrapper": "stage-home-teaser__button-wrapper"
}, jh = ({
  teaserTitle: e,
  teaserDescription: t,
  headingLevel: i = 2,
  children: s
}) => {
  const n = `h${i}`;
  return /* @__PURE__ */ M("div", { className: Tt["stage-home-teaser"], children: [
    /* @__PURE__ */ M("div", { className: Tt["stage-home-teaser__top-wrapper"], children: [
      /* @__PURE__ */ u(n, { className: Tt["stage-home-teaser__title"], children: e }),
      /* @__PURE__ */ u("p", { className: Tt["stage-home-teaser__description"], children: t })
    ] }),
    /* @__PURE__ */ u("div", { className: Tt["stage-home-teaser__button-wrapper"], children: s })
  ] });
}, Rp = "image", Op = {
  "scale-on-scroll": "scale-on-scroll",
  image: Rp
}, Lp = 1864, Pp = (e) => (Math.min(window.innerWidth, Lp) - e) / e, Dp = (e) => {
  const t = e.getAttribute("data-ratio");
  if (!t) return null;
  const [i, s] = t.split(":").map(parseFloat);
  return i && s ? [i, s] : null;
}, $p = ({ children: e }) => {
  const t = H(null), [i, s] = V(1), [n, r] = V("auto"), a = H(null);
  return G(() => {
    const o = t.current;
    if (!o)
      return;
    const l = () => {
      const d = o.querySelector(".image");
      if (!d) {
        a.current = null, r("auto");
        return;
      }
      const f = o.getBoundingClientRect().top + window.scrollY, h = o.getBoundingClientRect().width, g = Pp(h), m = o.getBoundingClientRect().width, b = Dp(d), E = b ? Math.floor(m * b[1] / b[0]) : 0;
      a.current = {
        initialSpaceToViewTop: f,
        initialHeight: E,
        widthPercentage: g
      };
      const x = E * (1 + g);
      r(`${x}px`);
    }, c = () => {
      l();
    };
    return window.addEventListener("resize", c), l(), () => {
      window.removeEventListener("resize", c);
    };
  }, []), G(() => {
    const o = t.current;
    if (!o || !a.current) return;
    const l = () => {
      const c = o.getBoundingClientRect().top, d = window.innerHeight;
      if (!(c > d || c < -0.3 * d) && a.current) {
        const { initialSpaceToViewTop: h, widthPercentage: g } = a.current, m = Math.min(h, d), b = d > h, E = b ? 1 : 0.75, p = m * (b ? 0.1 : 0.25), _ = m * (1 - E), w = m - p - _, v = Math.min(
          Math.max((m - c - p) / w, 0),
          1
        ), y = 1 + g * v;
        s(y);
      }
    };
    return window.addEventListener("scroll", l, { passive: !0 }), () => {
      window.removeEventListener("scroll", l);
    };
  }, [t.current, a.current]), /* @__PURE__ */ u(
    "div",
    {
      ref: t,
      className: Op["scale-on-scroll"],
      style: {
        "--scale-factor": i,
        height: n
      },
      children: e
    }
  );
}, zp = "headline", Vp = "image", Bp = {
  "stage-home": "stage-home",
  headline: zp,
  "headline--1": "headline--1",
  "stage-home--heading-visible": "stage-home--heading-visible",
  "stage-home--original-branding": "stage-home--original-branding",
  "scale-on-scroll": "scale-on-scroll",
  "video-player": "video-player",
  image: Vp,
  "stage-home__teasers": "stage-home__teasers",
  "stage-home-teaser": "stage-home-teaser"
}, Uh = ({
  statement: e,
  Image: t,
  slot: i,
  children: s
}) => {
  const [n, r] = V(!1);
  G(() => {
    r(!0);
  }, []);
  const a = O({
    "stage-home": !0,
    "stage-home--original-branding": e === "Doing now what patients need next",
    "stage-home--heading-visible": n
  });
  return /* @__PURE__ */ M("div", { className: a, slot: i, children: [
    /* @__PURE__ */ u(tn, { headline: e, level: "1" }),
    /* @__PURE__ */ u($p, { children: t }),
    /* @__PURE__ */ u("div", { className: Bp["stage-home__teasers"], children: s })
  ] });
}, Hp = "image", Ce = {
  "staging-hero": "staging-hero",
  "staging-hero__background": "staging-hero__background",
  "staging-hero__image": "staging-hero__image",
  image: Hp,
  "staging-hero__wrapper": "staging-hero__wrapper",
  "staging-hero__content": "staging-hero__content",
  "staging-hero__headline": "staging-hero__headline",
  "staging-hero__text": "staging-hero__text",
  "staging-hero__divider": "staging-hero__divider",
  "hero--variant-a": "hero--variant-a",
  "staging-hero__letter": "staging-hero__letter",
  "hero--variant-b": "hero--variant-b"
};
var li = /* @__PURE__ */ ((e) => (e.VARIANT_A = "hero--variant-a", e.VARIANT_B = "hero--variant-b", e))(li || {});
const Wh = ({
  variant: e = li.VARIANT_A,
  headline: t,
  content: i,
  Image: s,
  slot: n
}) => {
  const r = e === li.VARIANT_B, a = H(null), o = [Ce["staging-hero"], Ce[e]].filter(Boolean).join(" ");
  G(() => {
    var d;
    const c = (d = a.current) == null ? void 0 : d.closest("roche-grid");
    return c && (c.setAttribute("no-padding", "true"), c.setAttribute("data-staging-hero", e)), () => {
      c && (c.removeAttribute("no-padding"), c.removeAttribute("data-staging-hero"));
    };
  }, [e]);
  const l = r && s;
  return /* @__PURE__ */ M("section", { ref: a, className: o, "data-variant": e, slot: n, children: [
    /* @__PURE__ */ M("div", { className: Ce["staging-hero__wrapper"], children: [
      /* @__PURE__ */ u("div", { className: Ce["staging-hero__background"] }),
      /* @__PURE__ */ M("div", { className: Ce["staging-hero__content"], children: [
        /* @__PURE__ */ u("div", { className: Ce["staging-hero__letter"] }),
        t && /* @__PURE__ */ u("h1", { className: Ce["staging-hero__headline"], children: t }),
        i && /* @__PURE__ */ u("p", { className: Ce["staging-hero__text"], children: i })
      ] }),
      /* @__PURE__ */ u("div", { className: Ce["staging-hero__divider"] })
    ] }),
    l && /* @__PURE__ */ u("div", { className: Ce["staging-hero__image"], children: s })
  ] });
}, Mn = 2, Cn = (e, t = "", i = Mn) => {
  const s = ["-", "", "+"][Math.sign(e) + 1], n = Math.abs(e).toFixed(i);
  return `${s}${t}${n}`;
}, Fp = (e) => `${Cn(e, " ")}`, Gp = (e) => `(${Cn(e)}%)`, se = {
  "stock-price": "stock-price",
  "stock-price__heading": "stock-price__heading",
  "stock-price__price": "stock-price__price",
  "stock-price__value": "stock-price__value",
  "stock-price__currency": "stock-price__currency",
  "stock-price__unavailable": "stock-price__unavailable",
  "stock-price__daily-change": "stock-price__daily-change",
  "stock-price__difference": "stock-price__difference",
  "stock-price__relative-difference": "stock-price__relative-difference",
  "stock-price__price-difference": "stock-price__price-difference",
  "stock-price__icon": "stock-price__icon",
  "stock-price__icon--down": "stock-price__icon--down",
  "stock-price__icon--equal": "stock-price__icon--equal",
  "stock-price__icon--up": "stock-price__icon--up"
}, Yh = ({
  heading: e,
  href: t,
  price: i,
  currency: s,
  change: n,
  relativeChange: r,
  timeIntervalLabel: a,
  unavailableLabel: o
}) => {
  if (!(i !== void 0 && s !== void 0 && n !== void 0 && r !== void 0))
    return /* @__PURE__ */ M("div", { className: se["stock-price"], children: [
      /* @__PURE__ */ u("h3", { className: se["stock-price__heading"], children: e }),
      /* @__PURE__ */ u("span", { className: se["stock-price__unavailable"], children: o })
    ] });
  const c = ["stock-down", "stock-equal", "stock-up"][Math.sign(n) + 1], d = O(se["stock-price__icon"], {
    [se["stock-price__icon--down"]]: c === "stock-down",
    [se["stock-price__icon--equal"]]: c === "stock-equal",
    [se["stock-price__icon--up"]]: c === "stock-up"
  });
  return /* @__PURE__ */ M("a", { className: se["stock-price"], href: t, children: [
    /* @__PURE__ */ u("h3", { className: se["stock-price__heading"], children: e }),
    /* @__PURE__ */ M("div", { className: se["stock-price__price"], children: [
      /* @__PURE__ */ u("span", { className: se["stock-price__value"], children: i.toFixed(Mn) }),
      /* @__PURE__ */ u("span", { className: se["stock-price__currency"], children: s })
    ] }),
    /* @__PURE__ */ M("div", { className: se["stock-price__daily-change"], children: [
      /* @__PURE__ */ u("span", { className: d, "aria-hidden": "true", children: /* @__PURE__ */ u(F, { icon: c, height: "32px" }) }),
      /* @__PURE__ */ M("span", { className: se["stock-price__difference"], children: [
        /* @__PURE__ */ u("span", { className: se["stock-price__price-difference"], children: Fp(n) }),
        /* @__PURE__ */ u("span", { className: se["stock-price__relative-difference"], children: Gp(r) })
      ] }),
      /* @__PURE__ */ u("span", { className: se["stock-price__time-interval"], children: a })
    ] })
  ] });
};
var qe = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.PODCAST = "podcast", e.SERIES = "series", e.SLIDESHOW = "slideshow", e.VIDEO = "video", e))(qe || {}), qp = /* @__PURE__ */ ((e) => (e.VARIANT_A = "story-teaser--variant-a", e.VARIANT_B = "story-teaser--variant-b", e.VARIANT_C = "story-teaser--variant-c", e))(qp || {});
const qi = {
  [qe.DEFAULT]: null,
  [qe.PODCAST]: "podcasts",
  [qe.SERIES]: "series",
  [qe.SLIDESHOW]: "book",
  [qe.VIDEO]: "play"
}, de = {
  "story-staging-hero": "story-staging-hero",
  "story-staging-hero__background": "story-staging-hero__background",
  "story-staging-hero__wrapper": "story-staging-hero__wrapper",
  "story-staging-hero__content": "story-staging-hero__content",
  "story-staging-hero__header": "story-staging-hero__header",
  "story-staging-hero__headline": "story-staging-hero__headline",
  "story-staging-hero__text": "story-staging-hero__text",
  "story-staging-hero__divider": "story-staging-hero__divider",
  "story-staging-hero__story-type-wrapper": "story-staging-hero__story-type-wrapper",
  "story-staging-hero__story-type": "story-staging-hero__story-type",
  "story-staging-hero__tag-wrapper": "story-staging-hero__tag-wrapper",
  "hero--variant-a": "hero--variant-a",
  "story-staging-hero__letter": "story-staging-hero__letter",
  "story-staging-hero__image": "story-staging-hero__image",
  "hero--variant-b": "hero--variant-b",
  "story-staging-hero__icon": "story-staging-hero__icon"
}, Xh = ({
  variant: e,
  storyHeadline: t,
  storyDescription: i,
  storyType: s,
  storyTypeTranslation: n,
  storyTags: r,
  showTags: a,
  Image: o,
  slot: l
}) => {
  const c = e === li.VARIANT_B, d = H(null), f = [de["story-staging-hero"], de[e]].filter(Boolean).join(" "), h = c && a && r && r.length > 0, g = qi[s] ?? "", m = c && s && s !== qe.DEFAULT, b = c && o;
  return /* @__PURE__ */ M("section", { ref: d, className: f, "data-variant": e, slot: l, children: [
    /* @__PURE__ */ M("div", { className: de["story-staging-hero__wrapper"], children: [
      /* @__PURE__ */ u("div", { className: de["story-staging-hero__background"] }),
      /* @__PURE__ */ M("div", { className: de["story-staging-hero__content"], children: [
        /* @__PURE__ */ u("div", { className: de["story-staging-hero__letter"] }),
        m && /* @__PURE__ */ M("div", { className: de["story-staging-hero__story-type-wrapper"], children: [
          /* @__PURE__ */ u("span", { className: de["story-staging-hero__icon"], children: /* @__PURE__ */ u(F, { icon: g, height: "24px" }) }),
          /* @__PURE__ */ u("span", { className: de["story-staging-hero__story-type"], children: n })
        ] }),
        /* @__PURE__ */ M("div", { className: de["story-staging-hero__header"], children: [
          t && /* @__PURE__ */ u("h1", { className: de["story-staging-hero__headline"], children: t }),
          h && /* @__PURE__ */ u("div", { className: de["story-staging-hero__tag-wrapper"], children: r })
        ] }),
        !c && /* @__PURE__ */ u("p", { className: de["story-staging-hero__text"], children: i })
      ] }),
      /* @__PURE__ */ u("div", { className: de["story-staging-hero__divider"] })
    ] }),
    b && /* @__PURE__ */ u("div", { className: de["story-staging-hero__image"], children: o })
  ] });
}, jp = (e) => {
  const [t, i] = V(0);
  return G(() => {
    const s = () => {
      e.current && i(e.current.clientWidth);
    }, n = new ResizeObserver(s);
    return e.current && n.observe(e.current), () => n.disconnect();
  }, [e.current]), { width: t };
}, Up = "date", Wp = {
  date: Up
}, In = ({ displayDate: e, dateTimeValue: t }) => /* @__PURE__ */ u("div", { className: Wp.date, children: /* @__PURE__ */ u("time", { dateTime: t, children: e }) }), Yp = "image", Xp = "button", Ie = {
  "story-teaser": "story-teaser",
  image: Yp,
  "story-teaser__tag": "story-teaser__tag",
  "story-teaser__image-container": "story-teaser__image-container",
  "video-player": "video-player",
  "story-teaser__details": "story-teaser__details",
  "story-teaser__title": "story-teaser__title",
  "story-teaser__description": "story-teaser__description",
  "story-teaser__date": "story-teaser__date",
  "story-teaser--variant-a": "story-teaser--variant-a",
  "story-teaser__description-container": "story-teaser__description-container",
  "story-teaser--variant-b": "story-teaser--variant-b",
  "story-teaser--variant-c": "story-teaser--variant-c",
  button: Xp,
  "story-teaser--unpublished": "story-teaser--unpublished"
}, Xs = (e) => (t) => {
  e.forEach((i) => {
    i && (typeof i == "function" ? i(t) : i.current = t);
  });
}, Zh = Zs(
  ({
    layout: e,
    teaserType: t = qe.DEFAULT,
    teaserTitle: i,
    teaserDescription: s,
    teaserImage: n,
    teaserImageAlt: r,
    teaserUrl: a,
    teaserDate: o,
    dateTimeValue: l,
    teaserTagLabel: c,
    ctaLabel: d,
    unpublished: f,
    slot: h,
    playLabel: g,
    pauseLabel: m,
    onVideoStateChange: b,
    onTeaserLinkClick: E,
    awsServiceBaseUrl: x
  }, p) => {
    const _ = H(null), w = H(), { width: v } = jp(w), [y, S] = V(0), N = () => {
      switch (e) {
        case "story-teaser--variant-a":
          return { ratio: re.NORMAL };
        case "story-teaser--variant-b":
          return { ratio: re.SIXTOFIVE };
        case "story-teaser--variant-c":
          return { ratio: re.ORIGINAL, forceHeight: 480 };
        default:
          return { ratio: re.ORIGINAL };
      }
    }, R = Re(() => {
      const z = Number(n), L = N();
      return z ? /* @__PURE__ */ u(
        ts,
        {
          awsServiceBaseUrl: x,
          service: "aws",
          videoId: n,
          previewAlt: r ?? "",
          playLabel: g ?? "",
          pauseLabel: m ?? "",
          videoLoop: !0,
          onVideoStateChange: (k) => {
            b && b(k);
          }
        }
      ) : n ? /* @__PURE__ */ u(hi, { src: n, alt: r, ...L }) : null;
    }, [e, n]);
    G(() => {
      e === "story-teaser--variant-a" ? S(v ? v / 4 * 3 : 0) : _.current && S(_.current.clientHeight);
    }, [v, e, s]), G(() => {
      const z = (L) => {
        var k;
        L.key === "Escape" && ((k = w.current) == null || k.blur());
      };
      return window.addEventListener("keydown", z), () => {
        window.removeEventListener("keydown", z);
      };
    }, []);
    const A = /* @__PURE__ */ u("div", { className: Ie["story-teaser__image-container"], children: R() }), C = /* @__PURE__ */ M("div", { className: Ie["story-teaser__details"], children: [
      t !== qe.DEFAULT && /* @__PURE__ */ M("div", { className: Ie["story-teaser__tag"], children: [
        qi[t] && /* @__PURE__ */ u(F, { icon: qi[t], height: `${Pe(20)}rem` }),
        /* @__PURE__ */ u("span", { children: c })
      ] }),
      /* @__PURE__ */ M("div", { className: Ie["story-teaser__description-container"], children: [
        /* @__PURE__ */ u("h3", { className: Ie["story-teaser__title"], children: i }),
        /* @__PURE__ */ u("p", { ref: _, className: Ie["story-teaser__description"], children: s })
      ] }),
      o && l && e === "story-teaser--variant-a" && /* @__PURE__ */ u("div", { className: Ie["story-teaser__date"], children: /* @__PURE__ */ u(In, { displayDate: o, dateTimeValue: l }) }),
      e === "story-teaser--variant-c" && d && /* @__PURE__ */ u(Lt, { text: d, href: a, onClick: E })
    ] }), P = O(Ie["story-teaser"], Ie[e], {
      [Ie["story-teaser--unpublished"]]: f
    }), D = /* @__PURE__ */ u(
      "a",
      {
        ref: Xs([w, p]),
        className: P,
        "aria-label": i,
        href: a,
        onClick: E,
        style: { "--teaser-hover-offset": `${y}px` },
        slot: h,
        children: /* @__PURE__ */ M("article", { children: [
          A,
          C
        ] })
      }
    ), B = /* @__PURE__ */ M("article", { ref: Xs([w, p]), className: P, slot: h, children: [
      A,
      C
    ] });
    return e === "story-teaser--variant-c" ? B : D;
  }
), Zp = "subline", Kp = "subline__avatar", Qp = "subline__author", Jp = "subline__date", Ye = {
  subline: Zp,
  "subline__attribution-phrase": "subline__attribution-phrase",
  "subline__author-container": "subline__author-container",
  subline__avatar: Kp,
  "subline__author-description-container": "subline__author-description-container",
  subline__author: Qp,
  "subline__author-description": "subline__author-description",
  subline__date: Jp
}, Kh = ({
  author: e,
  authorDescription: t,
  attributionPhrase: i,
  displayDate: s,
  dateTimeValue: n,
  children: r
}) => /* @__PURE__ */ M("div", { className: Ye.subline, children: [
  i && /* @__PURE__ */ u("h3", { className: Ye["subline__attribution-phrase"], children: i }),
  /* @__PURE__ */ M("div", { className: Ye["subline__author-container"], children: [
    r && /* @__PURE__ */ u("div", { className: Ye.subline__avatar, children: r }),
    /* @__PURE__ */ M("div", { className: Ye["subline__author-description-container"], children: [
      /* @__PURE__ */ u("p", { className: Ye.subline__author, children: e }),
      /* @__PURE__ */ u("p", { className: Ye["subline__author-description"], children: t }),
      s && n && /* @__PURE__ */ u("div", { className: Ye.subline__date, children: /* @__PURE__ */ u(In, { dateTimeValue: n, displayDate: s }) })
    ] })
  ] })
] }), eh = "tag", th = {
  tag: eh
}, Qh = ({ tag: e, href: t, onClick: i, ariaLabel: s }) => /* @__PURE__ */ u("a", { href: t, className: th.tag, onClick: i, "aria-label": s, children: e }), ih = "teaser", sh = "image", nh = "teaser__heading", rh = "teaser__overline", ah = "teaser__title", oh = "teaser__icon", lh = "teaser__description", ch = "teaser__border", dh = "teaser__image", uh = "teaser__video", Q = {
  teaser: ih,
  "teaser__image-wrapper": "teaser__image-wrapper",
  image: sh,
  "teaser__link-wrapper": "teaser__link-wrapper",
  "teaser__image-border": "teaser__image-border",
  teaser__heading: nh,
  teaser__overline: rh,
  "teaser__overline-element": "teaser__overline-element",
  teaser__title: ah,
  "teaser__title--small": "teaser__title--small",
  teaser__icon: oh,
  teaser__description: lh,
  "teaser__author-description": "teaser__author-description",
  teaser__border: ch,
  "teaser__buttons-wrapper": "teaser__buttons-wrapper",
  "teaser__buttons-wrapper--align-left": "teaser__buttons-wrapper--align-left",
  "teaser--card": "teaser--card",
  "teaser--unpublished": "teaser--unpublished",
  "teaser--in-draft": "teaser--in-draft",
  teaser__image: dh,
  "teaser__image--loaded": "teaser__image--loaded",
  "teaser__image--reduced-scale": "teaser__image--reduced-scale",
  teaser__video: uh
};
var j = /* @__PURE__ */ ((e) => (e.VARIANT_A = "teaser-variant-a", e.VARIANT_B = "teaser-variant-b", e.VARIANT_C = "teaser-variant-c", e.VARIANT_D = "teaser-variant-d", e.VARIANT_E = "teaser-variant-e", e.VARIANT_E_WITHOUT_DESCRIPTION = "teaser-variant-e-without-description", e.VARIANT_A_WITHOUT_IMAGE = "teaser-variant-a-without-image", e.VARIANT_B_WITHOUT_IMAGE = "teaser-variant-b-without-image", e.VARIANT_C_WITHOUT_IMAGE = "teaser-variant-c-without-image", e.VARIANT_D_WITHOUT_IMAGE = "teaser-variant-d-without-image", e.VARIANT_C_WITHOUT_IMAGE_WITH_DATE = "teaser-variant-c-without-image-with-date", e.CARD_A = "teaser--card-a", e.CARD_B = "teaser--card-b", e.CARD_C = "teaser--card-c", e.PUBMED = "teaser--pubmed", e))(j || {}), ei = /* @__PURE__ */ ((e) => (e.DEFAULT = "arrow-right", e.DOWNLOAD = "download", e.EXTERNAL = "external-link", e))(ei || {});
const fh = [
  j.VARIANT_A,
  j.VARIANT_A_WITHOUT_IMAGE,
  j.CARD_A,
  j.VARIANT_B,
  j.VARIANT_B_WITHOUT_IMAGE,
  j.CARD_B,
  j.VARIANT_E,
  j.PUBMED
], ph = [
  j.VARIANT_A,
  j.VARIANT_A_WITHOUT_IMAGE,
  j.CARD_A,
  j.VARIANT_C,
  j.VARIANT_C_WITHOUT_IMAGE,
  j.VARIANT_C_WITHOUT_IMAGE_WITH_DATE,
  j.CARD_C,
  j.PUBMED
], hh = [
  j.VARIANT_A,
  j.VARIANT_B,
  j.VARIANT_C,
  j.VARIANT_D,
  j.VARIANT_E,
  j.VARIANT_E_WITHOUT_DESCRIPTION
], mh = [j.CARD_A, j.CARD_B, j.CARD_C], Jh = Zs(
  ({
    teaserImage: e,
    teaserImageAlt: t,
    teaserTitle: i,
    teaserDescription: s,
    teaserOverline: n,
    teaserOverlineElement: r,
    teaserUrl: a,
    target: o = ui.SELF,
    isExternalLink: l,
    isDownloadLink: c,
    downloadTranslation: d,
    layout: f,
    secondaryButton: h,
    primaryButtonText: g,
    playLabel: m,
    pauseLabel: b,
    onTeaserClick: E,
    onVideoStateChange: x,
    isSearchResult: p,
    unpublished: _,
    isTeaserInDraft: w,
    teaserAuthorDescription: v,
    slot: y,
    loaded: S,
    forceAlignLeft: N,
    awsServiceBaseUrl: R
  }, A) => {
    const C = n && n !== "" || r, P = !Number(e), D = l ? ei.EXTERNAL : c ? ei.DOWNLOAD : ei.DEFAULT, B = Re(() => {
      const ie = f === j.VARIANT_E || f === j.VARIANT_E_WITHOUT_DESCRIPTION, $e = ie ? re.VERTICAL : re.HD, le = ph.includes(f), ze = fh.includes(f), ot = hh.includes(f), Ve = mh.includes(f);
      return {
        isVerticalLayout: ie,
        imageRatio: $e,
        hasOverline: le,
        hasDescription: ze,
        hasImage: ot,
        isCard: Ve
      };
    }, [f]), { hasImage: z, isVerticalLayout: L, imageRatio: k, hasDescription: I, hasOverline: $, isCard: q } = B(), te = i && /* @__PURE__ */ M(
      "span",
      {
        className: O(Q.teaser__title, (p || c) && Q["teaser__title--small"]),
        children: [
          i,
          !q && /* @__PURE__ */ u("span", { className: Q.teaser__icon, children: /* @__PURE__ */ u(F, { icon: D, height: `${Pe(24)}rem` }) })
        ]
      }
    ), K = /* @__PURE__ */ M(Qe, { children: [
      z && e && /* @__PURE__ */ M("div", { className: Q["teaser__image-wrapper"], children: [
        P ? /* @__PURE__ */ u(hi, { src: e, alt: t ?? "", ratio: k, slot: y }) : /* @__PURE__ */ u(
          "div",
          {
            className: O(
              Q.teaser__video,
              L && Q["teaser__image--reduced-scale"],
              S && Q["teaser__image--loaded"]
            ),
            children: /* @__PURE__ */ u(
              ts,
              {
                awsServiceBaseUrl: R,
                service: "aws",
                videoLoop: !0,
                videoId: e,
                previewAlt: t ?? "",
                playLabel: m ?? "",
                pauseLabel: b ?? "",
                onVideoStateChange: (ie) => {
                  x && x(ie);
                }
              }
            )
          }
        ),
        /* @__PURE__ */ u("div", { className: Q["teaser__image-border"] })
      ] }),
      /* @__PURE__ */ M("h3", { className: Q.teaser__heading, children: [
        te,
        $ && C && /* @__PURE__ */ M("span", { className: Q.teaser__overline, children: [
          n,
          r && /* @__PURE__ */ u("span", { className: Q["teaser__overline-element"], children: r })
        ] })
      ] }),
      v && /* @__PURE__ */ u("p", { className: "teaser__author-description", children: v }),
      I && s && /* @__PURE__ */ u("p", { className: Q.teaser__description, children: s }),
      !z && !q && /* @__PURE__ */ u("div", { className: Q.teaser__border }),
      q && /* @__PURE__ */ M(
        "div",
        {
          className: O(
            Q["teaser__buttons-wrapper"],
            N && Q["teaser__buttons-wrapper--align-left"]
          ),
          children: [
            a && g && /* @__PURE__ */ u(
              Lt,
              {
                href: a,
                appearance: Me.SECONDARY,
                text: g,
                onClick: E
              }
            ),
            h
          ]
        }
      )
    ] });
    return /* @__PURE__ */ u(
      "div",
      {
        ref: A,
        slot: y,
        className: O(
          Q.teaser,
          q && Q["teaser--card"],
          _ && Q["teaser--unpublished"],
          w && Q["teaser--in-draft"]
        ),
        children: q ? K : /* @__PURE__ */ u(
          "a",
          {
            target: o,
            href: a,
            "aria-label": c ? `${d} ${i}` : i,
            onClick: E,
            className: Q["teaser__link-wrapper"],
            children: K
          }
        )
      }
    );
  }
);
export {
  ne as Breakpoints,
  Pi as ContainerColor,
  ui as LinkTarget,
  wh as RocheUIAccordion,
  bh as RocheUIAddToCalendar,
  yh as RocheUIAnimatedWords,
  Eh as RocheUIAvatar,
  xh as RocheUIBackToBranch,
  Va as RocheUIBreadcrumbs,
  Lt as RocheUIButton,
  Me as RocheUIButtonAppearance,
  ci as RocheUIButtonTarget,
  di as RocheUIButtonType,
  Sh as RocheUIContactPerson,
  Wt as RocheUIContactPersonLayout,
  Ha as RocheUIContainer,
  Th as RocheUIDropdown,
  Nh as RocheUIFooter,
  kh as RocheUIFormWrapper,
  Et as RocheUIGrid,
  Ah as RocheUIHeader,
  tn as RocheUIHeadline,
  Mh as RocheUIHeroTeaser,
  li as RocheUIHeroVariant,
  Ch as RocheUIHighlightBox,
  Ih as RocheUIHorizontalCenter,
  F as RocheUIIcon,
  hi as RocheUIImage,
  Jl as RocheUIImageLoading,
  re as RocheUIImageRatio,
  Rh as RocheUIInput,
  Xt as RocheUIInputType,
  mn as RocheUILanguageSwitch,
  pi as RocheUILanguageSwitchLayoutType,
  Oh as RocheUILeadText,
  Cc as RocheUILoadingSpinner,
  Lh as RocheUIMagnet,
  Ph as RocheUIMarketo,
  zl as RocheUIMobileNavigation,
  Ia as RocheUIOverline,
  Dh as RocheUIPodcast,
  $h as RocheUIPublishedDate,
  zh as RocheUIQuote,
  Vi as RocheUIQuoteLayout,
  zi as RocheUIQuoteSize,
  Vh as RocheUIRichText,
  Bh as RocheUISearch,
  Zt as RocheUISearchTrigger,
  Hh as RocheUISelect,
  Fh as RocheUISideBySide,
  Kt as RocheUISideBySideHorizontalAlignment,
  Qt as RocheUISideBySideVerticalAlignment,
  Je as RocheUISlideAnimation,
  Gh as RocheUISlider,
  qh as RocheUISocialMedia,
  Nt as RocheUISocialMediaAlignment,
  Uh as RocheUIStageHome,
  jh as RocheUIStageHomeTeaser,
  Wh as RocheUIStagingHero,
  Yh as RocheUIStockPrice,
  Xh as RocheUIStoryStagingHero,
  Zh as RocheUIStoryTeaser,
  qp as RocheUIStoryTeaserLayout,
  qe as RocheUIStoryType,
  Kh as RocheUISubline,
  zs as RocheUITabs,
  Qh as RocheUITag,
  Jh as RocheUITeaser,
  j as RocheUITeaserLayout,
  Mt as RocheUITextLink,
  Ra as RocheUITextLinkIconSize,
  ht as RocheUITextLinkType,
  ts as RocheUIVideoPlayer
};
